export default {
  actions: {
    creating: 'Creando {{model}}...',
    creating_error: 'Error al crear {{model_one}}',
    created_successfully: '{{model}} creado exitosamente',
    updating: 'Actualizando {{model}}...',
    updating_error: 'Error al actualizar {{model_one}}',
    updated_successfully: '{{model}} actualizado exitosamente',
    deleting: 'Eliminando {{model}}...',
    deleting_error: 'Error al eliminar {{model_one}}',
    deleted_successfully: '{{model}} eliminado exitosamente',
    converting: 'Convirtiendo {{model_one}} en {{model_two}}...',
    converting_error: 'Error al convertir {{model_one}} en {{model_two}}',
    converted_successfully: '{{model_one}} convertido en {{model_two}} exitosamente',
    exporting: 'Exportando {{model}}...',
    exporting_error: 'Error al exportar {{model}}',
    exported_successfully: '{{model}} exportados exitosamente'
  },
  checkbox_jumbotron: {
    model: '{{model}}',
    number: '{{number}}',
    select_advanced: 'Seleccione una opción',
    select_all: 'Seleccionar los {{number}} {{model}}.'
  },
  bulk_actions: {
    select_indicator_one: '<1>{{selected}}</1> {{model}} de <1>{{available}}</1>',
    select_indicator_other: '<1>{{selected}}</1> {{model}} de <1>{{available}}</1>'
  },
  datetime: {
    abbr_month_names: ['', 'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
    distance_in_words: {
      x_periods: {
        one: '1 periodo',
        other: '{{count}} periodos'
      }
    },
    format: {
      dashes: 'YYYY-MM-DD',
      date_box_server: 'DD MMM HH:mm',
      date_issues: 'DD MMM',
      date_discounts: 'DD MMM YYYY',
      date_notifications: 'D MMM YYYY',
      date_olt_card_created: 'DD MMM YYYY',
      date_olt_card_updated: 'DD MMM YYYY HH:mm',
      dateTime: 'DD MMMM YYYY',
      dateTimeLong: 'DD/MM/YYYY hh:mm:ss',
      dateTimeShort: 'DD MMM YYYY HH:mm',
      short: 'DD MMM HH:mm',
      //Iguales
      slash: 'DD/MM/YYYY HH:mm:ss',
      slashWithoutSeconds: 'DD/MM/YYYY HH:mm',
      slashWithoutTime: 'DD/MM/YYYY',
      time: 'HH:mm:ss',
      weekDayName: 'dddd DD MMMM YYYY',
      yearMonth: 'YYYY/MM'
    },
    month_name: [
      '',
      'Enero',
      'Febrero',
      'Marzo',
      'Abril',
      'Mayo',
      'Junio',
      'Julio',
      'Agosto',
      'Septiembre',
      'Octubre',
      'Noviembre',
      'Diciembre'
    ],
    second: {
      abr: 'Seg'
    }
  },
  dual_list: {
    empty_list: 'Lista Vacía',
    filtering: 'Filtrado',
    from: 'de',
    show_all: 'Mostrar Todo',
    showing_all: 'Mostrando Todo'
  },
  metrics: {
    client: {
      created: 'Creados',
      destroyed: 'Eliminados'
    },
    contract: {
      created: 'Creados',
      destroyed: 'Eliminados',
      offline: 'Desconectados',
      online: 'Conectados'
    },
    installation_order: {
      approved: 'Aprobadas',
      created: 'Creadas',
      rejected: 'Rechazadas'
    },
    invoicing: {
      issued: {
        issued: 'Emitidas',
        paid: 'Pagado'
      },
      payment: {
        count: 'Cantidad'
      }
    },
    help_desk: {
      issues: {
        closed: 'Cerrados',
        created_current_month: 'Creados',
        finalized_assigned: 'Finalizados asignados',
        finalized_unassigned: 'Finalizados sin asignar',
        high: 'Alta',
        low: 'Baja',
        medium: 'Media',
        pending: 'Pendientes',
        pending_assigned: 'Pendientes asignados',
        pending_unassigned: 'Pendientes sin asignar',
        still_open: 'Abiertos'
      }
    }
  },
  modal: {
    close: 'Cerrar',
    create: 'Crear nuevo {{model}}'
  },
  timeline: {
    version: {
      by: 'Por',
      create: 'Esta operación fue Creada',
      destroy: 'Esta operación fue Eliminada',
      update: 'Esta operación fue Actualizada'
    }
  },
  filter: {
    badge_content: {
      filter_configuration: 'Configuración de filtros',
      filter_searched: 'Tus parámetros de búsqueda son:',
      hint: ' Renombra tu búsqueda y guárdala',
      text_searched_title: 'El texto que buscó fue:',
      validation_message: 'Escribe al menos 3 caracteres'
    }
  },
  views: {
    acs_server: {
      create_new_acs_server: 'Crear nuevo Servidor ACS'
    },
    access_server: {
      pools: 'Pools',
      pools_description: 'Gestiona los pools asociados a las interfaces de Access server',
      network_ip_services: 'Servicios de red IP',
      network_ip_services_description: 'Gestiona los servicios de red IP asociados a las interfaces de Access Server',
      pool: {
        create_new_pool: 'Crear nuevo Pool',
        captive_portal: 'Portal cautivo',
        ip_from: 'IP desde',
        ip_to: 'IP hasta',
        name_help_hint:
          'Debe ser tal cual está escrito en el NAS (respetando mayúsculas y minúsculas) ya que va a ser utilizado por el RADIUS'
      }
    },
    radius_service: {
      add_nas: 'Agregar NAS',
      nas_selector: 'Seleccionar NAS',
      cloud_interface_id: 'Interfaz de conectividad RADIUS',
      ip: 'IP del NAS',
      nas_change_impact_warning:
        'Cualquier cambio en un NAS requiere el reinicio del servicio RADIUS. Las sesiones activas se interrumpirán si lo hace.',
      nases_section_title: 'NAS',
      radius_secret: 'Secreto RADIUS',
      require_message_authenticator: 'Message-Authenticator',
      require_message_authenticator_tooltip:
        ' El atributo Message-Authenticator es una función de seguridad RADIUS fundamental que actúa como una firma digital. Verifica la integridad del paquete y autentica al remitente, protegiendo contra la manipulación, la suplantación de identidad y la vulnerabilidad crítica Blast-RADIUS. Esto debe de configurarse en el NAS/BRASS para que lo envie.',
      auto_accept: 'Auto-Accept',
      auto_accept_tooltip:
        'Ante cualquier petición de un cliente que no exista en el sistema, se le asignará una IP del pool cautivo configurado para este NAS. Esto evita ciclos de rechazo continuos y permite redirigir al cliente a un portal de autogestión.'
    },
    authorized_not_linked_onts: {
      authorized_onts: 'ONUs autorizadas',
      breadcrumb: {
        title: 'autorizadas sin contrato'
      },
      error_querying_olt: 'Error al consultar OLT',
      initial: 'Inicial',
      link_ont_form: {
        contract_input_placeholder: 'Puede buscar por nombre de cliente, ip o servidor'
      },
      linked_olts: 'OLTs vinculadas',
      linked_onts: 'ONUs autorizadas con contrato',
      match: 'Match',
      must_complete_contract_configuration: 'Debe completar la configuración del contrato',
      must_select_a_contract: 'Debe seleccionar un contrato',
      no_records: 'No hay ONUs autorizadas no vinculadas para mostrar',
      no_records_linked_olts: 'No hay OLTs vinculadas para mostrar',
      not_linked_onts: 'ONUs autorizadas sin contrato',
      not_authorized_onts: 'ONUs no autorizadas',
      offline: 'Desconectado',
      olt_alerts: 'Alertas OLT',
      olt_interfaces: 'Interfaces OLT',
      olts_queried: 'OLTs consultadas',
      online: 'Conectado',
      querying_olt: 'Consultando OLT',
      querying_olts: 'Consultando OLTs',
      retry_olts_with_errors: 'Reintentar OLTs con errores',
      successfull_olt_query: 'Consulta de OLT exitosa',
      utilization: 'Usabilidad',
      utilization_tooltip_text: 'Porcentaje de ONUs vinculadas sobre el total de ONUs'
    },
    audit: {
      no_audits: 'No hay auditorias para mostrar',
      changes_done: 'Cambios Realizados',
      internal_system_changes: 'Cambios internos del sistema',
      searcher: {
        basic_placeholder: 'Puedes buscar por: Objeto'
      }
    },
    automigrator: {
      attributes: {
        invoicing: {
          client: {
            kind_invoice: {
              argentina_a: 'Argentina (A)',
              argentina_b: 'Argentina (B)',
              argentina_c: 'Argentina (C)',
              colombia: 'Factura de Venta',
              credit_note: 'Nota de Crédito',
              ecuador: 'Factura de Venta',
              espana: 'España',
              invoice: 'Factura',
              mexico: 'Factura de venta',
              peru_final_consumer_invoice: 'Boleta de venta',
              peru_invoice: 'Factura de venta',
              sales_invoice: 'Factura de venta',
              sales_receipt: 'Boleta de venta',
              voucher: 'Comprobante'
            }
          }
        }
      },
      client: {
        base: 'Cliente',
        custom_id: 'ID cliente personalizable',
        sequential_id: 'ID cliente (#)'
      },
      collector: {
        base: 'Recaudador'
      },
      contract: {
        olt_id: 'OLT',
        coverage_id: 'Nodo Wireless',
        base: 'Contrato',
        invoicing_contract: {
          plan: 'Plan facturación del contrato'
        },
        identifiers: {
          sequential_id: 'ID Secuencial (#)'
        }
      },
      employee: {
        user: {
          role_ids: 'Roles'
        }
      },
      hint: 'Se aceptan archivos {{files}}',
      invoice: {
        base: 'Factura'
      },
      invoicing: {
        client: {
          invoicing_firm_id: 'Razón social',
          tax_id: 'Impuesto'
        }
      },
      info: 'Puede cargar cualquier archivo .csv, .xls, .xlsx, .xml, .txt con cualquier conjunto de columnas siempre y cuando tenga 1 registro por fila. El siguiente paso le permitirá configurar y hacer coincidir las columnas de su hoja de cálculo con los puntos de datos correspondientes. Podrá borrar o eliminar todos los datos corruptos antes de finalizar su informe.',
      labels: {
        ['client.gps_point']: 'Punto GPS (Cliente)',
        ['contract.identifiers']: 'Identificadores del contrato',
        ['contract.gps_point']: 'Punto GPS (Contrato)',
        invoicing: {
          client: 'Facturación del cliente',
          contract: 'Facturación del contrato',
          plan: 'Facturación del plan'
        },
        ['nap.gps_point']: 'Punto GPS',
        required: 'Obligatorio'
      },
      nap: {
        inventory_article_id: 'Artículo',
        olt_id: 'OLT'
      },
      payment: {
        base: 'Pago',
        payment_amount: 'Monto del pago',
        collector_email: 'Email del recaudador',
        transaction_kind_id: 'Forma de pago'
      },
      plan: {
        name: 'Nombre del plan'
      },
      ppp_profile: {
        plan_id: 'Plan'
      },
      transaction_kind: {
        base: 'Forma de pago'
      },
      types: {
        clients: 'Clientes | Crear',
        clients_update: 'Clientes | Actualizar',
        contracts: 'Contratos',
        employees: 'Empleados',
        servers: 'Servidores y OLTs',
        smart_olt_olt: 'SmartOLT (OLTs)',
        smart_olt_ont: 'SmartOLT (ONUs)',
        onts_masive_link: 'Vinculación masiva de onus',
        contracts_onu: 'SmartOLT (ONUs)',
        ppp_profiles: 'PPP Profiles',
        naps: 'Naps'
      },
      select_file: 'Seleccionar archivo',
      title: 'Importar de archivo CSV/Excel',
      upload_file: 'Subir archivo'
    },
    changelog: {
      add_item: 'Agregar Item',
      changelog_updated: 'Historial de Mejores Actualizado',
      changelog_created: 'Historial de Mejoras Creado',
      changelog_destroyed: 'Historial de Mejoras Eliminado'
    },
    contracts: {
      contract_data: 'Datos de Contratos',
      billing_data: 'Datos de Facturación'
    },
    bandwidths: {
      by_period: {
        one_day: 'Consumo del último día',
        one_hour: 'Consumo de la última hora',
        one_month: 'Consumo del último mes',
        one_week: 'Consumo de la última semana',
        one_year: 'Consumo del último año',
        six_months: 'Consumo de los ultimos 6 meses',
        three_months: 'Consumo de los ultimos 3 meses'
      },
      summary: 'Resumen de consumo',
      dashboard: 'Dashboard de consumo'
    },
    consumption_dashboard: {
      consumption: 'Consumo',
      patterns: 'Patrones',
      no_session_selected: 'Sin sesión seleccionada',
      chart_titles: {
        daily_consumption: 'Consumo diario',
        session_curve: 'Curva acumulada de tráfico',
        ip_history: 'Historial de IPs asignadas',
        hourly: 'Consumo por hora del día',
        daily: 'Consumo por día de la semana',
        heatmap: 'Mapa de calor: hora × día',
        heatmap_description: 'Distribución del tráfico según hora y día',
        range_badge_one: '{{from}} → {{to}} · {{count}} día',
        range_badge_other: '{{from}} → {{to}} · {{count}} días',
        total: 'Total: {{total}}',
        filter_tooltip: 'Hacé clic para seleccionar un rango',
        clear_filter: 'Restablecer',
        reset_heatmap_scale: 'Restablecer escala'
      },
      chart_labels: {
        total_traffic: 'Tráfico total',
        cumulative_bytes: 'Tráfico acumulado',
        timestamp_utc: 'hora local',
        bytes: 'bytes',
        cumulative: 'bytes acum',
        bucket_day: 'Día',
        hour_of_day: 'Hora del día',
        day_of_week: 'Día de la semana'
      },
      days: {
        monday: 'Lunes',
        tuesday: 'Martes',
        wednesday: 'Miércoles',
        thursday: 'Jueves',
        friday: 'Viernes',
        saturday: 'Sábado',
        sunday: 'Domingo'
      },
      days_short: {
        monday: 'Lun',
        tuesday: 'Mar',
        wednesday: 'Mié',
        thursday: 'Jue',
        friday: 'Vie',
        saturday: 'Sáb',
        sunday: 'Dom'
      },
      sessions_table: {
        title: 'Sesiones del período',
        start: 'Inicio (estimado)',
        start_tooltip: 'Calculado como última actividad menos duración de la sesión',
        end: 'Último dato registrado',
        duration: 'Duración',
        download: 'Descarga',
        upload: 'Subida',
        closed: 'Estado',
        active: 'Activa',
        closed_label: 'Cerrada',
        zombie: 'Zombie',
        no_records: 'No hay sesiones registradas en el período seleccionado.',
        session_curve_title: 'Curva de tráfico',
        session_breadcrumb: 'Sesión #{{sessionNumber}} · {{dateRange}}'
      },
      ips_table: {
        title: 'Asignaciones IP',
        ip_address: 'Dirección IP',
        first_seen: 'Primera asignación',
        last_seen: 'Última asignación',
        no_records: 'No hay asignaciones de IP en el período seleccionado.'
      },
      no_data: 'Sin datos disponibles',
      export_csv: 'Exportar CSV',
      error_loading: 'Error al cargar',
      dashboard_radius: 'Panel de métricas RADIUS',
      tenant: {
        active_sessions: 'Sesiones activas',
        traffic_live: 'Tráfico en vivo',
        unique_clients: 'Clientes únicos',
        top_consumers: 'Top Consumidores (Mes Actual)',
        usage_capped: 'Consumo del Mes (Con Límite)',
        consumption_by_hour: 'Consumo por Hora del Día',
        consumption_by_day: 'Consumo por Día de la Semana',
        heatmap: 'Consumo por Hora y Día (Mapa de Calor)',
        distribution: 'Distribución de Consumo',
        tab_general: 'General',
        tab_by_service: 'Por servicio',
        tab_forensic: 'Forensia',
        select_service_hint: 'Seleccioná un servicio para ver su consumo',
        search_ip_hint: 'Ingresá una IP y un rango de fechas para buscar',
        no_results: 'Sin resultados',
        unresolved: 'no resuelto',
        search: 'Buscar',
        duration: 'Duración',
        ip_label: 'IP (IPv4 o IPv6)',
        ip_placeholder: 'Ingrese IP...',
        from_label: 'Desde',
        to_label: 'Hasta',
        forensic_description:
          'Búsqueda forense inversa: ¿quién tuvo una IP en un momento dado? Acceso restringido a roles soporte/compliance.',
        col_external_id: 'Cliente',
        col_first_seen: 'Primera vez',
        col_last_seen: 'Última vez',
        col_duration: 'Duración',
        invalid_ip: 'La IP ingresada no es válida',
        date_range_limit: 'La fecha desde excede el límite permitido',
        gantt_title: 'Timeline de asignaciones',
        view_gantt: 'Ver gráfico',
        results_table: 'Resultados de la búsqueda',
        from_after_to: 'No puede ser posterior a Hasta',
        to_before_from: 'No puede ser anterior a Desde',
        service_selector: 'Servicio',
        all_services: 'Todos los servicios',
        empty: 'Sin datos',
        retry: 'Reintentar',
        error_unavailable: 'Intente nuevamente o contacte a soporte',
        usage_table: {
          no_records: 'Sin clientes en el período seleccionado'
        },
        table_header_client: 'Cliente',
        table_header_external_id: 'ID',
        table_header_plan: 'Plan',
        table_header_gb: 'GB',
        table_header_sessions: 'Sesiones',
        table_header_time: 'Tiempo',
        contracts_count: 'Contratos',
        last_hour: 'Última hora'
      }
    },
    client: {
      autocomplete_gps_point_with_google_maps: 'Autocompletar punto GPS con Google Maps',
      automatic_debit: 'Débito automático',
      base_invoiced_date: 'Desde',
      bulk_actions_successful: 'Recibirá un email con los resultados',
      client_summary: 'Resumen del cliente',
      clients_imported_successfully: 'Clientes importados exitosamente',
      clients_portal: 'Portal de Clientes',
      clients_portal_subtitle: 'Este campo será reutilizado para el acceso al Portal de Clientes',
      clients_selected: 'Clientes Seleccionados',
      contact_email: 'E-mail de contacto',
      cpg_can_be_configured: 'La pasarela de pago puede ser configurada<br />Haga clic aquí para configurar',
      cpg_has_error: 'Error en la pasarela de pago',
      create_payment_promises:
        '* De no concretar el pago, el contrato se pondrá en el estado que corresponda al siguiente día.',
      customer_barcode: 'Código de barras del cliente',
      deleted_client: 'Cliente inactivo',
      device: {
        copy_login_link: 'Copiar enlace login'
      },
      edit_client: 'Editar cliente',
      errors_found_review_file: 'Se encontraron errores en el archivo, por favor revisa los datos ingresados',
      enter_international_phone_number: 'Ingrese el número en formato internacional',
      format_international: '+[código de país][código de área][código móvil][número]',
      export_clients_login_mobile: 'Exportar Clientes (con enlace de login mobile y QR)',
      export_clients_to_prisma: 'Exportar Clientes a Prisma',
      export_error: 'Error en exportación.',
      export_no_clients_filtered: 'No hay clientes filtrados.',
      exporting: 'Exportando...',
      generate_barcode_per_invoice: 'Generar código de barras por factura',
      generate_open_barcode: 'Generar código de barras abierto',
      hints: {
        add_taxes_to_client:
          'Al marcar cualquiera de estas opciones, se creará el impuesto correspondiente para los clientes',
        authorize_invoice_after_paid:
          'La factura se informará a la entidad recaudadora luego de haberse emitido y pagado. En el momento de emitir la factura, se enviará la factura como comprobante. Una vez informada después de pagar se enviará la factura.',
        automatic_state: 'El estado de todos los contratos podrá ser cambiado por el sistema automáticamente.',
        create_payment_promises:
          '* De no concretar el pago, el contrato se pondrá en el estado que corresponda al siguiente día.',
        enable_invoice_to_edit_taxes: 'Debe habilitar facturación para editar impuestos',
        invoicing_firm:
          'Razón social del ISP con la que se facturará al cliente (Emisor). Pueden crearse nuevas en el apartado de Facturación -> Razones sociales',
        national_identification_number: 'Según el país: documento o cédula de identidad o clave única de registro.',
        remove_taxes_from_client:
          'Al marcar cualquiera de estas opciones, se creará el impuesto correspondiente para los clientes',
        send_email_when_create_payment:
          'Cada vez que se cree un pago se enviará el comprobante del mismo al cliente si es que cuenta con un correo válido.',
        start_invoicing_day:
          'Cambiar el día a facturar afectará a todos los contratos, y será efectivo a partir del próximo periodo a facturar.',
        switch_issue_invoice:
          'Cada vez que se emita una factura se enviará la misma al correo del cliente si es que cuenta con un correo válido.',
        unverified_phone_number: 'Télefono no verificado',
        vat_condition: 'Condición de Iva del cliente, con la cual se le generarán sus facturas (Receptor)',
        verified_phone_number: 'Télefono verificado'
      },
      import_clients: 'Importar Clientes',
      import_mobile_phones: 'Importar Teléfonos Móviles',
      import_clients_count_one: 'Se actualizarán {{count}} cliente. ¿Está seguro?',
      import_clients_count_other: 'Se actualizarán {{count}} clientes. ¿Está seguro?',
      invoice_preview: 'Vista previa de factura',
      //Se quitan en la ultima revisión
      invoicing_client: {
        emails_to_notify: 'Correos separados por coma, sin espacios.'
      },
      invoicing_client_attributes: {
        emails_to_notify: 'Correos separados por coma, sin espacios.',
        has_debt: 'Tiene deuda',
        invoicing_disabled: 'Facturación deshabilitada',
        payment_gateways: {
          cobroDigital: {
            how_vinculate: '¿Cómo vincular el cliente con CobroDigital?',
            if_the_customer_has_records:
              'Si el cliente <1>NO</1> tiene registros en CobroDigital, deje los campos en blanco y el sistema los generará automáticamente una vez que se emita la primer factura.',
            if_the_customer_is_already:
              'Si el cliente <1>YA ESTÁ</1> dado de alta en CobroDigital, ingrese el ID del mismo. (Ej. de nombre de columna: Id, Identificador de Cliente, sap_identificador). Así como también podrá ingresar opcionalmente el Código de barra y de PagoMisCuentas en caso de tenerlos.'
          },
          create: 'Crear pasarela de pagos',
          cuenta_digital: {
            custom_code:
              '<0>Código personalizado</0>: En caso de tener querer personalizar el código de barras y su código de link pagos, ingréselo en los campos correspondientes.',
            generate_coupon_for_each_invoice:
              '<0>Generar cupón por cada factura</0>: Si quiere generar un cupón por cada factura deje los campos vacíos o haga clic en <2>Generar cupón por cada factura</2>.',
            single_coupon_generation:
              '<0>Generación de cupón único</0>: Generará un único código de barras para el cliente y se utilizará en todas las facturas. Click en <2>Generar cupón único</2>.'
          },
          issue_disabled: 'emisión deshabilitada',
          issue_enabled: 'emisión habilitada',
          siro: {
            // FIXME
            enter_inputs:
              'Si el cliente ya cuenta con un código de barras y código linkpagos, ingréselos en los campos correspondientes.',
            generate_for_each_invoice:
              '<0>Generación por cada factura: </0>Generará un código por cada factura que expirará segun los vencimientos de la misma. Click en <2>Generar código de barras por factura.</2>',
            generate_per_customer:
              '<0>Generación por cliente: </0> Generará un único código de barras para el cliente y se utilizará en todas las facturas. Click en <2> Generar código de barras abierto.</2>'
          }
        },
        positive_balance: 'Saldo a favor',
        without_debt: 'Sin deuda'
      },
      issue_invoices_in_pg: 'Informar facturas a la pasarela de pago',
      label: {
        authorize_invoice_after_paid: 'Informar después de pagar',
        send_email_when_create_payment: 'Enviar correo cuando se crea un pago',
        send_email_when_issue_invoices: 'Enviar correo cuando se emita la factura',
        start_invoicing_day: 'Ciclo de facturación comienza el día',
        switch_issue_invoice: 'Enviar correo con factura emitida'
      },
      last_day_consumption: 'Consumo del último día',
      limit_invoiced_date: 'Hasta',
      location: 'Localización',
      mark_payments_and_credit_notes: 'Marcar pagos y notas de credito asociadas',
      massive_update: {
        add_all_pgs_options: 'Agregar todas opciones de pasarelas',
        add_all_taxes_options: 'Agregar todas las opciones de impuestos',
        authorize_invoice_after_paid: 'Informar después de pagar',
        automatic_state: 'Estado automático',
        emails_to_notify: 'Emails a notificar',
        invoicing_enabled: 'Facturación',
        invoicing_firm_id: 'Razón social',
        kind_invoice: 'Tipo de factura',
        massive_update: 'Actualización masiva',
        payment_method: 'Método de pago',
        remove_all_pgs_options: 'Remover todas las opciones de  pasarelas',
        remove_all_taxes_options: 'Remover todas las opciones de impuestos',
        send_email_when_create_payment: 'Enviar correo cuando se crea un pago al cliente',
        send_email_when_issue_invoices: 'Enviar correo con factura emitida',
        start_invoicing_day: 'Ciclo de facturación comienza el día'
      },
      massive_update_client_with_errors: '{{error_count}} Cliente afectado',
      massive_update_clients_with_errors: '{{error_count}} Clientes afectados',
      massive_update_error_detail_message: '{{attr}}: {{error_type}}, {{error_count}}',
      massive_update_error_hint: 'Clickea el elemento en la lista y se filtrará en la tabla los Clientes con errores',
      massive_update_error_loader_message: 'Recuperando lista de errores',
      massive_update_error_refresh: 'No se han encontrado errores en la actualización masiva.',
      massive_update_error_title: 'Errores en la Actualización Masiva ({{count}} {{plurality}})',
      massive_update_process: 'La actualización masiva esta en proceso.',
      massive_update_remove_all_errors: 'Se han limpiado los errores de la actualización masiva.',
      massively_remove: 'Borrar masivamente',
      new_client: 'Nuevo cliente',
      next_periodic_invoice_link: 'Próxima factura por {{amount}} - Período {{period}} - Contrato #{{sequential_id}}',
      next_periodic_invoice_title: 'Próxima Factura',
      no_contact_information: 'Sin información de contacto',
      no_payment_gateways: 'No hay pasarelas de pago para mostrar',
      number_client: 'N° cliente',
      one_day: 'Consumo del último día',
      one_hour: 'Consumo de la última hora',
      one_month: 'Consumo del último mes',
      one_week: 'Consumo de la última semana',
      one_year: 'Consumo del último año',
      payments_and_associated_credit_notes: 'Pagos y notas de crédito asociadas',
      process_clients: 'Procesar Clientes',
      removeAllOptions: 'Remover todas las opciones',
      update_from_file: 'Actualizar desde archivo',
      searcher_pg_info:
        'Seleccione una opción de la lista. Después de seleccionarla, puede elegir si desea incluir o excluir el ítem de la búsqueda. Esto le permitirá realizar búsquedas combinadas, donde podrá especificar ítems que desea incluir y otros que desea excluir.',
      see_next_invoices: 'Ver próximas facturas',
      show_client_detail: 'Ver detalle del cliente',
      showAllOptions: 'Mostrar todas las opciones',
      successful_massive_update: 'Cliente/s actualizado/s',
      the_client_does_not_have_billing_enabled: 'Cliente no tiene la facturación habilitada',
      verified_existence: 'Verificar existencia'
    },
    cluster: {
      connected: 'Conectado',
      disconnected: 'Desconectado',
      not_linked: 'No vinculado',
      last_seen_at: 'Última conexión',
      create_service: 'Crear nuevo servicio',
      create_acs_service: 'Crear servicio ACS',
      create_radius_service: 'Crear servicio RADIUS',
      create_service_not_linked: 'El cluster no está vinculado',
      generate_enrollment_token: 'Generar token de vinculación',
      enrollment_token_copy: 'Copiar código',
      enrollment_token_copied: '¡Copiado!',
      enrollment_token_valid_for: 'Válido por',
      enrollment_token_expiring: 'Por expirar —',
      enrollment_token_expired: 'Expirado',
      enrollment_token_single_use: 'Un solo uso.',
      enrollment_token_paste_prefix: 'Pegalo en',
      enrollment_token_paste_suffix: 'para completar la vinculación.',
      enrollment_token_regenerate: 'Generar nuevo',
      stacks_count: 'Stacks',
      containers_count: 'Contenedores',
      node: 'Nodo',
      nodes_count: 'Nodos',
      status_running: 'Activo',
      status_degraded: 'Degradado',
      status_inactive: 'Inactivo',
      update_container_image: 'Actualizar imagen del container',
      current_image: 'Imagen actual',
      new_image: 'Nueva imagen',
      container_image_updated: 'Imagen del container actualizada exitosamente',
      view_consumption: 'Ver métricas RADIUS',
      view_consumption_modal: 'Métricas RADIUS',
      error_loading_nodes: 'Error al cargar los nodos del cluster',
      restart_container: 'Reiniciar container',
      restart_container_confirm:
        'Se enviará la orden de reinicio al servicio de Swarm asociado a este container. ¿Desea continuar?',
      restart_container_success: 'Orden de reinicio enviada exitosamente',
      restart_container_error: 'No se pudo enviar la orden de reinicio',
      restart_container_wait: 'Enviando orden de reinicio, por favor espere...'
    },
    contract: {
      tour: {
        quick_search_description:
          'Filtra al instante tus contratos, olvídate de desplazamientos interminables. Esta nueva búsqueda rápida hace que tus consultas diarias sean ultrarrápidas.',
        advanced_search_description:
          'Crea consultas complejas en segundos con nuestro panel de filtros mejorado. Combina varios campos y operadores para encontrar exactamente lo que necesitas.',
        select_all_description:
          'Con un solo clic, selecciona todos los registros para operaciones en masa. También puedes seleccionar contratos específicos.',
        bulk_action_update_description:
          'Aplica actualizaciones en decenas (o cientos) de contratos simultáneamente. Nuestra herramienta de actualización masiva renovada te ahorra horas de ediciones manuales.',
        bulk_action_download_description:
          'Descarga tus datos seleccionados de una vez. La descarga por lotes mejorada pone todos tus registros al alcance de tu mano.',
        hero_description: 'Visualice información del estado de las ONUs vinculadas a Contratos'
      },

      bulk_actions: {
        download: {
          hint_1:
            ' La exportación puede tardar varios minutos; para evitar timeouts, descarga en lotes de máximo 1.000 contratos.',
          hint_2: 'Filtra tus contratos antes de exportar para reducir el tamaño y la complejidad del archivo.',
          hint_3: 'Usa CSV para grandes volúmenes de datos; reserva XLS solo para funciones avanzadas.'
        },
        delete: {
          really_destroy: 'Al marcarlo, se eliminarán permanentemente.',
          warning_message: 'Estos contratos dejaran de existir en tu lista.',
          ont_warning: 'Las ONTs vinculadas con los contratos a eliminar serán desautorizadas.',
          success_message: 'Los contratos han sido borrados exitosamente'
        },
        update: {
          will_update_verb: 'Se Actualizará',
          will_updates_verb: 'Se Actualizarán',
          update_message: 'Los campos a actualizar son:',
          recurring_items_and_discounts_hint: 'Solo puede agregar hasta 24 periodos'
        },
        notificate: {
          success_message_one: 'Notificación enviada correctamente.',
          success_message_other: 'Notificaciones enviadas correctamente.'
        }
      },
      acs_server: {
        change_password: 'Cambiar contraseña',
        change_ssid: 'Cambiar SSID'
      },
      argentina: {
        taxpayer_identification_number: 'CUIT/CUIL',
        vat_condition: 'Condición de IVA'
      },
      band_2_4_the_device_does_not_support_this_configuration:
        'Banda (2.4Ghz) El dispositivo no soporta esta configuración',
      band_5_the_device_does_not_support_this_configuration:
        'Banda (5.8Ghz) El dispositivo no soporta esta configuración',
      // balance: 'Balance C/C',
      breadcrumb_info_paragraph_1: 'Seleccione el Separador, para visualizar las columnas correctamente separadas.',
      breadcrumb_info_paragraph_2:
        'El Encoding (o conjunto de caracteres) para que los caracteres especiales, como acentos, se visualicen de forma correcta.',
      breadcrumb_info_paragraph_3:
        'Luego seleccione el archivo a importar, podrá ver los resultados debajo e importarlo.',
      bulk_actions_successful: 'Recibirá un email con los resultados',
      contracts_deleted_successfully: 'Contratos eliminados exitosamente',
      contracts_imported_successfully: 'Contratos importados exitosamente',
      errors_found_review_file: 'Se encontraron errores en el archivo, por favor revisa los datos ingresados',
      importer: {
        all_errors: 'Todos los errores',
        contracts_updated: 'Contratos Actualizados',
        contracts_with_errors: 'Contratos con Errores',
        filter_errors: 'Filtrar Errores',
        fiber_code: 'Precinto',
        must_select_one_file: 'Debe seleccionar un archivo',
        nap_name: 'Nap',
        nap_port_name: 'Puerto NAP',
        total_contracts: 'Cantidad de Contratos'
      },
      import_contracts: 'Importar Contratos',
      import_contracts_count_one: 'Se actualizarán {{count}} contrato. ¿Está seguro?',
      import_contracts_count_other: 'Se actualizarán {{count}} contratos. ¿Está seguro?',
      destroy_contracts: 'Eliminar Contratos',
      destroy_contracts_count_one: 'Se eliminará {{count}} contrato. ¿Está seguro?',
      destroy_contracts_count_other: 'Se elimarán {{count}} contratos. ¿Está seguro?',
      process_contracts: 'Procesar Contratos',
      client_input_placeholder: 'Busque por nombre',
      client_invoicing_disabled: 'No podrá facturar este contrato.',
      client_invoicing_recurring_item: 'No podrá configurar los items recurrentes de este contrato.',
      client_invoicing_title: 'El cliente tiene la <1>facturación deshabilitada</1>:',
      client_summary: 'Resumen de Cliente',
      colombia: {
        taxpayer_identification_number: 'CC/CE/NIT',
        vat_condition: 'Régimen'
      },
      connecting: 'Conectando',
      contract_config: 'Configuración del Contrato',
      contract_deleted: 'Contrato eliminado',
      contract_discount_no_records: 'Sin descuentos',
      cpe_access: 'Acceso CPE',
      create_new_contract: 'Crear nuevo contrato',
      credit_amount: 'Crédito disponible en cuenta',
      details_contract: 'Observaciones',
      diagnostics: {
        acs_disabled: 'Necesita tener este contrato vinculado a un Wispro Box con ACS para usar esta funcionalidad.',
        address_ip: 'Dirección IP',
        brand: 'Marca',
        device_offline: 'No es posible realizar diagnósticos porque el dispositivo está desconectado.',
        diagnostic: 'Diagnóstico',
        diagnostic_not_supported: 'El dispositivo no soporta este diagnostico.',
        mac_address: 'Dirección MAC',
        model_name: 'Nombre de modelo',
        network_name: 'Nombre de red (SSID)',
        not_mikrotik: 'Necesita tener este contrato vinculado a un servidor Mikrotik para usar esta funcionalidad',
        offline: 'Desconectado',
        online: 'En línea',
        onu_signal: 'Señal ONU',
        ping: {
          failure_count: 'Paquetes perdidos',
          loss_percentage: 'Porcentaje de pérdida',
          packages_sent: 'Paquetes enviados',
          ping: 'Ping',
          ping_statistics: 'Estadísticas de Ping',
          run_ping: 'Realizar Ping',
          statistics_legend:
            'Recuerde que estos valores pueden ser erróneos si el equipo no se encuentra homologado. Para una mejor medición, realice la prueba desde el CPE para la validación. Para una mejor asistencia, contáctese con el Soporte de Wispro.',
          success_count: 'Paquetes Recibidos'
        },
        ping_mkt: 'Ping Mikrotik',
        run_ping_mkt: 'Realizar Ping Mikrotik',
        serial_number: 'N° serial',
        speed_test: {
          run_speed_test: 'Realizar prueba de enlace',
          speed_test: 'Prueba de enlace'
        },
        status: 'Estado',
        summary_of_the_contract_device: 'Resumen del dispositivo del contrato',
        traceroute: {
          hop: 'Salto',
          ip: 'IP',
          run_traceroute: 'Realizar Traceroute',
          time: 'Tiempo',
          traceroute: 'Traceroute'
        },
        update_network: 'Actualizar red',
        uptime: 'Tiempo de conexión',
        you_must_connect_to_the_network_to_view_devices: 'Debe conectar la red para ver los dispositivos'
      },
      disconnecting: 'Desconectando',
      // dhcp_server: 'Servidor DHCP',
      ecuador: {
        taxpayer_identification_number: 'Cédula/RUC',
        vat_condition: 'Régimen'
      },
      error_massive_update: 'error_massive_update',
      export_classic_error: 'Error en exportación clásica.',
      export_error: 'Error en exportación.',
      export_no_contracts_filtered: 'No hay contratos filtrados.',
      form_hints: {
        cable_modem_bin: 'Archivo binario DOCSIS personalizado para este contrato.',
        cable_modem_dhcp: 'Cable Modem funciona sólo para DHCP',
        cable_modem_enabled: 'Funciona solo para versiones de BMU mayores o igual a 0.7.0.',
        contract_linked_to_ont: 'Contrato relacionado con ONU',
        dhcp_server: 'El nombre del servidor DHCP debe coincidir con el definido en el equipo fisico',
        must_select_an_olt: 'Debe seleccionar una OLT para poder seleccionar una NAP',
        must_select_a_nap: 'Debe seleccionar una NAP para poder seleccionar un puerto',
        nap_select: 'Al seleccionar una NAP, se deseleccionará la Cobertura actual.',
        olt_select: 'Para cambiar/eliminar la OLT primero debe desautorizar la ONU.',
        olt_traffic_control_not_supported: 'No soportado.',
        onu_id: 'Si este campo no es completado, será asignado por la OLT.',
        subnet: 'No puede configurar Subred si activa OLT',
        fully_wispro_effect: 'Este campo solo impacta en ONUs configuradas por Wispro'
      },
      forwarded_port_updated: 'Redireccionamiento de puerto se actualizó correctamente',
      generate_invoice_days: 'Generar la factura los días',
      has_discounts: 'Tiene {{discounts}} Descuentos vigentes',
      has_payment_promises: 'Tiene {{paymentPromises}} Promesas de pago vigentes',
      has_recurring_items: 'Tiene {{recurringItems}} Items Recurrentes vigentes',
      has_tickets: 'Tiene {{tickets}} Tickets vigentes',
      import_statuses_error: 'Error en importación de estados',
      indicators: {
        active_recurring_items_count: 'Items recurrentes activos',
        active_recurring_items_count_zero: 'Sin items recurrentes activos',
        pending_tickets_count: 'Tickets pendientes',
        pending_tickets_count_zero: 'Sin tickets pendientes',
        to_apply_discounts_count: 'Descuentos activos',
        to_apply_discounts_count_zero: 'Sin descuentos activos',
        valid_payment_promises_count: 'Promesas de pago válidas',
        valid_payment_promises_count_zero: 'Sin promesas de pago válidas'
      },
      ip_select_placeholder: 'Busque IP libre',
      mac_to_use: 'Vincular ip con',
      massive_update_confirmation_with_params:
        'De los <0>{{totalContracts}}</0> contratos listados <1>(hay filtros aplicados en: {{filteredParams}})</1>, se actualizarán <2>{{updatedContracts}}</2>,',
      massive_update_confirmation_without_params:
        'De los <0>{{totalContracts}}</0> contratos listados, se actualizarán <1>{{updatedContracts}}</1>',
      massive_update_contract_with_errors: '{{error_count}} Contrato afectado',
      massive_update_contracts_with_errors: '{{error_count}} Contratos afectados',
      massive_update_error_detail_message: '{{attr}}: {{error_type}} {{restriction_value}}, {{error_count}}',
      massive_update_error_hint: 'Clickea el elemento en la lista y se filtrará en la tabla los Contratos con errores',
      massive_update_error_loader_message: 'Recuperando lista de errores',
      massive_update_error_refresh: 'No se han encontrado errores en la actualización masiva.',
      massive_update_error_title: 'Errores en la Actualización Masiva ({{count}} {{plurality}})',
      massive_update_form_preview_title: 'Los datos a actualizar son:',
      massive_update_process: 'La actualización masiva esta en proceso.',
      massive_update_remove_all_errors: 'Se han limpiado los errores de la actualización masiva.',
      mikrotik_not_linked: 'Mikrotik no vinculado',
      no_address_interface_mkt: 'La IP definida, no pertenece a la interfaz de red seleccionada',
      no_interface_address_mkt: 'La interfaz {{interface}} con la dirección {{address}} no existe en el equipo.',
      no_interface_mkt: 'La interfaz {{interface}} no existe en el equipo.',
      olt_plans: 'Planes disponibles en la OLT',
      olt: {
        action: {
          add: 'Agregar',
          authorize: 'Autorizar',
          check: 'Verificar',
          unlink: 'Desvincular'
        },
        associate_succesfuly: 'Ont actualizada',
        auth_ont: 'Autorizar ONU',
        authorize_succesfuly: 'Ont autorizada',
        connecting_to_olt: 'Conectando con la OLT, por favor aguarde.',
        disable_catv: 'Deshabilitar CATV',
        disable_catv_wait: 'Deshablitando CATV, por favor aguarde.',
        enable_catv: 'Habilitar CATV',
        enable_catv_wait: 'Hablitando CATV, por favor aguarde.',
        enable_wan_access: 'Habilitar acceso WAN',
        enable_wan_access_wait: 'Habilitando acceso WAN, por favor aguarde.',
        disable_wan_access: 'Deshabilitar acceso WAN',
        disable_wan_access_wait: 'Deshabilitando acceso WAN, por favor aguarde.',
        factory_reset: 'Restablecer configuración de fábrica',
        factory_reset_wait: 'Restableciendo configuración de fábrica, por favor aguarde.',
        no_olts: 'No hay OLTs vinculadas',
        no_onts: 'No hay ONUs disponibles',
        onts: {
          alert_description: 'Descripción del error',
          alert_error: 'Error',
          alert_ont: 'F/S/P:Ont',
          alert_time: 'Hora',
          alerted_onts: 'ONUs con alertas',
          authorizing: 'Autorizando ONU Serial: "{{serial}}" en {{interface}}: {{number}}',
          board: 'Slot',
          both: 'Ambas',
          contract: 'Contrato',
          contracts_with_ont: 'Contratos con ONUs',
          editing: 'Editando ONU Serial: "{{serial}}" en {{interface}}: {{number}}',
          frame: 'Frame',
          frame_slot_port: 'Frame / Slot / Port',
          full_interface: 'Interfaz F/B/P',
          gateway: 'Puerta de enlace',
          instant_bw: 'Instantaneo',
          ipconfig: 'Tipo de configuración',
          ipconfig_legend: 'Los datos serán copiados directamente del contrato',
          ipconfigs: {
            bridge: 'Modo Bridge',
            dhcp: 'DHCP',
            pppoe: 'PPPoE',
            static: 'Estática'
          },
          massive_unlink_onus: 'Desvincular ONUs',
          massive_unlink_onus_description: 'Desvincula la ONU de los contratos seleccionados',
          massive_unlinking_process: 'La desvinculación masiva está en proceso.',
          massive_unlinking_warning:
            'Se van a desvincular las ONUs de los contratos seleccionados (los clientes van a seguir navegando).',
          missing_configuration: 'Debe completar la configuración faltante para autorizar.',
          missing_configuration_link: 'Debe completar la configuración faltante para vincular.',
          name: 'Nombre',
          netmask: 'Máscara',
          number: 'Numero',
          olt: 'Olt',
          only_auth: 'Sólo es posible autorizar. Próximamente estará disponible el aprovisionamiento WAN.',
          ont_authorized_not_linked: 'Autorizadas no vinculadas',
          ont_not_authorized: 'No autorizadas',
          port: 'Port',
          ports_with_onts: 'Puertos GPON con ONUs',
          ports_with_onts_count: '{{count}} puertos con ONUs',
          profile: 'Perfil',
          profile_type: 'Tipo de Perfil',
          authorization: {
            authorizing: 'Autorizando ONU…',
            authorizing_error: 'Error al autorizar la ONU'
          },
          rules: {
            applying_changes_in_ont: 'Aplicando cambios en la ONU',
            change_state: {
              applied: 'Aplicado',
              canceled: 'Cancelado',
              error: 'Error al aplicar cambios',
              pending: 'Aplicando cambios'
            },
            error_applying_changes_in_ont: 'Error al aplicar cambios en la ONU',
            kinds: {
              activate: 'Activar ONU',
              activate_catv: 'Activar CATV',
              authorize: 'Autorizar ONU',
              catv: 'CATV',
              deactivate: 'Desactivar ONU',
              deactivate_catv: 'Desactivar CATV',
              disable_wan_access: 'Deshabilitar acceso WAN',
              enable_wan_access: 'Habilitar acceso WAN',
              factory_reset: 'Restablecimiento de fábrica',
              reboot: 'Reiniciar',
              reconfigure: 'Reconfigurar',
              resync: 'Resincronizar',
              state: 'Estado',
              tr069: 'TR069',
              traffic_control: 'Control Ancho de Banda',
              unauthorize: 'Desautorizar ONU',
              vlan: 'VLAN',
              wan_provision: 'Aprovisionamiento WAN'
            },
            rule_state: {
              canceled: 'Cancelado',
              error: 'Error',
              success: 'Procesado',
              pending: 'Pendiente',
              processing: 'Procesando'
            },
            no_changes_currently_applying: 'No se están aplicando cambios actualmente a la ONU',
            changes_history_title: 'Historial de cambios aplicados',
            no_changes_applied: 'No hay cambios aplicados',
            copy_rule_id: 'Copiar Rule ID',
            copy_errors: 'Copiar errores',
            copy_feedback: 'Copiar feedback',
            retry_change_error: 'Error al reintentar el cambio',
            change_being_applied: 'El cambio se está aplicando'
          },
          serial: 'Nº de serie',
          serial_number: 'Nº de serie',
          service_profile: 'Service profile',
          show_alerts: 'Ver alertas',
          show_changes_applied: 'Cambios aplicados',
          static_ip: 'IP estática',
          tr069: 'Perfil TR069',
          tr069_profile_id: 'Perfil TR069',
          unsync: 'ONU desincronizada',
          unsync_causes: {
            number: 'ONU ID',
            'fbp:n': 'F/B/P:N',
            fbp: 'F/B/P',
            serial_not_found: 'Serial',
            unauthorized: 'Desautorizada',
            unknown: 'Desconocida'
          },

          vlan_id: 'Vlan',
          vlans: 'Vlans'
        },
        reboot_ont: 'Reiniciar',
        rebooting: 'Reiniciando la ONU, por favor aguarde.',
        resynchronizing: 'Resincronizando la ONU, por favor aguarde.',
        reconfig: 'Reescribir configuración',
        reconfig_wait: 'Reescribiendo configuración, por favor aguarde.',
        reconfig_wan: 'Reescribir configuración WAN',
        reconfig_wan_wait: 'Reescribiendo configuración WAN, por favor aguarde.',
        resync: 'Resincronizar',
        select_ont: 'Debe selecciona al menos una ONU para asociar',
        show_onu_info: 'Ver Información',
        unauthorizing: 'Desautorizando la ONU, por favor aguarde.',
        unlink_first: 'Primero debe desvincular la ONU actual',
        unlinking: 'Desvinculando la ONU, por favor aguarde.',
        vlans: {
          ip: 'IP',
          kind: 'Tipo',
          name: 'Nombre',
          netmask: 'Máscara',
          number: 'VLAN ID',
          onts_enabled: 'ONUs?',
          server_client_numbers: 'VLAN ID Servidor <=> Cliente',
          title: 'VLANs',
          uplinks_enabled: 'Uplinks?',
          vlan_one_in_use:
            '<0>¡IMPORTANTE!:</0> Usted utiliza la VLAN 1 para las autorizaciones. Por buenas prácticas, NO se recomienda usar la VLAN 1 como VLAN de gestión o VLAN de servicio. Esta es una VLAN reservada.',
          vlan_one_in_use_more_info:
            'Todas las interfaces se unen a la VLAN 1 de forma predeterminada, es una configuración bridge de toda su red. Esto genera que los paquetes que realizan Unicast, Multicast o Broadcast de VLAN 1, se envíen a toda su red y puedan ocurrir tormentas de Broadcast y su red se verá degradada de manera exponencial.'
        },
        wan_provisioning: 'El aprovisionamiento WAN se encuentra deshabilitado.',
        without_permission: 'Sin permisos'
      },
      // offline: 'Desconectado',
      one_month: 'Consumo del último mes',
      one_week: 'Consumo de la última semana',
      one_year: 'Consumo del último año',
      // online: 'Conectado',
      online_contract_error_message: 'No pudimos obtener la cantidad de contratos conectados',
      ont_linked_info_message:
        'El control de ancho de banda, estado automático de CATV y Aprovisionamiento WAN no se configurarán debido a que la ONU se encuentra vinculada sin reconfigurar.  Para poder utilizarlos es necesario que resincronice la ONU con las configuraciones de Wispro.',
      ont_signal: 'Señal ONU',
      ont_number_hint: 'Este campo tendra efecto solo si se autoriza o reconfigura.',
      pagination_info: '{{paginationFilterTotal}} contratos filtrados de {{paginationTotalCount}} en total',
      other_plans: 'Otros planes',
      payment_promises_no_records: 'Sin promesas de pago',
      // ping: 'Ping',
      ping_wait: 'Ping en proceso, por favor aguarde.',
      plan_discounts: 'Descuentos del plan',
      public_address: 'Dirección FULL-NAT',
      recurring_item_no_records: 'Sin items recurrentes',
      removed_articles_destination: 'Destino de los artículos removidos',
      recurring_item_discounts: 'Descuentos del item recurrente',
      resync_contract_to_mkt: 'Resincronizar contrato a MikroTik',
      resync_wait: 'Resincronizar en proceso, por favor aguarde.',
      save_service_invoice: 'Guardar factura de servicio',
      search_by_code: 'Busque por código',
      search_by_name_or_fbp: 'Busque por nombre o F/B/P',
      searcher: {
        basic_placeholder:
          'Puedes buscar por: Nombre cliente, ID Cliente personalizable, Dirección IP, Nombre plan, Número de Serie ONU.'
      },
      select_a_port: 'Seleccione un puerto',
      service: {
        bridge_mode: 'Bridge',
        dhcp: 'DHCP',
        host: 'Host',
        pppoe: 'PPPoE',
        routing_mode: 'Router',
        static: 'Estática',
        subnet: 'Subred',
        router_mode_wan_provisioning_enabled_info:
          'La interfaz wan de navegación de la ONU se escribe en la OLT y se configura en la ONU via OCMI.',
        router_mode_wan_provisioning_disabled_info:
          'La interfaz WAN de navegación de la ONU se configura manualmente en la ONU.',
        bridge_mode_info: 'La interfaz WAN de navegación se configura en el router conectado detrás de la ONU.',
        disabled_routing_mode:
          'No es posible cambiar el modo de enrutamiento porque el contrato está vinculado a una ONU configurada por Wispro.'
      },
      service_by: 'Servicio por',
      // should_select_contract: 'Debe seleccionar contrato',
      should_select_contract: 'Debe seleccionar contrato',
      show_client_detail: 'Ver detalle del cliente',
      show_contract_detail: 'Ver detalle del contrato',
      signal_quality: {
        disconnected: 'Sin señal',
        moderate: 'Media',
        strong: 'Excelente',
        weak: 'Débil'
      },
      connectivity_tooltip: {
        title: 'Conectividad',
        signal_subtitle: 'Estado de la señal',
        signal_ok: 'Señal óptica óptima',
        signal_warning: 'Señal óptica alarmante',
        signal_critical: 'Señal óptica critica',
        last_down_cause_subtitle: 'ONU offline — causa reportada por la OLT',
        last_down_cause_los:
          'Pérdida de la señal óptica en el enlace de fibra (LOSI). La ONU dejó de recibir señal desde la OLT.',
        last_down_cause_auth_fail: 'Fallo de autenticación. La ONU no pudo registrarse contra la OLT.',
        last_down_cause_negotiation: 'Falló la negociación de activación con la OLT.',
        last_down_cause_deactivate: 'La ONU fue desactivada administrativamente desde la OLT.',
        last_down_cause_reboot: 'La ONU se desconectó por un reinicio.',
        last_down_cause_dying_gasp: 'Pérdida de alimentación. La ONU envió una alarma dying-gasp antes de apagarse.',
        last_down_cause_na: 'La OLT no reportó una causa específica para la desconexión.'
      },
      six_months: 'Consumo de los ultimos 6 meses',
      start_date: 'Fecha de alta',
      start_invoicing_date: 'Fecha a generar la proxima factura',
      start_invoicing_day: 'Generar la factura los días',
      state: 'Provincia/Estado/Región',
      states: {
        alerted: 'Alertado',
        degraded: 'Degradado',
        disabled: 'Deshabilitado',
        enabled: 'Habilitado'
      },
      successful_massive_update: 'Contrato/s actualizado/s',
      this_device_does_not_support_the_requested_service: 'Este equipo no soporta el servicio solicitado',
      // tabs: {
      //   audits: 'Auditorías',
      //   details: 'Detalles',
      //   forwarded_ports: 'Redirecciones de puerto',
      //   invoicing: 'Facturación',
      //   ont: 'ONU',
      //   payment_promises: 'Promesas de pago',
      //   pppoe_status: 'PPPoE Status'
      // },
      three_months: 'Consumo de los ultimos 3 meses',
      tooltip_total_contracts: 'Cantidad total de contratos',
      tooltip_total_contracts_connected: 'Indica la cantidad de contratos conectados con un servidor {{server}}',
      tooltips: {
        created_at: 'Creado el',
        updated_at: 'Actualizado el'
      },
      unexpected_error_getting_plan_data: 'Error inesperado al obtener los datos del plan',
      update_network: {
        update_in_progress: 'Actualización en progreso'
      },
      update_contract_from_file: 'Actualizar contratos desde archivo',
      view_next_invoices: 'Ver próximas facturas',
      wifi: 'WI-FI',
      you_must_bind_an_ont_to_use_this_service: 'Debe vincular una ONU para utilizar este servicio'
    },
    contract_discounts: {
      to_apply_discounts: 'Descuentos actuales',
      finalized_discounts: 'Descuentos finalizados',
      lapse: {
        every_period: 'Todos los periodos',
        specific_periods: '{{lapse}} periodos'
      }
    },
    cloud_license: {
      unlock_plan_change: 'Desbloquear cambio de plan',
      acs_license: {
        subscribe: 'Suscribirme'
      },
      annual: 'Anual',
      balance_due: 'Saldo adeudado',
      balance_in_favor: 'Saldo a favor',
      cloud: 'Cloud',
      customer: 'Customer',
      day_of_trial_left: 'Queda {{day}} día de prueba',
      days_of_trial_left: 'Quedan {{days}} días de prueba',
      default_card: 'Tarjeta por defecto',
      discount_for_months: {
        one: 'Descuento de {{percentage}}% por {{periods}} mes',
        other: 'Descuento de {{percentage}}% por {{periods}} meses'
      },
      extended_license_until: 'Suscripción extendida hasta',
      future_discounts_after_trial: {
        one: 'Descuento de {{percentage}}% por {{periods}} mes se le aplicará una vez que termine su período de prueba',
        other:
          'Descuento de {{percentage}}% por {{periods}} meses se le aplicará una vez que termine su período de prueba'
      },
      hola_suite: {
        subscribe: 'Suscribirme',
        token: 'Token Hola Suite'
      },
      install_cloud: 'Instalar Cloud',
      installation: 'Instalación',
      invoice: {
        issue_invoice: 'Emitir factura',
        loading_invoices: 'Cargando facturas...',
        there_are_no_invoices_to_display: 'No hay facturas para mostrar',
        To_make_a_payment_you_must_add_a_payment_method: 'Para pagar debes agregar un método de pago'
      },
      monthly: 'Mensual',
      past_due_message:
        'Queremos informarle que al día de la fecha no se ha podido realizar el cobro de su suscripción. Por favor, revise si cuenta con fondos suficientes o si requiere autorización de su Banco, para evitar el vencimiento de la misma.',
      summary: 'Resumen',
      support_message: 'Ante cualquier duda o inconveniente comuniquese a nuestro WhatsApp oficial al',
      terms_and_conditions: {
        privacy_policy: 'Política de Privacidad',
        privacy_policy_info: {
          changes_to_this_policys_paragraph:
            'Wispro podrá modificar esta política de vez en cuando. Si hacemos cualquier cambio sustancial en la forma en que usamos la información personal que vamos a hacer que la información disponible mediante la publicación de un aviso en este sitio.',
          changes_to_this_policys_title: 'Cambios en esta Política de Privacidad',
          choice_opt_out_paragraph:
            'Usted puede optar por “Opt out” de recibir marketing directo o información de estudios de mercado. Esto significa que suponemos que usted nos ha dado su consentimiento para recoger y utilizar su información de acuerdo con esta política a menos que tome medidas positivas activando “Opt-out”. Opt-out es el medio por el cual usted, no nos da su consentimiento para utilizar su información personal para los fines expuestos. Usted puede activar “Opt-out” cuando se recopila información personal, o puede hacerlo en cualquier momento enviando un correo electrónico a contacto@wispro.co (indique “Opt Out” en la línea del asunto) o mediante el envío de una solicitud por escrito a la dirección indicada a continuación. En algunos casos, le dará la oportunidad de “opt in”. Esto significa que vamos a exigir su acción afirmativa para indicar su consentimiento antes de utilizar su información para fines distintos de los fines para los que fue requerido.',
          choice_opt_out_title: 'Elección / Opt-Out',
          contact_info_paragraph:
            'Wispro espera sus comentarios sobre esta declaración de privacidad. Si usted cree que Wispro no se ha ceñido a esta declaración de privacidad, por favor póngase en contacto con nosotros por vía electrónica a contacto@wispro.co o mediante correo postal a la dirección indicada a continuación, y realizaremos los esfuerzos comercialmente razonables para determinar y solucionar pronto el problema.',
          contact_info_title: 'Información del contacto',
          cookies_and_tracking_paragraph:
            'Una “cookie” es un pequeño archivo de datos que algunos sitios web escriben en su disco duro cuando usted los visita. Las cookies no pueden ser utilizadas para ejecutar programas o distribuir virus informáticos a su computadora. Un archivo cookie puede contener información como el ID de usuario que el sitio utiliza para rastrear las páginas que ha visitado, pero la única información personal que una cookie puede contener es información de usted mismo. Una cookie no puede leer datos de su disco duro ni leer los archivos cookie creados por otros sitios. Las cookies le ahorran tiempo, por ejemplo, si personaliza una página Web o explora un sitio web, una cookie recuerda su información específica en las subsiguientes visitas. Wispro también utiliza cookies para rastrear los patrones de tráfico del usuario. Esto lo hacemos con el fin de determinar la utilidad de nuestro sitio web la información para nuestros usuarios y para comprobar la eficacia de nuestra estructura de navegación para ayudar a los usuarios a llegar esa información. Usted puede aceptar o rechazar las cookies. La mayoría de los navegadores web aceptan automáticamente las cookies, pero usted puede modificar la configuración del explorador para rechazar las cookies. Tenga en cuenta sin embargo, si un visitante se apaga las cookies como visitante y / o el propietario del sitio web puede encontrar algunas de las funcionalidades de nuestro sitio web y / o nuestros productos, que se reduzca. Además de las cookies, nuestro sitio web utiliza una variedad de métodos técnicos para fines de seguimiento, incluidos los contadores de visitantes. Las web beacons son pequeñas piezas de información que están incrustadas en las imágenes en las páginas de los sitios web. Wispro también utiliza estos métodos técnicos para analizar los patrones de tráfico en nuestro sitio web, como la frecuencia con la que nuestros usuarios visitan diferentes partes de nuestro Sitio Web.',
          cookies_and_tracking_title: 'Cookies y tecnología de seguimiento',
          data_collection_paragraph:
            'Información personal significa cualquier información que pueda ser utilizada para identificar a un individuo, incluyendo, pero no limitado a, un nombre y apellido, nombre de la empresa, dirección de correo electrónico, número de teléfono, dirección postal o física sí, fecha de nacimiento, sexo, ocupación, un número de tarjeta de crédito (incluyendo la fecha de vencimiento) para procesar el pago de productos, aplicaciones y / o servicios, y cualquier otra información cuando sea necesario para proporcionar un servicio que ha solicitado. Algunos de nuestros productos, aplicaciones y servicios también almacenan información de conexión o sesión como el tiempo / fecha y duración de la recopilación, la dirección IP, registros e información técnico de chat. ',
          data_collection_paragraph_2:
            'A medida que navega a través de este Sitio Web y / o utilizar nuestras aplicaciones, cierta información anónima puede ser recopilada pasivamente (es decir, sin que usted proporcione activamente la información) usando diversas tecnologías, tales como cookies, etiquetas de Internet o web beacons y recopilación de datos de navegación (archivos de registro, registros de servidor, click stream). Su navegador de Internet automáticamente transmite parte de esta información anónima, como el URL del sitio web que se conectó, la dirección de Protocolo de Internet (IP) y la versión del navegador que su computadora o dispositivo móvil está utilizando en la actualidad; la fecha y hora de acceso al Sitio Web y las páginas que ha tenido acceso en el Sitio Web. Esta información se utiliza para fines de marketing internos / externos, para analizar tendencias y mejorar nuestro sitio web, productos, aplicaciones y servicios. Nuestro sitio web también puede recopilar información anónima de su ordenador o dispositivo móvil a través de cookies y etiquetas de Internet o web beacons. Usted puede configurar su navegador para que le notifique cuando se envía una cookie o para rechazar todas las cookies, pero ciertas características de este sitio web podrían no funcionar sin cookies.',
          data_collection_paragraph_3:
            'Wispro recopila información personal cuando usted decide usar nuestro software en una base de prueba gratuita o adquirir una App, suscripción o una actualización. Wispro sólo utiliza esta información si ha sido recaudada de conformidad con las prácticas de privacidad aceptables consistentes con esta Política y las leyes aplicables.',
          data_collection_subtitle: 'Recopilación de Información',
          data_security_paragraph:
            'Tu información personal está protegida para su privacidad y seguridad. Wispro protege la seguridad y confidencialidad de los datos que nos envía mediante procedimientos físicos, técnicos y administrativos. Tenga en cuenta que, a pesar de nuestros mejores esfuerzos, ninguna medida de seguridad es perfecta o impenetrable. Si bien nos esforzamos por proteger su información personal, no podemos garantizar la seguridad de la información que usted nos transmita, por lo que instamos a que tome todas las precauciones para proteger sus datos personales cuando esté en Internet. Cambia tus contraseñas a menudo, utilice una combinación de letras y números, y asegúrese de usar un navegador seguro.',
          data_security_paragraph_2:
            'Nuestro sitio web puede contener enlaces a sitios web operados por otras compañías. Algunos de estos sitios de terceros pueden ser de marca compartida con un logotipo Wispro, a pesar de que no son operados o mantenidos por Wispro. Aunque elegimos a nuestros socios de negocio cuidadosamente, Wispro no es responsable de las prácticas de privacidad de los sitios web operados por terceros que estén vinculados a nuestro sitio. Una vez que haya salido de nuestro sitio web, usted debe comprobar la política de privacidad aplicable del sitio web de terceros para determinar cómo van a manejar toda la información que obtenemos de usted.',
          data_security_title: 'Seguridad de los datos',
          international_privacy_paragraph:
            'La información personal que mantenemos puede ser controlada y procesada en los Estados Unidos de América y / o en otros países, lo que podría no proporcionar el mismo nivel de protección de la privacidad como en su país de residencia. Para obtener información de identificación personal recopilada de los usuarios en el Espacio Económico Europeo y Suiza, Wispro se adhiere a los principios de puerto seguro administrado por el Departamento de Comercio de EE.UU.',
          international_privacy_title: 'Protección Internacional de Privacidad',
          privacy_for_childrens_paragraph:
            'Nuestro sitio web es un sitio para el público en general que no se dirige y no está destinado a niños menores de 13 años. Wispro no solicita ni mantenemos información personal perteneciente a menores de 13 años.',
          privacy_for_childrens_title: 'Privacidad de los niños',
          privacy_policy_paragraph:
            'Wispro Inc. y sus subsidiarias (en conjunto denominados en lo sucesivo “WISPRO”, “nosotros”, “la empresa” o “nuestra”), respetamos su privacidad y nos comprometemos a proteger la información personal que usted comparte con nosotros. En general, se puede navegar a través de nuestra página web sin darnos ninguna información sobre sí mismo. Esta política describe cómo recopilamos y utilizamos su información personal cuando necesitamos su información personal para proporcionar los servicios que solicita o cuando elige proporcionarnos su información personal a través de nuestro sitio web (www.wispro.co el “Sitio Web”) o de nuestras aplicaciones (“apps”)',
          revise_review_info_paragraph:
            'Siempre se puede solicitar una revisión de toda la información personal que hemos recopilado de usted, hemos nosotros de actualizar, corregir o borrar dicha información y / o darnos instrucciones de no utilizar esta información en el futuro. Si desea ejercer este derecho, sólo tiene que ponerse en contacto con nosotros.',
          revise_review_info_title: 'Su capacidad de revisar y eliminar información',
          sharing_info_paragprah:
            'Nuestro sitio Web y aplicaciones ofrece la oportunidad de optar por no recibir comunicaciones de nosotros cuando usted elige utilizar nuestras aplicaciones o software en una base de prueba gratuita o adquirir una nueva suscripción o una actualización. Además, cuando reciba la comunicación, se le da la oportunidad de dejar de recibir comunicaciones en el futuro o para cambiar la información.',
          sharing_info_paragprah_2:
            'A menos que usted Opt-in, Wispro no transferirá su información personal a terceros, excepto podemos transferir su información personal sin su consentimiento en la medida requerida para ello por la ley o en la creencia de buena fe que dicha acción es necesaria para: (i) cumplir con edictos legales o el cumplimiento de un proceso legal en Wispro o el sitio; (ii) proteger o defender los derechos o la propiedad del Wispro; (iii) actuar en circunstancias urgentes para proteger la seguridad personal, la propiedad o la privacidad de los empleados de Wispro, los usuarios de los productos o servicios de Wispro, o los miembros del público; o (iv) efectuar una transacción, reestructuración o de las actuaciones que se transfiere a un tercero los activos o la línea de negocio a la que se refiere la información. Si decide proporcionarnos su información personal, podemos transferir esa información dentro Wispro o terceros proveedores de servicios de Wispro con su permiso. Además, Wispro puede enviar su información personal a otras empresas o personas en cualquiera de las siguientes circunstancias: cuando tenemos su consentimiento para compartir la información; necesitamos compartir su información para proveer el producto o servicio que usted ha solicitado; necesitamos enviar la información a compañías que trabajan en nombre de Wispro para proporcionar un producto o servicio a usted (sólo proporcionaremos a esas empresas la información que necesitan para prestar el servicio, y se les prohíbe utilizar esa información con ninguna otra finalidad ); o queremos mantenerle al día sobre los últimos anuncios de productos, actualizaciones de software, ofertas especiales u otra información que pensamos que le gustaría oír de nosotros o de nuestros socios comerciales (a menos que usted haya optado por este tipo de comunicaciones).',
          sharing_info_paragprah_3:
            'Además, es posible que compartamos información agregada no identificable sobre nuestros usuarios (por ejemplo, el porcentaje de usuarios masculinos y femeninos) con anunciantes, socios comerciales y otros terceros en un esfuerzo para personalizar o mejorar el contenido y la publicidad en nuestro Sitio Web para nuestros usuarios.',
          sharing_info_title: 'Compartir y revelar información',
          used_collected_data_paragraph:
            'Wispro utiliza la información de identificación personal para varios propósitos generales: para satisfacer sus pedidos de ciertos productos y servicios, para mantenerte al día sobre los últimos anuncios de productos, actualizaciones de software, ofertas especiales u otra información que pensamos que le gustaría conocer tanto a de nosotros o de nuestros socios de negocios, y para entender mejor sus necesidades y ofrecerle un mejor servicio. También podemos utilizar su información para enviarle materiales promocionales acerca de bienes y servicios (incluyendo ofertas especiales y promociones), ya sea que ofrece Wispro y/o ofrecidos por terceros. Usted puede optar por no recibir estas comunicaciones.',
          used_collected_data_title: 'Cómo utilizamos la información recopilada'
        },
        refund_info: {
          money_back_guarantee_paragraph:
            'Usted puede deshacer su compra y requerir un reembolso completo del dinero pagado por el Software comprado. El plazo para hacerlo es de 15 días.',
          money_back_guarantee_subtitle: 'Garantía de Devolución',
          process_for_refund_paragraph_1: 'Registre la siguiente información del suscriptor:',
          process_for_refund_paragraph_2:
            '1) Dirección de correo electrónico del suscriptor (asociado con su cuenta Wispro)',
          process_for_refund_paragraph_3: '2) El detalle de la factura sobre la cual requiere reembolso.',
          process_for_refund_paragraph_4: '3) Envíe esta información por mail a contacto@wispro.co',
          process_for_refund_paragraph_5:
            '4) Esperar una respuesta del Servicio de atención al cliente que confirma que su devolución se ha emitido.',
          process_for_refund_paragraph_6: '5) Coordine la forma de entrega del dinero solicitado en el reembolso.',
          process_for_refund_subtitle: 'Proceso de Reembolso',
          refund_policy_title: 'Política de Devoluciones'
        },
        refund_policy: 'Política de devoluciones',
        terms_and_conditions: 'Términos y Condiciones',
        terms_and_conditions_info: {
          accepted_payment_methods_paragraph_1: '3.1.1. Pago de Mes a Mes Suscripciones.',
          accepted_payment_methods_paragraph_1_1:
            'En el caso de que tu suscripción a un servicio es sobre una base mensual, el pago de la cuota de suscripción debe ser por la carga de la tarjeta de crédito pre-autorizado y su suscripción se renovará automáticamente cada mes calendario, a menos que Usted proporcione Wispro con notificación por escrito de no renovación durante el mes natural anterior.',
          accepted_payment_methods_paragraph_2: '3.1.2. El pago de las suscripciones anuales:',
          accepted_payment_methods_paragraph_3:
            '3.1.2.1. Suscripciones anuales por la tarjeta de crédito. En el caso de que tu suscripción al Servicio es por un año y el pago inicial es con tarjeta de crédito, cargo o débito directo, Su suscripción se renovará automáticamente al principio de cada año aniversario subsecuente a menos que darle Wispro aviso previo por escrito de no renovación al menos treinta (30) días antes del vencimiento de su suscripción actual año.',
          accepted_payment_methods_paragraph_4:
            '3.1.2.2. Suscripciones anuales en la factura. En el caso de que tu suscripción al Servicio es por un año y el pago inicial es por cheque o giro bancario contra una factura de Wispro, el pago será por un plazo de treinta (30) días de la fecha de factura. Además, Su suscripción se renovará automáticamente al principio de cada año aniversario subsecuente a menos que usted o Wispro da aviso previo por escrito de no renovación al menos treinta (30) días antes de la expiración del año de suscripción actual.',
          accepted_payment_methods_paragraph_5:
            '3.1.3. Suscripciones gratuitas. No obstante lo anterior, su suscripción a cualquiera de los servicios gratuitos de Wispro no requiere el pago de una cuota de suscripción. Wispro se reserva el derecho, a su sola y absoluta discreción, restringir, limitar o cancelar el uso de o versiones “gratuitas” “básicas” de los Servicios por parte de cualquier persona, entidad o grupo de entidades.',
          accepted_payment_methods_subtitle: '3.1. Modalidades de pago aceptadas:',
          account_use_title: 'Artículo II. Uso de su cuenta',
          additional_conditions_title: 'ARTICULO VI. Condiciones para acceso remoto, Servicios de Gestión y Soporte',
          applicable_law_paragraph_1:
            'Los Términos se regirán e interpretarán de conformidad con las leyes del Estado de Delaware y las leyes de EEUU, sin dar efecto a cualquier principio de conflicto de derecho. Ud está de acuerdo en que cualquier acción que surja de o esté relacionada con estos Términos se presentaron sólo en los tribunales estatales o federales ubicados Delaware, EEUU, y usted acepta y se somete a la jurisdicción personal de dichos tribunales a los fines de litigar cualquier acción. Las partes renuncian expresamente la aplicabilidad de (i) la Convención de las Naciones Unidas sobre la Venta de Bienes y (ii) cualquier Incoterms.',
          applicable_law_subtitle: '5.2. Ley aplicable.',
          characteristics_paragraph_1: 'Software de gestión y administración para ISP’s.',
          characteristics_paragraph_2:
            'El software soluciona cuestiones técnicas y administrativas para la provisión del servicio de Internet a clientes o usuarios finales.',
          characteristics_paragraph_3: 'Las técnicas son:',
          characteristics_paragraph_4:
            '– Balanceo y Failover de múltiples conexiones: da la posibilidad al ISP de balancear múltiples WAN’s.',
          characteristics_paragraph_5: '– QoS y control de P2P.',
          characteristics_paragraph_6: '– Web y Video Cache.',
          characteristics_paragraph_7: '– PPPoE.',
          characteristics_paragraph_8: '– Control de ancho de banda por usuarios y planes. Gráficos de consumo.',
          characteristics_paragraph_9: '– Actualizaciones permanentes online. Balanceo NAT. Ráfagas de descarga.',
          characteristics_paragraph_10:
            '– Manejo de IP públicas por Full NAT, Proxy ARP, Ruteadas. DNS dinámico. DHCP. Control por horarios.',
          characteristics_paragraph_11:
            'Las de gestión son: Delegación de tareas. Auditoría. Usuarios con perfiles de permisos. Aplicación web de acceso remoto. Automatización de procesos. Notificaciones de mora y corte automáticos. Portal cautivo para los clientes del ISP. Notificaciones por única vez con fines comerciales. Soporte y Mesa de ayuda para los clientes del ISP. Asignación de tareas. Seguimiento de incidencias. Reportes. Billing. Facturación e impresión. Gestión de pagos y cobranzas. Importación de pagos electrónicos.',
          characteristics_paragraph_12: 'Estas características son solo enunciativas y no taxativas.',
          characteristics_paragraph_13:
            'Se entiende que el uso de este software implica un negocio que Ud. realiza cobrando a sus usuarios por él, y que por ende deberá respetar todas las cláusulas legales y disposiciones que regulen dicha actividad.',
          characteristics_paragraph_14: 'Usted acepta que NO podrá:',
          characteristics_paragraph_15:
            '(i) Violar las reglas internacionales que dan base a Internet entendido en forma amplia y abarcativa.',
          characteristics_paragraph_16:
            '(ii) Utilizar el software o servicio para revender Internet en violación de las normas locales o internacionales.',
          characteristics_paragraph_17:
            'Acepta que es responsable de las acciones y omisiones de sus empleados y consultores y realizará esfuerzos comercialmente razonables para vigilar a sus empleados.',
          characteristics_paragraph_18:
            'Wispro se reserva el derecho de desactivar su cuenta o tomar cualquier otra acción que Wispro, a su exclusivo criterio, considere necesarias o convenientes, incluyendo una acción legal, en caso de que Wispro tenga razones para creer que usted ha violado los términos de esta Sección.',
          characteristics_subtitle: '6.1. Características.',
          comments_paragraph_1:
            'Wispro tendrá una licencia mundial, perpetua, libre de regalías para utilizar o incorporar a los Servicios de sugerencias, ideas, solicitudes de mejora, recomendaciones u otra información proporcionada por usted en relación con el funcionamiento del Servicio (“Comentarios”).',
          comments_subtitle: '4.6. Comentarios.',
          confidentiality_paragraph_1:
            'Deberá mantener la confidencialidad de la información que ha sido, y continuará siendo, proporcionado a Usted por Wispro en relación con su uso del Servicio. Usted expresamente acepta los siguientes términos de confidencialidad (los “Términos de confidencialidad”):',
          confidentiality_paragraph_2:
            '4.7.1. Obligaciones. Usted deberá (a) mantener la confidencialidad de toda la información, incluyendo pero no limitado a, el Servicio y el software relacionado, (b) no divulgar tal información a nadie, excepto a sus empleados, agentes y consultores sobre la base de la necesidad de conocer (y que han sido informados y reconocer su obligación de estar obligado por estas condiciones de confidencialidad), y © no utilizará la información confidencial de Wispro para cualquier fin distinto de aquel para el que se da a conocer. Toda la información confidencial quedará en propiedad exclusiva de Wispro. Usted no tendrá ningún derecho, título o interés en o para la información confidencial.',
          confidentiality_paragraph_3:
            '4.7.2. Información Confidencial. La información considerada confidencial por Wispro incluye, sin limitación, la información de Wispro en relación con (a) los asuntos de carácter técnico, como procesos secretos comerciales o dispositivos, know-how, datos, fórmulas, invenciones (patentables o no, o derechos de autor), especificaciones y características de los productos o servicios de los sujetos de investigación, métodos y resultados, (b) las cuestiones de carácter empresarial, tales como la información sobre los costos, beneficios, precios, políticas, mercados, ventas, proveedores, clientes, planes de productos planeados o en desarrollo, y, y conceptos de negocio, planes o estrategias, © las cuestiones de carácter recursos humanos, tales como las políticas y prácticas de empleo, de personal, compensación y beneficios de los empleados, (d) cualquier otra información de naturaleza similar no ha sido revelado generalmente por Wispro al público u otra información que usted debe creer razonablemente que sea confidencial, dadas las circunstancias, (e) la información relativa a su uso del Servicio, y (f) del propio servicio y su software asociado.',
          confidentiality_paragraph_4:
            '4.7.3. Exclusiones. Las obligaciones impuestas por estas condiciones de confidencialidad no se aplicarán a ninguna información que (a) se ha demostrado por Usted que ha sido obtenida legalmente de un tercero sin el acompañamiento de uso o divulgación restricciones; (b) es o se hace generalmente a disposición del público a través de ningún hecho ilícito de Usted o cualquier otra persona o entidad con obligación de confidencialidad; © ya se conoce a usted antes de la fecha de divulgación como lo demuestra la documentación que lleva una fecha anterior a la fecha de la divulgación; (d) está aprobado para su liberación por escrito por un representante autorizado de Wispro; (e) o la obligación de ser revelada de acuerdo con una orden judicial válida, citación debidamente autorizada, o autoridad gubernamental (siempre que daréis inmediatamente Wispro aviso por escrito y la oportunidad de impugnar dicha revelación requerida).',
          confidentiality_paragraph_5:
            '4.7.4. Remedios. El remedio a la ley en caso de incumplimiento de cualquiera de los convenios y acuerdos establecidos en estas condiciones de confidencialidad puede ser insuficiente, por lo que en caso de cualquier incumplimiento o amenaza de incumplimiento, Wispro deberá, además de todos los demás recursos que puedan estar disponibles para que en la ley, derecho a una reparación equitativa en forma de medidas cautelares preliminares y permanentes, sin la necesidad de probar daños. Asimismo, acepta que estas condiciones de confidencialidad no será en modo restringir o limitar de cualquier otro recurso Wispro puede tener disponibles en la ley y Wispro puede tener derecho a recuperar los costos, incluyendo los honorarios razonables de abogados, para hacer valer sus derechos en virtud de estas condiciones de confidencialidad.',
          confidentiality_paragraph_6:
            '4.7.5. Retorno de la Información Confidencial. A petición por escrito de Wispro, deberá devolver o acreditar que has destruido, toda la información revelada en estas condiciones de confidencialidad y cualesquier memorandos, diagramas o cualquier otro documento que contenga cualquier información revelada en estas condiciones de confidencialidad.',
          confidentiality_paragraph_7:
            '4.7.6. Exigibilidad. En el caso de una o más de las disposiciones de estas condiciones de confidencialidad se considerará inválida, ilegal o no ejecutable en cualquier aspecto, la validez, legalidad y aplicabilidad de las restantes disposiciones contenidas en este documento no podrá de ninguna manera ser afectada o dañada por el mismo.',
          confidentiality_paragraph_8:
            '4.7.7. Aplicación. Estas condiciones de confidencialidad deberán controlar en lugar de y sin perjuicio de las leyendas o declaraciones de propiedad o restrictivas incompatibles con estas condiciones de confidencialidad que pueden estar asociados con ninguna información particular descrita a continuación.',
          confidentiality_paragraph_9:
            '4.7.8. Sobrevivir a las Obligaciones. Las obligaciones de confidencialidad impuestas por estas condiciones de confidencialidad sobrevivirán a cualquier terminación, expiración o la rescisión de estos Términos o su período de suscripción, además de continuar más allá de cualquier momento en el que estaba utilizando el Servicio.',
          confidentiality_subtitle: '4.7. Confidencialidad.',
          credit_card_auth_paragraph_1:
            'En caso de que usted cancela su tarjeta de crédito a Wispro que pagar por el servicio o la tarjeta expira o es terminado por cualquier motivo, usted debe proporcionar de inmediato Wispro con un nuevo número de tarjeta de crédito válida. Usted autoriza a Wispro, de vez en cuando, para llevar a cabo las medidas necesarias para determinar si el número de tarjeta de crédito proporcionada a Wispro es un número de tarjeta de crédito válida. En caso de que Usted no proporciona Wispro con un número de tarjeta de crédito en vigor al día con suficiente crédito a petición durante el período de vigencia de las presentes Condiciones, Usted estará en violación de estos Términos. Usted autoriza Wispro para actualizar automáticamente su información de tarjeta de crédito a través de un software diseñado para los propósitos de la actualización.',
          credit_card_auth_subtitle: '3.3. Autorización de la tarjeta de crédito.',
          disclaimer_of_risk_activity_paragraph_1:
            'Los servicios no son tolerante a fallos y no están diseñados, fabricados o diseñados para su uso o reventa como equipos de control o con en línea en entornos peligrosos que requieran un rendimiento a prueba de fallos, incluyendo, pero no limitado a, el equipo utilizado para operar las instalaciones nucleares, sistemas de comunicación y navegación aérea de aviones o el control del tráfico aéreo, máquinas de auxilio vital o sistemas de armamento, en los que el fracaso de los servicios podría conducir directamente a la muerte, lesiones personales o daños físicos o ambientales severos (“Actividades de Alto riesgo”). En consecuencia, Wispro y sus proveedores niegan específicamente cualquier garantía expresa o implícita de idoneidad para tales actividades de alto riesgo.',
          disclaimer_of_risk_activity_subtitle: '4.8. Descargo de Actividades de Alto Riesgo.',
          divisibility_paragraph_1:
            'Si cualquiera de las disposiciones de estas Condiciones fuera ilegal, nula o por cualquier razón inaplicable, dicha disposición se considerará separable de estos Términos y no afectará la validez y aplicabilidad de las disposiciones restantes.',
          divisibility_subtitle: '5.3. Divisibilidad.',
          entire_agreement_condition_paragraph_1:
            'Wispro podrá modificar estos Términos en cualquier momento mediante (i) la publicación de un documento revisado Condiciones (ii) el envío de información acerca de los términos enmienda a la dirección de correo electrónico que nos ha proporcionado. Ud. es responsable de revisar regularmente el sitio para estar al tanto de tales cambios.',
          entire_agreement_condition_subtitle: '5.1. Condiciones Acuerdo completo.',
          final_user_conduct_paragraph:
            'Usted es el único responsable por el contenido de su computadora (s) y su cuenta de Wispro y las transmisiones realizadas al utilizar los Servicios. Su uso de los Servicios están sujetos a los términos establecidos en el presente documento y todas las leyes, reglas y regulaciones, incluyendo locales, estatales, leyes nacionales e internacionales, normas y regulaciones (incluyendo, sin limitación, los que rigen la vida privada, la colección cuenta, el control de las exportaciones, de los consumidores la protección, la competencia desleal, antidiscriminación o falsa publicidad). Al utilizar cualquiera de los Servicios de la presente, usted acepta: (i) cumplir con todas las leyes, reglas y regulaciones, incluyendo locales, estatales, leyes nacionales e internacionales, normas y regulaciones (incluyendo, sin limitación, los que rigen la vida privada, la colección cuenta, el control de las exportaciones, protección al consumidor, competencia desleal, antidiscriminación o la publicidad engañosa); (ii) no utilizar el Servicio para publicar, distribuir, o poner a disposición o transmitir cualquier software u otros archivos de computadora que contienen un virus, troyano, gusano u otro componente dañino o destructivo; (iii) no utilizar el Servicio para fines ilegales; (iv) no eliminar del Servicio o de su software relacionado, la documentación o cualquier sitio web de Wispro utilizado en relación con el Servicio, cualquier aviso legal, renuncias, o de propiedad, tales como derechos de autor o avisos de marca registrada, o modificar cualquier logotipo que NO propia o tener permiso expreso de modificar; (v) no utilizar el Servicio para interferir o interrumpir las otras redes conectadas al Servicio; (vi) no utilizar el Servicio para infringir los derechos de autor de terceros, patentes, marcas, secretos comerciales u otros derechos de propiedad o derechos de publicidad o privacidad; y (vii) no utilizar el Servicio para distribuir cualquier material ilegal, de acoso, de material calumnioso, difamatorio, racista, indecente, abusivo, violento, amenazante, intimidante, perjudicial, vulgar, obsceno, ofensivo u objetable de cualquier tipo o naturaleza. Usted no podrá acceder ni utilizar la cuenta de Wispro de otra persona en cualquier momento, sin obtener primero el permiso del titular de la cuenta. Usted acepta que es responsable de todas las acciones y omisiones de sus empleados, consultores, o cualquier otro tercero que le permiten acceder a su cuenta de Wispro, y Usted se compromete a realizar esfuerzos comerciales razonables para controlar dichos terceros usuarios. Wispro se reserva el derecho de desactivar su cuenta o tomar cualquier otra acción que Wispro a su exclusivo criterio, considere necesarias o apropiadas en caso de que Wispro tiene razones para creer que su conducta durante el uso de cualquiera de los Servicios ha violado los términos de esta Sección 2.2.',
          final_user_conduct_subtitle: '2.2. Conducta para el usuario final.',
          force_majeure_paragraph_1:
            'No será responsable por cualquier falla de rendimiento, retraso en el cumplimiento, o la pérdida de datos en virtud de estos Términos (que no sea por el retraso en el pago de dinero adeudado y pagadero a continuación) en la medida dijo que los fallos o retrasos están causados directamente por: (i) los fallos de software o cualquier otra programación de computadoras (que no sea el servicio adquirido a continuación), (ii) los fenómenos meteorológicos naturales, o (iii) cualquier otra causa más allá del control razonable de dicha parte y que ocurre sin su culpa o negligencia, incluyendo, sin limitación, la falta de proveedores, subcontratistas, y los transportistas, a condición de que, en cualquier caso, como condición para la reclamación de exención del pago, la parte que experimenta la dificultad que dará a la otra notificación escrita inmediata, con todos los detalles después de la aparición de la causa invocada.',
          force_majeure_subtitle: '4.10.Fuerza Mayor.',
          guarantee_disclaimer_paragraph_1:
            'Aunque Wispro ha intentado ofrecer información precisa con respecto al Servicio, Wispro no asume ninguna responsabilidad por la exactitud o inexactitud de la información proporcionada. La mención de productos o servicios de Wispro es únicamente con fines informativos y no constituye aprobación ni recomendación. El uso de cualquiera de los Servicios es bajo su propio riesgo. TODA LA INFORMACIÓN, DOCUMENTACIÓN Y SERVICIOS PRESTADOS POR Wispro SE OFRECEN “TAL CUAL” SIN GARANTÍA DE NINGÚN TIPO, EXPRESA O IMPLÍCITA, Wispro RECHAZA EXPRESAMENTE TODAS LAS GARANTÍAS, CONDICIONES, REPRESENTACIONES Y GARANTÍAS CON RESPECTO AL SERVICIO, YA SEA EXPRESA O IMPLÍCITA, DERIVADA DE LA LEY, COSTUMBRE, exposiciones orales o escritas ANTERIORES, O DE OTRA MANERA. Wispro NO GARANTIZA QUE EL SERVICIO CUMPLIRÁ CON SUS NECESIDADES O QUE EL SERVICIO SERÁ ININTERRUMPIDO, PUNTUAL O ERRORES. TAMPOCO Wispro NINGUNA GARANTÍA EN CUANTO A LOS RESULTADOS QUE SE PUEDEN OBTENER DEL USO DEL SERVICIO O LA EXACTITUD DE LA INFORMACIÓN OBTENIDA A TRAVÉS DEL SERVICIO. USTED RECONOCE Y ACEPTA QUE CUALQUIER MATERIAL Y / O DATOS DESCARGADO U OBTENIDO A TRAVÉS DEL USO DEL SERVICIO SE HACE A SU PROPIO RIESGO Y QUE USTED SERÁ EL ÓNICO RESPONSABLE DE CUALQUIER DAÓO A CUALQUIER SISTEMA INFORMÁTICO O PÉRDIDA DE DATOS RESULTANTE DE LA DESCARGA DE DICHO MATERIAL Y / O DATOS. NINGUNA REPRESENTACIÓN O OTRA AFIRMACIÓN DE HECHO, INCLUYENDO, SIN LIMITACIÓN, LAS DECLARACIONES RESPECTO DE CAPACIDAD, IDONEIDAD PARA EL USO O LA EJECUCIÓN DE LOS SERVICIOS, YA SEA REALIZADO POR EMPLEADO DE Wispro O DE OTRA MANERA, que no es parte del presente acuerdo, se considerará como una garantía POR Wispro PARA CUALQUIER PROPÓSITO, O DAR LUGAR A NINGUNA RESPONSABILIDAD DE NINGÚN TIPO.',
          guarantee_disclaimer_subtitle: '4.1. Exclusión de garantías.',
          ilicit_use_paragraph_1:
            'Wispro, no se responsabiliza del uso ilícito de internet bajo ningún concepto, ya que Wispro no es quien distribuye o vende internet a los usuarios.',
          ilicit_use_subtitle: '6.3. Uso ilícito.',
          laws_of_chile_subtitle:
            '4.9.Compliance con Leyes de Exportación de Servicios y normativas de su software relacionado están sujetos a leyes de Chile.',
          legal_terms_title: 'Artículo IV. Términos legales',
          licensing_paragraph:
            'Wispro otorga a Usted una licencia libre de regalías, no exclusiva, mundial, no transferible, y la licencia para el acceso y uso del software sujeto a las restricciones establecidas en las presentes Condiciones. El servicio es propiedad y está operado por Wispro y se proporciona a Usted por suscripción; Wispro no está transfiriendo la propiedad o la titularidad del servicio.',
          licensing_sub_item_paragraph_1:
            '2.1.1. El servicio está disponible para su descarga solamente para su uso por Usted y solamente de acuerdo con estos Términos. Cualquier reproducción, reventa o redistribución del servicio que no está de acuerdo con estas Condiciones está expresamente prohibida, y puede resultar en sanciones civiles y penales. Los infractores serán perseguidos en la máxima medida posible. La licencia otorgada no podrá ser transferida por Usted a terceros y no es exclusiva.',
          licensing_sub_item_paragraph_2:
            '2.1.2. Usted reconoce que los Servicios y su software son propiedad de Wispro y / o de sus proveedores y están protegidos por derechos de autor, marcas comerciales, marcas de servicio, patentes y / u otros derechos de propiedad y leyes. Usted no puede eliminar ningún aviso de propiedad o etiquetas de cualquiera de los Servicios. No se puede alterar, modificar, distribuir, vender, subastar, descompilar, realizar ingeniería inversa, desmontar o reducir algunos de los Servicios a un formato legible. Usted no puede reproducir, distribuir o crear trabajos derivados basados en los Servicios sin haber sido autorizado expresamente por escrito para ello por Wispro. Además, Usted no puede alquilar, arrendar, otorgar un derecho de garantía o de otro modo transferir ningún derecho a los Servicios. Todos los derechos no expresamente concedidos en estos términos están reservados a Wispro y sus proveedores.',
          licensing_sub_item_paragraph_3:
            '2.1.3. La licencia otorgada en virtud del presente da derecho a recibir cualquiera y todas las actualizaciones y apoyo que Wispro proporciona estándar a todos los usuarios de sus servicios, por lo general. No obstante lo anterior, Wispro se reserva el derecho de cobrar la totalidad de sus cuotas a los usuarios de las versiones futuras. Usted entiende que Wispro puede actualizar o modificar cualquiera de los servicios y su software relacionado en cualquier momento, pero no tiene la obligación de informar a usted de cualquiera de dichos cambios o modificaciones. Para evitar cualquier duda, a menos que Wispro decide proporcionar tales cambios o modificaciones a todos sus usuarios, estas Condiciones no otorgan Usted ningún derecho, licencia o interés en o para cualquier prima o apoyo “VIP”, mantenimiento, mejoras, modificaciones, mejoras o actualizaciones de los Servicios o el software relacionado. En la medida en que Wispro proporciona las actualizaciones o mejoras a Usted, serán considerados como sujetos a estos términos, a menos Wispro indica lo contrario.',
          licensing_sub_item_paragraph_4:
            '2.1.4. CUALQUIER Y TODO EL CONTENIDO DE LOS PROGRAMAS DE SITIOS WEB, software y equipos asociados a los servicios están protegidos por copyright y otras leyes de propiedad intelectual. Excepto aquello específicamente permitido, NINGUNA PARTE DE LA INFORMACIÓN O CONTENIDO DE DICHOS SITIOS WEB, software y programas informáticos puede ser reproducida en cualquier forma y por cualquier medio, sin el permiso escrito ANTES DE Wispro. USTED Y CUALQUIER OTRO VISITANTE O USUARIO no están autorizados a modificar, distribuir, publicar, transmitir o crear trabajos derivados de cualquier material que aparecen en dichas páginas web, software y programas informáticos PARA CUALQUIER FINALIDAD PÓBLICA O COMERCIAL.',
          licensing_subtitle: '2.1. Concesión de licencia.',
          limitations_of_liability_paragraph_1:
            '4.2.1. USTED ACEPTA QUE NO INCLUYE LA ASUNCIÓN DEL RIESGO DE SU ESPECIAL, CONSECUENTE, INCIDENTAL U OTROS DAÑOS INDIRECTOS. Wispro Y SUS PROVEEDORES NO SERÁN RESPONSABLES POR CUALQUIER DAÑO ESPECIAL, CONSECUENTE, INCIDENTAL U OTROS DAÑOS INDIRECTOS, INCLUYENDO, SIN LIMITACIÓN, PÉRDIDA DE BENEFICIOS O INGRESOS, COSTOS DE LOS PRODUCTOS O SERVICIOS DE REEMPLAZO, PÉRDIDA O DAÑO A LA INFORMACIÓN O DATOS DERIVADOS DEL USO O IMPOSIBILIDAD USAR EL SERVICIO. BAJO NINGUNA CIRCUNSTANCIA, INCLUYENDO, PERO NO LIMITADA A, NEGLIGENCIA, Wispro NO ES RESPONSABLE POR DAÑOS CAUSADOS POR EL USO DEL SERVICIO, O DEPENDENCIA DE LA INFORMACIÓN PRESENTADA EN RELACIÓN CON EL SERVICIO, AUNQUE Wispro O SUS PROVEEDORES HAYAN SIDO INFORMADOS DE LA POSIBILIDAD DE TALES DAÑOS. USTED ESTÁ DE ACUERDO NO HACER VALER CUALQUIER RECLAMACIÓN CONTRA Wispro O SUS SUBSIDIARIAS O AFILIADOS O SUS RESPECTIVOS OFICIALES, DIRECTORES, EMPLEADOS.',
          limitations_of_liability_paragraph_2:
            '4.2.2. USTED ACEPTA QUE EL USO DEL SERVICIO ES BAJO SU PROPIO RIESGO. EN NINGÚN CASO LA RESPONSABILIDAD TOTAL DE Wispro DE TODOS LOS DAÑOS, PÉRDIDAS Y CAUSAS DE ACCIÓN (YA SEA EN CONTRATO, AGRAVIO U OTRO) EXCEDERÁ EL IMPORTE PAGADO A Wispro, EN SU CASO, POR EL SERVICIO DURANTE LOS 12 MESES INMEDIATAMENTE ANTES DE LA RECLAMACIÓN. EN CASO DE QUE LA LEY APLICABLE LIMITA LA EXCLUSIÓN DE GARANTÍAS IMPLÍCITAS O LAS LIMITACIONES DE RESPONSABILIDAD, POR EL MONTO MÁXIMO DE EXCLUSIONES PERMITIDAS POR LA LEY APLICABLE SERÁ APLICADA.',
          limitations_of_liability_paragraph_3:
            '4.2.3. TODAS LAS RENUNCIAS, LIMITACIONES DE GARANTÍAS Y DAÑOS Y COMPROMISOS CONFIDENCIALES ESTABLECEN EN ESTOS TÉRMINOS O DE OTRO EXISTENTE EN LA LEY (1) SON DE LA ESENCIA DEL ACUERDO DE LAS PARTES, Y (2) sobrevivirán a cualquier terminación, expiración o rescisión DE ESTOS TÉRMINOS .',
          limitations_of_liability_subtitle: 'Limitaciones de los daños y de responsabilidad civil.',
          no_cancelations_paragraph_1:
            'No obstante cualquier disposición de estos Términos o cualquier curso de las negociaciones entre las partes, no se puede cancelar, terminar o rescindir una suscripción durante su vigencia. Todas y todos los pagos por usted a Wispro para el acceso a los Servicios son finales.',
          no_cancelations_subtitle: '3.2. No hay cancelaciones.',
          non_exclusivity_paragraph_1:
            'Ud. reconoce y acepta que Wispro está en el negocio de proporcionar soluciones para ISP’s y que Wispro puede proporcionar este tipo de servicios a terceros, incluidas posibles competidores de Usted, que son iguales o similar a los servicios prestados a usted a continuación.',
          non_exclusivity_subtitle: '5.7.No Exclusividad.',
          notifications_paragraph_1:
            'Wispro puede enviar a la dirección de correo electrónico que usted proporciona en el formulario de registro o de otra manera por cualquier medio que Wispro determine a su sola discreción. SI usted quiere enviar a Wispro cualquier notificación, en relación con estos términos deberán ser por escrito y enviada por correo de primera clase o correo certificado (recibo se considerará 72 horas después de franqueo y con acuse de recibo), o entregada personalmente a la dirección de Wispro proclamados en esta Declaración.',
          notifications_subtitle: '5.3. Notificaciones.',
          ownership_paragraph_1:
            'La titularidad, los derechos de propiedad y derechos de propiedad intelectual en el Servicio será propiedad de la Wispro o sus proveedores, según corresponda. El Servicio está protegido por derechos de autor y otras leyes de propiedad intelectual y por tratados internacionales. Título y derechos afines en el contenido al que acceda a través del Servicio es propiedad del propietario del contenido y está protegido por la ley aplicable. Las licencias concedidas en virtud de estos Términos, usted da ningún derecho sobre dicho contenido. “Wispro”, los logotipos asociados, y otros nombres, logotipos, iconos y marcas que identifican Servicios de Wispro son marcas comerciales o marcas de servicio de Wispro (colectivamente las “Marcas”) y no se puede usar sin el permiso previo por escrito de Wispro. Todos los demás nombres de productos mencionados se utilizan con fines de identificación únicamente y pueden ser marcas comerciales o marcas de servicio de sus respectivos propietarios. Nada debe ser interpretado como una concesión, por implicación, impedimento, o de otra manera, de cualquier licencia o derecho a usar cualquier marca registrada sin el permiso por escrito de Wispro o del tercero que sea propietario de las Marcas. El uso de las marcas comerciales, salvo lo dispuesto en estas Condiciones está estrictamente prohibido.',
          ownership_subtitle: '4.5. Título.',
          password_and_securuty_paragraph:
            'Ciertos servicios prestados por Wispro continuación requieren el uso de una dirección de correo electrónico para crear un nombre de usuario y elija una contraseña para acceder a su cuenta de Wispro (por razones de seguridad, Wispro recomienda elegir una contraseña para el servicio diferente del nombre de usuario y contraseña usado en su ordenador). Wispro no envía correos electrónicos solicitando Wispro nombre de usuario y / o contraseña de un usuario o cualquier otro nombre de usuario o contraseña. Para mantener el servicio seguro, Usted debe mantener todos los nombres de usuario y contraseñas confidenciales. El acceso a, y uso de, los aspectos protegidos por contraseña y / o seguridad de los servicios se limitan únicamente a los usuarios autorizados. Los individuos no autorizados que intenten utilizar cualquiera de los Servicios pueden ser objeto de enjuiciamiento. Usted se compromete a salvaguardar cuidadosamente todas sus contraseñas. Wispro no mantiene una base de datos de contraseñas de usuario por lo que Usted es el único responsable si usted no mantiene la confidencialidad de sus contraseñas e información de cuenta. Además, Usted es el único responsable de cualquier y toda actividad que ocurra bajo su cuenta. Wispro no se hace responsable de cualquier pérdida incurrida por usted como resultado de su uso de otra de su contraseña, cuenta o clave pública / privada, como puede ser el caso, ya sea con o sin su conocimiento. Sin embargo, usted puede ser responsable por las pérdidas sufridas por Wispro u otra parte debido al uso de su contraseña, cuenta o clave pública / privada de otra persona, como puede ser el caso, ya sea con o sin su conocimiento. Usted se compromete a notificar inmediatamente a Wispro de cualquier uso no autorizado de su cuenta o cualquier otra sospecha de violación de la seguridad que tenga conocimiento, incluyendo si usted cree que su contraseña y / o información de la cuenta ha sido robada o de otra manera comprometida.',
          password_and_securuty_subtitle: '2.3. Contraseñas de la cuenta y de Seguridad.',
          payment_due_date_paragraph_1:
            'Salvo disposición en contrario en el presente documento, el pago de todas las cuotas se deben pagar a Wispro y sin demanda, la facturación o el aviso antes del inicio del período de suscripción al que se aplican esas tasas.',
          payment_due_date_subtitle: '3.5. Vencimiento de Pago.',
          paypal_pay_paragraph_1: 'Wispro no acepta el pago a través de PayPal ®.',
          paypal_pay_subtitle: '3.4. El pago a través de PayPal ®.',
          personal_info_paragraph:
            'Cuando se utiliza cierto Servicio (s) proporcionado por Wispro a continuación, puede ser posible que usted pueda intercambiar limitada información personal identificable (“PII”) con Wispro. Su consentimiento a estos Términos constituye un entendimiento y acuerdo expreso que cuando PII se proporciona a Wispro en relación con los Servicios, a través de cualquiera de los sitios web de Wispro.',
          personal_info_subtitle: '1.2. Información de Identificación Personal.',
          publicity_paragraph_1:
            'Wispro tendrá el derecho a identificar a usted como usuario del Servicio . Se autoriza expresamente la publicidad en un mapa geolocalizando al usuario del servicio de acuerdo al domicilio proporcionado por estos en el formulario de registro..',
          publicity_subtitle: '5.4. Publicidad.',
          reparations_paragraph_1:
            'Usted es responsable de mantener la confidencialidad de su cuenta y contraseña (s). Usted también es responsable de todas las actividades que ocurran bajo su cuenta. Por lo tanto, Usted acepta indemnizar, defender y mantener a Wispro y sus proveedores afiliados, empleados, funcionarios, directores, propietarios, información, agentes, licenciatarios, licenciantes (las “Partes indemnizadas”) de y contra cualquier y toda responsabilidad, reclamos, costos, incluyendo los honorarios razonables de abogados, incurridos por las Partes indemnizadas en relación con cualquier demanda de terceros, demandas, acción, demanda o pérdida que surja como resultado de (a) cualquier incumplimiento por su parte de estas condiciones de uso o reclamaciones surgidas de su cuenta; (b) cualquier fraude o manipulación por parte de Usted; © una reclamación de un tercero, la acción o de una alegación de infracción sobre la base de información, datos, archivos u otro contenido enviado por usted; o (d) cualquier reclamo de fraude de tarjetas de crédito basadas en la información publicada por usted. Usted se compromete a utilizar los mejores esfuerzos para cooperar con los países de Wispro en la defensa de cualquier demanda, reclamo, acción o demanda. Wispro se reserva el derecho de asumir la defensa exclusiva de cualquier asunto sujeto a indemnización por Usted a su costa Wispro.',
          reparations_subtitle: '4.3. Indemnización.',
          sales_promo_offers_etc_paragraph_1:
            'Ventas, promociones y otras ofertas de precios especiales con descuento son temporales y en la renovación de su suscripción, dichas ofertas de precios reducidos pueden caducar. Wispro se reserva el derecho de discontinuar o modificar cualquier cupón, créditos, ventas y ofertas especiales de promoción a su entera discreción.',
          sales_promo_offers_etc_subtitle: '3.7. Ventas, ofertas promocionales, cupones, créditos.',
          saving_navigational_info_paragraph_1:
            'Wispro no se hace responsable del incumplimiento de las normativas vigentes locales o internacionales respecto a la conservación de la información de navegación de los usuarios del ISP.',
          saving_navigational_info_subtitle: '6.2. Guarda de información de navegación.',
          service_data_paragraph:
            'Al utilizar los Servicios Wispro Usted puede ver, recopilar, transmitir, almacenar y compartir ciertos datos, información, archivos, etc. Wispro no posee ningún servicio de datos y se exime de cualquier responsabilidad por cualquier servicio de datos que usted o cualquier otro usuario recoge o produce al utilizar el Servicio. Wispro acepta que estas Condiciones no otorgan ningún derecho de propiedad a Wispro a datos de servicio.',
          service_data_subtitle: '1.3. Datos de servicio.',
          taxes_paragraph_1:
            'Usted acepta ser responsable y pagar cualquier venta aplicables, bienes personales, el uso, el IVA, los impuestos especiales, la negación o cualquier otro impuesto que se pueden imponer, a partir de esta licencia, o el uso o posesión de un servicio, o cualquier otro software u otro producto, siempre bajo estos términos, excluidos los impuestos basados en los ingresos netos liquidables por Wispro. Si está exento del pago de cualquier venta, uso u otros impuestos, debe proporcionar Wispro con las correspondientes pruebas de exención de impuestos para todas las jurisdicciones pertinentes.',
          taxes_subtitle: '3.6. Impuestos.',
          term_and_termination_paragraph_1:
            'Wispro puede, a su sola discreción, cancelar inmediatamente su suscripción, licencia y derecho a utilizar el servicio si (i) usted no puede hacer los pagos a tiempo de las cuotas de suscripción como se requiere para el acceso a su cuenta o se declara la quiebra, está involucrado en un procedimiento de quiebra procedimientos o están en estado de insolvencia; (ii) incumple estos Términos; (iii) Wispro no puede verificar o autenticar cualquier información que proporcione a Wispro; o (iv) Wispro decide, a su sola discreción, a dejar de ofrecer el servicio a sus usuarios. Wispro no será responsable ante usted ni ante terceros por la terminación del Servicio o de su uso del Servicio. Tras la expiración o terminación por cualquier razón, usted ya no estará autorizado a utilizar el Servicio. Cuando su acceso al Servicio es terminado y / o su suscripción sea cancelada, usted ya no tendrá acceso a los datos y otros materiales que usted puede tener almacenados en relación con el Servicio y que los materiales pueden ser borrados por Wispro. Todas las renuncias, las limitaciones de garantías y daños, y los compromisos confidenciales establecidas en estos Términos o ya existente a la ley no desaparecen con la terminación, expiración o la rescisión de estos Términos.',
          term_and_termination_subtitle: '4.4. Derecho de terminar.',
          terms_and_conditions_info_paragraph:
            'IMPORTANTE – POR FAVOR LEA ESTOS TÉRMINOS Y CONDICIONES AL COMPRAR O USAR LOS SERVICIOS Y / O SOFTWARE COTIZADOS DE WISPRO.',
          terms_and_conditions_info_paragraph_2:
            'Estos términos y condiciones (“Términos”) regulan el uso y licencia de Wispro ® SuperCache ®, (en conjunto, los “Servicios”, y cada una "Servicio"). Cada servicio puede tener términos y condiciones que son únicas en sus funciones y características particulares adicionales. Le animamos a leer las Condiciones específicas de servicio antes de comprar o usar cualquier Servicio. Al completar el proceso de aceptación electrónica, pulsando el botón “Enviar” o “Aceptar”, utilizando cualquiera de los SERVICIOS, INDICA LA ACEPTACIÓN DE ESTOS TÉRMINOS, DECLARA Y GARANTIZA QUE: (i) USTED ESTÁ AUTORIZADO PARA OBLIGAR A USTED Y A CUALQUIER OTRA PERSONA EN CUYO NOMBRE HAGA REFERENCIA PARA USAR EL SERVICIO Y / O EL SOFTWARE; Y (ii) SE COMPROMETE A CUMPLIR CON TODOS ESTOS TÉRMINOS, INCLUYENDO LA EXCLUSIÓN DE GARANTÍAS Y LIMITACIÓN DE RESPONSABILIDADES INDICADA MÁS ADELANTE con exclusión de cualesquiera otros derechos y obligaciones.',
          terms_and_conditions_info_title: 'Términos y condiciones de uso de servicios en la nube de Wispro',
          terms_fees_renewals_title: 'Artículo III. Términos, Tasas y Renovaciones pago',
          terms_of_assigment_paragraph_1:
            'Wispro puede ceder este Acuerdo, sin el consentimiento previo y por escrito en relación con una fusión, adquisición, cambio del control o la venta de sustancialmente todos sus activos (o de cualquier transacción sustancialmente similar). Además, Wispro podrán delegar todas o parte de la ejecución de este Contrato a una entidad participada, sin su previo y por escrito consent. Â ',
          terms_of_assigment_subtitle: '5.8. Términos Asignación.',
          various_terms_of_service_title: 'Artículo V. Varias Condiciones del servicio.',
          waiver_paragraph_1:
            'Ud. se compromete a no presentar o participar en cualquier demanda colectiva contra Wispro o cualquiera de sus empleados o affiliates. Ud. se compromete a no presentar una demanda en virtud de estos Términos de más de dos años después de la expiración de estos Términos.',
          waiver_subtitle: '5.6. Renuncia.',
          your_data_paragraph:
            'Para utilizar los Servicios, el Cliente deberá completar y presentar un formulario de inscripción en línea (el “Formulario de Registro”). Como parte de este proceso de registro, usted acepta: (i) proporcionar cierta información limitada sobre usted mismo como se le indique durante el proceso de registro o posteriormente por el Servicio (tal información sea actual, completa y exacta) y (ii) mantener y actualizar esta información según sea necesario para mantenerla actualizada, completa y precisa. La información que se solicita en el momento de la signup inicial se conoce como datos de la cuenta (la “Cuenta de datos”). Wispro puede tener un acceso limitado a los datos que se pueden almacenar, crear, compartir, o mostrarse a través del Servicio, que se empleará exclusivamente para brindar el Servicio. La Política de Privacidad describe cómo los datos de la Cuenta podrá ser recopilada, utilizada y divulgada. Usted no puede registrarse para cualquier servicio si usted es menor de 18 años de edad. Al registrarse, usted declara que Wispro que tiene 18 años de edad o más. Si Wispro descubre que cualquier información de su cuenta de datos es inexacta, incompleta o no actualizada, o si Wispro determina, a su entera discreción, que usted no es un suscriptor o usuario del servicio adecuado, Wispro puede terminar inmediatamente su derecho a acceder, recibir, usar, autorizar el Servicio y el software relacionado.',
          your_data_subtitle: '1.1. Datos de su cuenta.',
          your_data_title: 'Artículo I. Sus Datos'
        }
      },
      title: 'Estimado usuario de Wispro',
      // views.cloud_license.transactions.transaction.status.succeeded
      transactions: {
        loading_transactions: 'Cargando transacciones...',
        status: {
          failed: 'Falló',
          pending: 'Pendiente',
          refunded: 'Reembolsado',
          succeeded: 'Exitoso'
        },
        there_are_no_transactions_to_display: 'No hay transacciones para mostrar',
        transaction: {
          approved_by_network: 'Aprobado',
          authorized: 'Autorizado',
          blocked: 'Bloqueado',
          declined_by_network: 'Rechazado',
          elevated: 'Elevado',
          failure_code: {
            approve_with_id: 'El pago no pudo ser procesado',
            call_issuer: 'Tarjeta rechazada. Por favor contacte a su banco.',
            card_declined: 'Tarjeta rechazada.',
            card_not_supported: 'Tarjeta no permitida',
            card_velocity_exceeded: 'Límite de la tarjeta excedido',
            currency_not_supported: 'Currency no permitida',
            do_not_honor: 'Tarjeta rechazada por razón desconocida (1). Por favor contacte a su banco.',
            do_not_try_again: 'Tarjeta rechazada por razón desconocida (2). Por favor contacte a su banco.',
            duplicate_transaction: 'Transacción duplicada',
            expired_card: 'Tarjeta expirada',
            fraudulent: 'Tarjeta Rechazada, Stripe sospecha que es fraudulenta',
            generic_decline: 'Tarjeta rechazada por razón desconocida (3). Por favor contacte a su banco.',
            incorrect_cvc: 'Número de cvc es incorrecto',
            incorrect_number: 'El número de tarjeta es incorrecto',
            incorrect_zip: 'ZIP/postal code es incorrecto',
            insufficient_funds: 'La tarjeta no tiene fondos suficientes',
            invalid_account: 'La tarjeta o cuenta a la que está conectada la tarjeta no es válida.',
            invalid_amount: 'El monto del pago no es válido o excede la cantidad permitida',
            invalid_cvc: 'Número CVC es incorrecto',
            invalid_expiry_month: 'Mes de expiración no válido',
            invalid_expiry_year: 'Año de expiración no válido',
            invalid_number: 'El número de tarjeta es incorrecto',
            issuer_not_available: 'El emisor de la tarjeta no pudo ser contactado',
            lost_card: 'La tarjeta fue reportada perdida',
            missing: 'No tiene una tarjeta associada',
            new_account_information_available: 'La tarjeta o cuenta a la que está conectada la tarjeta no es válida.',
            no_action_taken: 'Tarjeta rechazada por razón desconocida (4). Por favor contacte a su banco.',
            not_permitted: 'pago no permido',
            payment_method_provider_decline: 'Rechazo del proveedor del método de pago',
            pickup_card:
              'La tarjeta no se puede usar para realizar este pago (es posible que se haya informado de pérdida o robo)',
            pin_try_exceeded: 'Se ha excedido el número permitido de intentos de PIN',
            processing_error: 'Un error ha ocurrido processando la tarjeta',
            reenter_transaction: 'El pago no pudo ser procesado por el emisor por un motivo desconocido',
            resource_missing:
              'Tarjeta de crédito faltante, por favor agregue una tarjeta de crédito valida para continuar.',
            restricted_card:
              'La tarjeta no se puede usar para realizar este pago (es posible que se haya informado de pérdida o robo)',
            revocation_of_all_authorizations: 'Tarjeta rechazada por razón desconocida (5)',
            revocation_of_authorization: 'Tarjeta rechazada por razón desconocida (6). Por favor contacte a su banco.',
            security_violation: 'Tarjeta rechazada por razón desconocida (7). Por favor contacte a su banco.',
            service_not_allowed: 'Tarjeta rechazada servicio no permitido',
            stolen_card: 'La tarjeta fue reportada robada',
            stop_payment_order: 'Tarjeta rechazada por razón desconocida (8). Por favor contacte a su banco.',
            testmode_decline: 'Se utilizó un número de tarjeta de Testing',
            transaction_not_allowed: 'Tarjeta rechazada por razón desconocida (9). Por favor contacte a su banco.',
            try_again_later: 'Tarjeta rechazada por razón desconocida (10). Intente nuevamente más tarde.',
            withdrawal_count_limit_exceeded:
              'El cliente ha excedido el saldo o límite de crédito disponible en su tarjeta'
          },
          fraudulent: 'Fraudulento',
          highest: 'Alto',
          invalid: 'Inválido',
          issuer_declined: 'Emisión Rechazada',
          manual_review: 'Revisión Manual',
          network_status: 'Estado de la red',
          normal: 'Normal',
          not_assessed: 'No Evaluado',
          not_sent_to_network: 'No Enviado',
          receipt_number: 'Número de recibo',
          reversed_after_approval: 'Revertido después de la aprobación',
          risk_level: 'Nivel de Riesgo',
          type: 'Tipo de cobro'
        }
      },
      trial_due: 'Vencimiento de dias free',
      trial_expiration_date:
        'El cargo a su tarjeta de crédito será realizado el día {{trial_expiration_date}} que finaliza su período de prueba.',
      trial_used: 'Periodo gratuito finalizado',
      unpaid_message:
        'Queremos informarle que al día de la fecha su licencia se encuentra VENCIDA. Por favor, revise si cuenta con fondos suficientes o si requiere autorización de su Banco, para evitar el bloqueo de la misma.',
      you_have_basic_trial: {
        one: '¡Tienes {{days}} día de prueba!',
        other: '¡Tienes {{days}} días de prueba!'
      },
      your_trial_period_ends_today: 'Hoy finaliza tu periodo de prueba'
    },
    dashboard: {
      alerted: 'Alertados',
      clients_chart_info: 'Aquí puede ver el histórico de clientes (Creados / Eliminados)',
      contract_states_changes: 'Cambio de estado de contratos',
      contracts_chart_info: 'Aquí puede ver el histórico de contratos (Creados / Eliminados)',
      contracts_connected: 'Contratos conectados',
      contracts_connected_chart_info: 'Aquí puede ver contratos conectados / desconectados',
      contracts_that_are_not_invoiced_when_disabled: 'Contratos que no se facturan cuando están deshabilitados',
      contracts_with_invoicing_enabled: 'Contratos con facturación habilitada',
      created_current_month: 'Creados',
      degraded: 'Degradados',
      help_desk_issues: 'Tickets',
      installation_order_chart_info:
        'Aquí puede ver el histórico de Ordenes de Instalación (Creadas / Aprobadas / Rechazadas)',
      is_load: 'No hay registros para mostrar',
      payments_by_kind: 'Pagos por tipo',
      periodic_invoices: 'Facturas de servicio',
      periodic_invoices_to_generate: 'Facturas de servicio a generar',
      still_open: 'Abiertos',
      tooltips: {
        export: 'Exportar',
        zoom_in: 'Ampliar',
        zoom_out: 'Alejar',
        zoom_panning: 'Panorámica',
        zoom_reset: 'Restablecer Zoom',
        zoom_selected: 'Zoom de selección'
      },
      total_invoices_draft: 'Total de facturas en borrador',
      total_invoices_generated: 'Total de facturas generadas',
      total_invoices_issued: 'Total de facturas emitidas',
      total_periodic_invoices_not_issued: 'Total de facturas de servicio no emitidas',
      until_now: 'Hasta el momento',
      with_invoice_generation_error: 'Contratos con error al momento de generar la factura'
    },
    default: {
      is_load: 'No hay registros para mostrar',
      no_record: 'No hay {{model}} para mostrar',
      no_record_cta_create_female: 'Cree una ',
      no_record_cta_create_male: 'Cree uno ',
      no_record_cta_create_other: 'Cree uno ',
      no_templates_available: 'No hay Plantillas de {{model}} disponibles',
      only_first_search: 'Realiza tu primera búsqueda para comenzar',
      record_not_found: 'No se encontró el registro',
      titleErrors: 'Por favor revise los siguientes problemas:'
    },
    dhcp_server: {
      loading_server_information: 'Cargando información del servidor...',
      no_server_data_found: 'No se encontró información del servidor',
      loading_leases: 'Cargando leases...',
      leases: 'Leases',
      lease_no_records: 'No hay Leases para mostrar'
    },
    discount: {
      create_discount: 'Crear descuento',
      search_by_name: 'Busque por nombre de descuento',
      not_expiring: 'No expira',
      starts_at: 'Si no se especifica, estará disponible inmediatamente.',
      expires_at: 'Si no se especifica, no expira automáticamente.',
      validity: 'Vigencia',
      labels: {
        basic_information: 'Información básica',
        validity: 'Vigencia',
        invoicing_configuration: 'Configuración de Facturación',
        contract_discount_edition_enabled: 'Habilitar edición de periodos al asignar descuento'
      }
    },
    dropzone: {
      dropzone_text_bold: 'arrastra una imagen',
      max_size: 'Máximo {{max_size}}Mb'
    },
    document: {
      alert_info:
        '<p>¿Qué puedes hacer aquí?</p><p>En esta sección puedes gestionar las plantillas PDF de la <b>Comisión de Regulación de Comunicaciones (CRC)</b>.</p><p>Funciones disponibles:</p><ul><li>✅ Cargar el logo de tu empresa</li><li>✅ Eliminar el logo actual</li><li>✅ Previsualizar cómo se verá el PDF final</li></ul><p>📋 Instrucciones de uso</p><p>Paso 1: Configurar la plantilla</p><ul><li>Ve a la vista de <b>Órdenes</b></li><li>Selecciona <b>Configurar las órdenes</b></li><li>En <b>Tipo de configuración</b>, elige <b>“Instalación”</b></li></ul><p>Paso 2: Seleccionar plantilla</p><p>Edita y selecciona una de estas opciones de previsualización:</p><ul><li><b>CRC Template</b> - Plantilla estándar</li><li><b>Wispro Template</b> - Plantilla personalizada</li></ul><p>Paso 3: Subir tu logo (opcional)</p><ul><li>Usa el botón <b>“Subir Imagen”</b> de abajo</li><li>Formato aceptado: <b>JPG, PNG</b></li><li>Tamaño máximo: <b>10MB</b></li><li>Recomendado: Imágenes con fondo transparente para mejor resultado</li></ul><p>🔮 Próximamente</p><p>En futuras versiones podrás crear y editar plantillas,que luego estarán disponibles en la configuración de <b>Órdenes</b>, donde elegirás qué plantilla usar para cada tipo de documento.</p>',
      reload_pdf: 'Recargar PDF',
      preview_title: 'Aquí podrás ver el PDF una vez generado.',
      preview_pdf: 'Previsualizar PDF',
      blocks: {
        available_blocks: 'Bloques disponibles',
        blocks: 'Bloques',
        content: 'Contenido',
        create_block: 'Crear bloque',
        edit_block: 'Editar bloque',
        error_getting_blocks: 'Error al obtener los bloques',
        start_typing_here: 'Comienza a escribir aquí...',
        substitutions: {
          client_email: 'E-mail del cliente',
          client_name: 'Nombre del cliente',
          client_national_identification_number: 'Documento ó Cédula de identidad',
          client_phone: 'Teléfono del cliente',
          contract_full_address: 'Dirección completa de cliente',
          contract_number: 'Número de contrato',
          error_getting_substitutions: 'Error al obtener las sustituciones'
        },
        view_blocks_empty_description: 'Comienza creando los que necesites desde esta sección.',
        view_blocks_empty_title: '¡Aún no tienes bloques creados!'
      },
      template: {
        columns: 'Número de columnas',
        create_template: 'Crear plantilla',
        edit_template: 'Editar Plantilla',
        error_getting_templates: 'Error al obtener las plantillas',
        font_size_body: 'Fuente del contenido',
        font_size_footer: 'Fuente pie de página',
        font_size_title: 'Fuente del título',
        page_format: 'Formato de página',
        select_template: 'Seleccionar plantilla',
        template: 'Plantilla',
        template_blocks: 'Bloques de la plantilla',
        view_template_blocks_empty_description: 'Crea los que necesites desde la sección de bloques.',
        view_template_blocks_empty_title: '¡Aún no hay bloques disponibles!',
        view_template_blocks_add:
          'Aún no tiene bloques, pero puedes agregar las que necesites desde la sección de disponibles.',
        view_template_blocks_ready: '¡Tu plantilla está lista para empezar!'
      },
      view_needs_bigger_screen: 'La gestión de plantillas requiere una pantalla más grande.',
      view_needs_bigger_screen_hint:
        'Estamos trabajando para ofrecer soporte en dispositivos móviles. Mientras tanto, por favor, utilice una pantalla más grande.'
    },
    employee: {
      unlocked_at_header_tooltip:
        'Indica la fecha y hora en que la cuenta quedó bloqueada por múltiples intentos fallidos de acceso.',
      unlocked_successfully: 'Empleado desbloqueado exitosamente',
      blank_table: 'Aún no hay empleados creados',
      blank_zones: 'No posee zonas',
      create_employee: 'Crear empleado',
      created_succesful: 'Empleado creado',
      delete_employee: 'Borrar empleado',
      deleted_succesful: 'Empleado eliminado',
      edit_password: 'Editar contraseña',
      employee_detail: 'Detalle de empleado',
      password: {
        the_password_must_have: 'La contraseña debe tener:',
        at_least_8_characters: 'Como mínimo 8 caracteres',
        one_uppercase_letter: 'Al menos una mayúscula (A-Z)',
        one_lowercase_letter: 'Al menos una minúscula (a-z)',
        one_number: 'Al menos un número (0-9)',
        one_special_character: 'Al menos un caracter especial (ej. !@#$%^&*)'
      },
      password_changed: 'Contraseña actualizada',
      employee_desactivated: 'Empleado desactivado',
      password_expired: 'Contraseña expirada',
      roles: 'Roles',
      tooltip: {
        deactivate: 'Deshabilitar login',
        activate: 'Habilitar login'
      },
      searcher: {
        basic_placeholder: 'Puedes buscar por: Nombre y apellido, E-mail de usuario, Teléfono, Teléfono celular.'
      },
      filter_with_expired_password: 'Con contraseña expirada',
      update_employee: 'Actualizar empleado',
      update_succesful: 'Empleado actualizado',
      zones: 'Zonas'
    },
    fiber_configuration: {
      default_feasibility_distance_to_nap: 'Distancia de factibilidad por defecto de las NAPs (en metros)',
      default_feasibility_distance_to_nap_hint:
        'Distancia máxima, en metros, factible para conectar la ONU a la caja NAP.',
      fiber_configuration_plans: 'Planes disponibles por defecto en las OLTs'
    },
    gps_point: {
      convert_dms_latitude_coord_to_dd_error:
        'Formato válido para conversión\n por ejemplo: 00°00\'00"N - 00°00\'00"S.',
      convert_dms_latitude_coord_to_dd_format:
        'Convertir latitud en formato DMS a formato DD.\n Por ejemplo: 00°00\'00"N - 00°00\'00"S.',
      convert_dms_longitude_coord_to_dd_error:
        'Debe ingresar una longitud en formato DMS válido.\n Por ejemplo: 00°00\'00"E - 00°00\'00"O.',
      convert_dms_longitude_coord_to_dd_format:
        'Convertir longitud en formato DMS a formato DD.\n Por ejemplo: 00°00\'00"E - 00°00\'00"O.',
      coordinates_conversion_guide: `Convierte coordenadas geográficas a formato válido para mapas. Ingresa grados (°), minutos ('), segundos ("), seguido de dirección cardinal (N, S, E, O).`,
      coordinates_conversion_guide_example: `45°45'45"S se convierte a -45.7625.`,
      coordinates_conversion_guide_limit: `Latitud: +90 a -90, Longitud: +180 a -180.`
    },
    helpDesk: {
      has_delinquent_contracts: 'Tiene al menos un contrato morosos',
      issues: {
        print_with_comments: 'Imprimir con comentarios'
      }
    },
    forwarded_port: {
      without_address_ip: 'SIN IP',
      public_destiny: 'Destino Público',
      private_destiny: 'Destino Privado',
      tcp: 'tcp',
      udp: 'udp'
    },
    help_desk: {
      issue: {
        assign_contract_to_issue: 'Asignar contrato al ticket',
        click_here_to_try_again: 'Haga clic aquí para intentar nuevamente',
        client_contracts: 'Contratos del cliente',
        client_contracts_other: 'Otros contratos del cliente',
        client_deleted: 'Cliente eliminado',
        client_does_not_have_email: 'El cliente no tiene email configurado',
        client_has_no_contracts: 'El cliente no tiene contratos',
        client_has_no_devices: 'El cliente no tiene dispositivos',
        client_has_no_invoices: 'El cliente no tiene facturas',
        client_has_no_payment_gateways: 'El cliente no tiene pasarelas de pago',
        client_has_no_payments: 'El cliente no tiene pagos',
        client_has_no_tickets: 'El cliente no tiene tickets',
        client_invoices: 'Facturas del cliente',
        close_ticket: 'Cerrar Ticket',
        close_ticket_comment: 'Comentario de cierre',
        contract_assigned_to_issue: 'Contrato asignado al ticket',
        contract_assigned_successfully: 'Contrato asignado correctamente',
        contract_has_no_articles: 'El contrato no tiene artículos',
        contract_has_no_discounts: 'El contrato no tiene descuentos activos',
        contract_has_no_invoices: 'El contrato no tiene facturas',
        contract_has_no_recurring_items: 'El contrato no tiene ítems recurrentes',
        contract_has_no_tickets: 'El contrato no tiene tickets',
        contract_invoices: 'Facturas del contrato',
        contract_price: 'Precio del contrato',
        create_payment: 'Crear Pago',
        download: 'Bajada',
        email_invalid: 'El email no es válido. Por favor, verifique el formato del email.',
        email_sent_to: 'El email se ha enviado a {{email}}',
        error_fetching_client_information: 'Ocurrió un error al obtener los datos del cliente',
        error_fetching_comments: 'Ocurrió un error al obtener los comentarios',
        error_fetching_contract_information: 'Ocurrió un error al obtener los datos del contrato',
        error_fetching_images: 'Ocurrió un error al obtener las imágenes',
        error_fetching_invoicing_information: 'Ocurrió un error al obtener los datos de facturación',
        error_fetching_network_information: 'Ocurrió un error al obtener los datos de red',
        error_fetching_pppoe_status: 'Ocurrió un error al obtener el estado de PPPoE',
        error_sending_email_contact_support: 'Ocurrió un error al enviar el email. Por favor, contacte a soporte.',
        error_updating_ticket: 'Ocurrió un error al actualizar el ticket.',
        finalize_ticket: 'Finalizar Ticket',
        invoices_and_payments: 'Pagos y Facturas',
        invoicing_client: 'Facturación Cliente',
        invoicing_client_information: 'Facturación del cliente',
        invoicing_contract: 'Facturación Contrato',
        invoicing_contract_information: 'Facturación del contrato',
        invoicing_information: 'Información de facturación',
        issue_contract: 'Contrato del ticket',
        network_information: 'Información de red',
        no_contracts_to_show: 'No hay contratos para mostrar',
        one_month: 'Último mes',
        one_week: 'Última semana',
        one_year: 'Último año',
        plan_price: 'Precio del plan',
        remove_employee: 'Quitar empleado',
        reopen_ticket: 'Reabrir Ticket',
        select_contract: 'Seleccione un contrato',
        send_mobile_app_link: 'Enviar enlace de Alerta Internet por mail',
        show_ont_alerts: 'Ver alertas ONU',
        show_olt_alerts: 'Ver alertas OLT',
        six_months: 'Últimos 6 meses',
        three_months: 'Últimos 3 meses',
        ticket_has_no_comments: 'No hay comentarios para mostrar',
        ticket_has_no_images: 'No hay imágenes para mostrar',
        unexpected_error_assigning_contract: 'Error inesperado al asignar el contrato',
        unexpected_error_getting_data: 'Error inesperado al obtener el ticket',
        upload: 'Subida',
        view_billing_transactions: 'Ver movimientos'
      },
      issues: {
        change_issue_complexity: 'Cambiar complejidad del ticket',
        change_issue_state: 'Cambiar estado del ticket',
        change_issue_priority: 'Cambiar prioridad del ticket',
        create_new_issue: 'Crear nuevo Ticket',
        client_last_issues: 'Últimos tickets del cliente',
        dashboard: {
          assigned: 'Asignados',
          by_assignable: 'Por empleados',
          by_category: 'Por categoría',
          from: 'Desde',
          high_complexity_first_letter: 'A',
          historic: 'Histórico',
          low_complexity_first_letter: 'B',
          medium_complexity_first_letter: 'M',
          resolution_time: 'Tiempo de resolución',
          to: 'Hasta',
          total_due: 'Total Vencidos',
          total_resolved: 'Total Resueltos',
          total_pending: 'Total Pendientes',
          total_unassigned: 'Total Sin asignar',
          unresolved: 'Sin resolver'
        },
        deleted_client: 'Cliente eliminado',
        dropzone_text: 'Arrastre aquí las imágenes que desea subir',
        error_getting_client_contracts: 'Error inexperado al obtener los contratos del cliente',
        error_loading_image: 'Error al cargar la imagen',
        images_uploaded_successfully: 'Imágenes subidas correctamente',
        notification_mail_closed_issue_disabled:
          'Tienes la notificación "Ticket de Cierre" <1>deshabilitada</1>. Por lo tanto, este comentario no se enviará por correo al cliente.',
        notification_mail_closed_issue_enabled:
          'Tienes la notificación "Ticket de Cierre" <1>habilitada</1>. Por lo tanto, este comentario se enviará por correo al cliente.',
        minimum_number_of_copies: 'Debe imprimir al menos una copia',
        no_images_to_preview: 'No hay imágenes para previsualizar',
        number_of_copies: 'Nº de copias',
        print_with_comments: 'Imprimir con comentarios',
        public_description: 'Visible para los clientes desde la aplicación móvil',
        refresh_dashboard_on_search: 'Actualizar dashboard al buscar',
        search_by_clients_name: 'Buscar por nombre de cliente',
        searcher: {
          basic_placeholder: 'Puedes buscar por: Título, Categoría, Cliente, Asignado'
        },
        select_an_issue: 'Debe seleccionar al menos un ticket',
        select_category: 'Seleccione una categoría',
        set_due_date: 'Establecer fecha de vencimiento',
        show_closed_issues: 'Mostrar tickets cerrados',
        show_issue_details: 'Ver detalles del ticket',
        upload_images: 'Subir imágenes'
      },
      issue_categories: {
        create_new_issue_category: 'Crear nueva categoría',
        edit_issue_category: 'Editar categoría'
      }
    },
    hola_suite: {
      card: {
        tooltip: {
          contract: {
            meta: {
              main: {
                state: 'Estado del Contrato'
              }
            }
          },
          invoice: {
            meta: {
              main: {
                invoice_amount: 'Monto de la Factura'
              }
            }
          },
          order: {
            header: {
              status: 'Tipo de Orden'
            },
            meta: {
              main: {
                state: 'Estado de la Orden'
              }
            }
          },
          payment: {
            meta: {
              main: {
                payment_amount: 'Monto del Pago'
              }
            }
          },
          prospect: {
            meta: {
              main: {
                state: 'Estado del Prospecto'
              }
            }
          }
        }
      },
      unavailable: {
        button: {
          text: { inactive: 'Quiero ¡Hola! Suite', verifying: 'Soporte ¡Hola! suite', not_alive: 'Ir a Facturas' }
        },
        banner: {
          inactive: {
            text: 'Solicita la integración de ¡Hola! Suite a tu asesor comercial y gestiona mensajes desde WhatsApp, Instagram y más.'
          },
          not_alive: {
            button: {
              not_alive: ''
            },
            text: 'Tu cuenta presenta pagos pendientes. Una vez que realices el pago, podrás volver a acceder y continuar tus atenciones sin interrupciones.'
          },
          verifying: {
            text: 'En breve podrás acceder a ¡Hola! Suite y comunicarte con tus clientes con flujos de atención personalizados.'
          }
        },
        title: {
          inactive: 'Tu plataforma de atención',
          not_alive: 'El servicio requiere una actualización de pago',
          verifying: 'Verificación en curso'
        }
      },
      automatic_settings: {
        error_message: {
          already_attended: 'Este contacto ya está siendo atendido',
          already_attended_citas: 'Ya está siendo atendido por el departamento de citas',
          blank_destination_number: 'El número de teléfono está en blanco',
          channel_not_found: 'Canal no encontrado',
          communication_channel_is_invalid: 'El canal no es valido',
          different_number_of_variables: ' Número de variables diferente del esperado',
          invalid_destination_number: 'Número de teléfono no es válido',
          invalid_parameter: 'No es posible notificar a este número',
          parameter_missing: 'No se pudieron encontrar los parámetros necesarios',
          something_went_wrong: 'Algo salió mal',
          template_not_found: 'Template no encontrado',
          unexpected_number_of_params: 'El número de parámetros es distinto del esperado',
          unknown_error: 'Ocurrio un error al contactar'
        },
        tour_steps: {
          quick_search_description:
            'Filtra al instante tus Notificaciones, olvídate de desplazamientos interminables. Esta nueva búsqueda rápida hace que tus consultas diarias sean ultrarrápidas.',
          advanced_search_description:
            'Crea consultas complejas en segundos con nuestro panel de filtros mejorado. Combina varios campos y operadores para encontrar exactamente lo que necesitas.',

          configure: {
            title: 'Ver notificaciones',
            descriptions: 'Al pulsar aquí se abre una lista de todas las notificaciones automáticas disponibles.'
          },
          config_table: {
            title: 'Tus notificaciones',
            descriptions: 'Aquí ves el listado completo de todas tus reglas de notificación automática.'
          },
          config_button: {
            title: 'Guardar cambios',
            descriptions: 'Pulsa este botón para guardar la configuración que acabas de definir.'
          },
          activate_button: {
            title: 'Activar envío',
            descriptions: 'Con este interruptor activas o desactivas el envío automático de la notificación.'
          },
          table: {
            title: 'Lista de notificaciones',
            descriptions: 'Consulta aquí todas las notificaciones que hayas creado.'
          }
        },
        action_column_tooltip: {
          activate_description: 'Usa este botón para activar o desactivar el envío automático de notificaciones.',
          activate_description_activate: 'se enviarán notificaciones automáticamente al canal configurado.',
          activate_description_inactive: 'el envío quedará deshabilitado y solo podrás notificar de forma manual.',
          activate_title: 'Gestionar notificaciones automáticas',
          config_channel_template_description:
            'Selecciona una plantilla, luego haz clic en Guardar para salvar tu configuración.',
          config_template_title: 'Configurar Template'
        },
        kind: {
          contract_alerted: 'Contrato alertado',
          contract_dgo_pack_discontinued: 'Pack será dado de baja',
          contract_dgo_price_update: 'Actualización de precios de DGO',
          contract_dgo_subscription_created: 'Suscripción a DGO creada',
          contract_disabled: 'Contrato deshabilitado',
          issue_finalized: 'Ticket de mesa de ayuda finalizado',
          invoice_first_due_date: 'Primer vencimiento de factura',
          invoice_issued: 'Factura emitida',
          invoice_second_due_date: 'Segundo vencimiento de factura',
          issue: 'Ticket de mesa de ayuda',
          manual: 'Manual',
          order_feasibility_failure: 'Análisis de factibilidad fallido',
          order_feasibility_success: 'Análisis de factibilidad exitoso',
          order_installation_failure: 'Visita de instalación fallida',
          order_installation_scheduled: 'Visita de instalación programada',
          order_installation_success: 'Visita de instalación exitosa',
          order_resignation_failure: 'Visita de baja fallida',
          order_resignation_scheduled: 'Visita de baja programada',
          order_resignation_success: 'Visita de baja exitosa',
          order_technical_failure: 'Visita técnica fallida',
          order_technical_scheduled: 'Visita técnica programada',
          order_technical_success: 'Visita técnica exitosa',
          payment_created: 'Pago creado',
          ticket: 'Ticket de mesa de venta'
        }
      },
      templates: {
        tour_steps: {
          quick_search_description:
            'Filtra al instante tus Plantillas, olvídate de desplazamientos interminables. Esta nueva búsqueda rápida hace que tus consultas diarias sean ultrarrápidas.',
          advanced_search_description:
            'Crea consultas complejas en segundos con nuestro panel de filtros mejorado. Combina varios campos y operadores para encontrar exactamente lo que necesitas.',
          create: {
            title: 'Crear nueva plantilla',
            descriptions:
              'Haz clic aquí para abrir el formulario donde podrás crear una nueva Plantilla. Desde esta interfaz podrás definir todos los detalles para automatizar tus mensajes.'
          },
          name_input: {
            title: 'Nombre de la plantilla',
            descriptions:
              'Este campo define el nombre interno de tu plantilla. Te servirá para identificarla fácilmente cuando necesites editarla o reutilizarla.'
          },
          kind_input: {
            title: 'Módulo de donde envias',
            descriptions:
              'Aquí seleccionas el módulo de la plataforma al que se aplicará la plantilla: contratos, clientes, órdenes, pagos, etc. Es muy importante elegir correctamente este ámbito para que el mensaje se envíe en el contexto adecuado.'
          },
          template_input: {
            title: 'Seleciona el mensaje',
            descriptions:
              'Elige el mensaje predefinido de Hola Suite que se enviará automáticamente. Algunos templates incluyen sustituciones: son palabras clave que se reemplazan dinámicamente según el contexto del mensaje. Si el template que seleccionas tiene sustituciones, deberás completarlas para personalizar tu notificación.'
          },
          channel_input: {
            title: 'Canal de envio',
            descriptions:
              'Selecciona el canal por el cual se enviará la notificación, como WhatsApp, Telegram u otro disponible. Configura correctamente este canal para asegurar que tus clientes reciban el mensaje donde corresponde.'
          },
          submit_input: {
            title: 'Guarda configuración',
            descriptions:
              'Haz clic aquí para guardar y activar la plantilla con todos los datos configurados. Asegúrate de haber completado correctamente cada campo antes de continuar.'
          },
          table: {
            title: 'Plantillas configuradas',
            descriptions:
              'Aquí verás todas las plantillas que ya tienes creadas. Para cada una puedes revisar su nombre, el canal por el que se enviará, el mensaje que se usará y desde dónde se enviará. Además, tienes accesos directos para editarlas o gestionarlas cuando lo necesites.'
          },
          table_edit: {
            title: 'Editar plantilla',
            descriptions:
              'Al hacer clic aquí podrás abrir la configuración de esta plantilla para modificar sus campos. Es útil si necesitas cambiar el mensaje, el canal o ajustar cualquier detalle de la notificación.'
          }
        },
        substitutions: {
          algo: 'Algo',
          client_name: 'Nombre de cliente',
          contract: 'Contrato',
          employee_name: 'Nombre del empleado asignado',
          first_due_date: 'Primer vencimiento',
          foo: 'Foo',
          invoice: 'Factura',
          invoice_number: 'Número de factura',
          issued_at_day: 'Emitido el',
          lead: 'Lead',
          number: 'Número',
          order: 'Orden',
          payment: 'Pago',
          payment_date_day: 'Fecha de pago',
          plan_name: 'Nombre de Plan',
          prospect: 'Prospecto',
          second_due_date: 'Segundo vencimiento',
          sequential_id: 'ID',
          start_at_date: 'Fecha de inicio',
          start_at_time: 'Hora de inicio',
          transaction_code: 'Código de transacción'
        },
        template_hola: {
          one: 'Template Hola'
        },
        one: 'Plantilla',
        other: 'Plantillas'
      },
      manual_settings: {
        notification_status: 'Estado de notificaciones',
        hints: {
          created_at:
            'Las notificaciones manuales ahora se agrupan únicamente por su horario de envío, lo que simplifica la visualización y facilita el filtrado de los registros.'
        }
      }
    },
    horizontal_async_select: {
      enter_search: 'Por favor, introduzca su búsqueda',
      error_getting_option: 'Error inesperado al obtener las opciones',
      no_search: 'No se encontraron resultados',
      search: 'Buscando...',
      type_characters_to_search: 'Escriba {{count}} o más caracteres para buscar'
    },
    installation_order_configuration: {
      agreement_details: 'Campo para detallar términos de uso o descargo de responsabilidad a mostrar en el PDF'
    },
    invoicing_contract: {
      alerted_date_by_system: 'Alertado automaticamente el',
      cancel_initial_invoice: 'Cancelar factura inicial',
      current_period_invoiced: 'Ultimo periodo facturado',
      description_for_initial_invoice_warning:
        'El sistema facturará automaticamente el proximo periodo el dia {{from}}. Puede generar una factura inicial de servicio con el siguiente boton.',
      disabled_date_by_system: 'Deshabilitado automaticamente el',
      delinquent_date_by_system: 'Moroso automáticamente el',
      from_to: 'El sistema facturará automáticamente el contrato el día {{from}} hasta {{to}}',
      generate_initial_invoice: 'Generar factura inicial',
      generate_service_invoice: 'Generar factura de servicio',
      info_autocalculate_amount:
        'Al cambiar la fecha de inicio o fin a facturar, el sistema autocalculará el monto en función del precio del plan. Puede cambiar el monto luego de haber seleccionado las fechas a facturar.',
      initial_invoice_generated: 'Factura inicial generada.',
      initial_invoice_not_generated: 'La factura inicial no ha sido generada.',
      invoicing_disabled: 'Facturación deshabilitada',
      plan_amount: 'Precio del plan: {{amount}}',
      profile: 'Perfil de facturación',
      next_period_to_invoice: 'Proximo periodo a facturar'
    },
    invoicing_firm: {
      configuration: 'Configuración',
      create_new_invoicing_firm: 'Crear Razón Social',
      no_previous_numeration_record: 'No hay numeración previa que mostrar'
    },
    invoicing_configuration: {
      show_invoicing_firms: 'Ver Razones sociales',
      without_invoicing_firms: 'Sin Razones sociales'
    },
    invoicing_profile: {
      alert_after_days: 'Se <1>alertarán</1> contratos pasado {{days}} días del 1º venc.',
      alert_on_first_due_date: 'Se <1>alertarán</1> contratos el día del 1º venc.',
      amount: '<0>Monto:</0> {{amount}}',
      basic: 'Básico',
      days_before_end_period: '{{days}} días antes del final del periodo',
      disable_after_days: 'Se <1>deshabilitarán</1> contratos pasado {{days}} días del 2º venc.',
      disable_on_second_due_date: 'Se <1>deshabilitarán</1> contratos el día del 2º venc.',
      disabled: 'Deshabilitado',
      due_at: 'Vence en <1>{{due_days}}</1> dias apartir del <3>{{period}}</3>',
      due_at_end_of_period: 'Vence <1>{{period}}</1>',
      enabled: 'Habilitado',
      end_of_period: 'al final de cada periodo',
      first_due: '1º Vencimiento',
      invoicing_generation: 'Generar facturas',
      never_alert: 'Nunca se <1>alertarán</1> contratos',
      never_disable: 'Nunca se <1>deshabilitarán</1> contratos',
      second_due: '2º Vencimiento',
      since_beginning_of_period: 'inicio del periodo',
      since_end_of_period: 'final del periodo',
      tax_reconnection: '<0>Impuesto:</0> % {{rate}}',
      when_generate_card: {
        beginning_of_period: 'Inicio del periodo',
        days_before_end: 'días antes del fin del periodo',
        end_of_period: 'Fin del periodo'
      },
      when_generate: {
        beginning_of_period: 'Al inicio del periodo',
        days_before_end: 'Seleccionar días previos al final del periodo',
        end_of_period: 'Al final del periodo'
      },
      without_interest: 'No se cobrará el interés',
      with_interest_mount: '<0>El interés será de</0> {{amount}}',
      with_interest_percentage: '<0>El interés será de</0> % {{amount}}',
      without_tax: 'Sin impuestos'
    },
    invoicing: {
      cash_audit: {
        payment_unverified_successfully: 'Pago desverificado correctamente',
        unverified_payment: 'Marcar como no verificado',
        searcher: {
          basic_placeholder_index: 'Puedes buscar por: ID y Creador',
          basic_placeholder_show: 'Puedes buscar por: Cliente, Recaudado por, Registrado por y tipo de Transacción',
          current_month: 'Este Mes',
          last_three_months: 'Últimos 3 Meses'
        },
        confirmation_modal_body: 'Se creará un arqueo de caja con los siguientes datos:',
        create_cash_audit: 'Crear arqueo de caja',
        create_new_cash_audit: 'Crear nuevo arqueo de caja',
        error_create_cash_audit: 'Error al crear el arqueo de caja',
        success_create_cash_audit: 'Arqueo de caja creado correctamente',
        dashboard: {
          current_month_cash_audits_count: 'Arqueos realizados este mes',
          current_month_cash_audits_amount: 'Total arqueado este mes',
          not_validated: 'No validados',
          not_validated_payments_count: 'Pagos sin verificar',
          not_validated_payments_amount: 'Monto total sin verificar',
          selected: 'Seleccionados',
          selected_payments: 'Pagos seleccionados',
          selected_payments_amount: 'Monto total seleccionado',
          transactions_by_amount: 'Monto total por tipo de transacción',
          transactions_by_count: 'Cantidad por tipo de transacción'
        },
        export: {
          select_format: 'Seleccione el formato al que desea exportar',
          bulk_actions_successful: 'Recibirá un email con los resultados',
          export_error: 'Error al exportar'
        },
        payments_quantity: 'Cantidad de pagos',
        total_amount: 'Monto total'
      },
      client: {
        hints: {
          colombia: {
            taxpayer_identification_number:
              'Para facturaciones con (siigo) el digito verificador debe ir separado por - o /, (hka) el digito verificador no va separado.'
          },
          mexico: {
            invoicing_name: 'Declarado en el SAT',
            taxpayer_identification_number: 'El RFC es obligatorio si no elige Fantasía',
            zip_code: 'Código postal declarado en el SAT'
          },
          peru: {
            invoicing_name: 'Declarado en la SUNAT',
            taxpayer_identification_number: 'El RUC es obligatorio si es persona jurídica o elige factura de venta'
          }
        }
      },
      contract_discount: {
        successfully_canceled: 'Cancelado exitosamente',
        successfully_deleted: 'Eliminado exitosamente'
      },
      dolarizer: {
        change_exchange_values: ' Para cambiar este valor, puede hacerlo desde ',
        exchange_currency: 'Moneda de cambio',
        invoicing_currency: 'Moneda actual',
        invoicing_currency_to_exchange_currency_rate: 'Tasa de cambio',
        set_exchange_currency: 'Para fijar la Tasa de cambio, debe establecer primero la moneda de cambio desde '
      },
      invoice: {
        export: {
          bancolombia_all_invoices: 'Bancolombia (Todas)',
          bancolombia_format: 'Formato Bancolombia',
          bancolombia_selected_invoices: 'Bancolombia ({{selected_count}} seleccionadas)',
          efecty_all_invoices: 'Efecty (Todas)',
          efecty_format: 'Formato Efecty',
          efecty_selected_invoices: 'Efecty ({{selected_count}} seleccionadas)',
          export_debt: 'Exportar deuda',
          export: 'Exportar',
          exporting: 'Exportando...',
          loading_payment_gateways: 'Cargando pasarelas de pago...',
          no_payment_gateways: 'No hay pasarelas de pago configuradas para este formato',
          payment_gateway_required: 'Debe seleccionar una pasarela de pago para usar este formato',
          payment_gateway_required_for_bancolombia:
            'Debe seleccionar una pasarela de pago para usar el formato Bancolombia',
          prisma_all_invoices: 'Prisma (Todas)',
          prisma_format: 'Formato Prisma',
          prisma_selected_invoices: 'Prisma ({{selected_count}} seleccionadas)',
          select_invoices_hint: 'Si deseas una selección más precisa, márcalas en la tabla',
          selected_invoices: 'Facturas seleccionadas'
        },
        without_first_due_date: 'No tiene 1er vencimiento',
        without_second_due_date: 'No tiene 2do vencimiento'
      },
      issued_invoices: {
        void: 'Anular',
        amount_to_void: 'Monto a anular'
      },
      payment_gateways: {
        there_are_no_verified_gateways_to_associate: 'No existen pasarelas verificadas para asociar.'
      },
      payment_receipts: {
        create_payment: 'Crear pago',
        change_to_processed: 'Procesar',
        change_to_pending: 'Volver a Pendiente',
        discard_payment_receipt: 'Descartar Comprobante de Pago',
        error_loading_preview: 'Error al cargar la previsualizacón',
        searcher: {
          basic_placeholder: 'Nombre de cliente, número de factura'
        },
        state: {
          communication_error: 'Validando',
          discarded: 'Descartado',
          error: 'Error',
          pending: 'Pendiente',
          processed: 'Procesado',
          processing: 'Procesando'
        },
        successfully_updated: 'Actualizado correctamente',
        process_payment_receipt: 'Procesar Comprobante de Pago'
      },
      payment_transactions: {
        successfully_unbinded: 'Desvinculado correctamente',
        no_associated_payments: 'Sin pagos asociados',
        unbind: 'Desvincular'
      },
      profiles: {
        navtabs: {
          tabs: {
            first_due_date: '1er. Vencimiento',
            second_due_date: '2do. Vencimiento',
            alert_contracts_strat: 'Estrategia para alertar contratos',
            disabled_contracts_strat: 'Estrategia para deshabilitar contratos'
          }
        }
      },
      kind_invoices: {
        argentina_a: 'Argentina (A)',
        argentina_b: 'Argentina (B)',
        argentina_c: 'Argentina (C)',
        colombia: 'Factura de Venta',
        credit_note: 'Nota de Crédito',
        ecuador: 'Factura de Venta',
        espana: 'España',
        invoice: 'Factura',
        mexico: 'Factura de venta',
        peru_final_consumer_invoice: 'Boleta de venta',
        peru_invoice: 'Factura de venta',
        sales_invoice: 'Factura de venta',
        sales_receipt: 'Boleta de venta',
        voucher: 'Comprobante'
      },
      kind_person: {
        mexico_natural: 'Persona Física',
        mexico_juridic: 'Persona Moral'
      },
      vat_condition: {
        juridic_person: 'Persona jurídica',
        natural_person: 'Persona natural',
        billing_regime: 'Regimen de Facturación',
        billing_regime_juridical: 'Regimen de Facturación (P. Jurídica)',
        billing_regime_person: 'Regimen de Facturación (P. Física)',
        common_regime: 'Regimen Común',
        common_regime_juridical: 'Regimen Común (P. Jurídica)',
        common_regime_person: 'Regimen Común (P. Física)',
        exempt: 'Exento',
        fantasy: 'Fantasia',
        final_consumer: 'Consumidor Final',
        registered_vat_payer: 'Responsable Inscripto',
        self_employed_taxpayer: 'Responsable Monotributo',
        not_applicable: 'IVA No Alcanzado',
        simplified_regime: 'Regimen Simplificado',
        general_regime: 'Régimen General de Ley Personas Morales',
        legal_entities_with_non_profit_purpose: 'Personas Morales con Fines no Lucrativos',
        wages_and_salaries_and_income_assimilated_to_salaries: 'Sueldos y Salarios e Ingresos Asimilados a Salarios',
        lease: 'Arrendamiento',
        property_disposal_or_acquisition_regime: 'Régimen de Enajenación o Adquisición de Bienes',
        other_income: 'Demás ingresos',
        residents_abroad_without_permanent_establishment_in_mexico:
          'Residentes en el Extranjero sin Establecimiento Permanente en México',
        dividend_income: 'Ingresos por Dividendos (socios y accionistas)',
        individuals_with_business_and_professional_activities:
          'Personas Físicas con Actividades Empresariales y Profesionales',
        interest_income: 'Ingresos por intereses',
        income_regime_for_obtaining_prizes: 'Régimen de los ingresos por obtención de premios',
        no_tax_obligations: 'Sin obligaciones fiscales',
        production_cooperative_societies_that_choose_to_defer_their_income:
          'Sociedades Cooperativas de Producción que optan por diferir sus ingresos',
        tax_incorporation: 'Incorporación Fiscal',
        agricultural_livestock_forestry_and_fishing_activities:
          'Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras',
        optional_for_groups_of_companies: 'Opcional para Grupos de Sociedades',
        coordinated: 'Coordinados',
        regime_of_business_activities_with_income_through_technological_platforms:
          'Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas',
        simplified_trust_regime: 'Régimen Simplificado de Confianza'
      }
    },
    invoicing_taxes: {
      kinds: {
        colombia_contrib: 'Contribuciones',
        colombia_ica: 'ICA',
        colombia_ico: 'ICO',
        colombia_ret_hon: 'Retención en la fuente por renta Honorarios',
        colombia_ret_ica: 'Retención en la fuente por ICA',
        colombia_ret_iva: 'Retención en la fuente por IVA',
        colombia_ret_purch: 'Retención en la fuente por renta Compras',
        colombia_ret_serv: 'Retención en la fuente por renta Servicios',
        colombia_ret_transp: 'Retención en la fuente por renta Transporte',
        costa_rica_911: '911',
        costa_rica_cruz_roja: 'Cruz Roja',
        ecuador_ice: 'ICE',
        iva: 'IVA',
        mexico_ieps: 'IEPS',
        panama_itbms: 'ITBMS',
        peru_igv: 'IGV'
      }
    },
    invoicing_transaction_kinds: {
      kinds: {
        credit: 'Crédito',
        debit: 'Débito'
      }
    },
    isps: {
      api_token: {
        regen: 'Regenerar token',
        sending: 'Enviando',
        title: 'Token autenticador de API'
      },
      archive_isp: 'Archivar ISP'
    },
    maps: {
      cluster: 'Podras desactivar los cluster despues del zoom 16',
      contract: 'Mostrar/ocultar contratos',
      warehouse: 'Mostrar/ocultar almacenes',
      coverage: 'Mostrar/ocultar coberturas',
      fiber: 'Mostrar/ocultar fibra',
      home: 'Inicio',
      inputAddressContract: 'Para utilizar el filtro, haga click en el mapa',
      isp: 'Centrar ISP',
      nap: 'Mostrar/ocultar NAPs',
      node: 'Mostrar/ocultar nodos',
      olt: 'Mostrar/ocultar OLTs',
      ont_signal: 'Mostrar/ocultar señal ONUs',
      search_by_name: 'Buscar por nombre',
      search_contracts_by_ont_signal: 'Buscar contratos por señal ONU',
      searcher: {
        enums: {
          client: {},
          contract: {
            state: {
              alerted: 'Alertado',
              degraded: 'Degradado',
              disabled: 'Deshabilitado',
              enabled: 'Habilitado'
            }
          },
          coverage: {},
          node: {
            kind: {
              fiberbox: 'Caja de fibra',
              wireless: 'Wireless'
            }
          }
        },
        kind: 'Tipo',
        name: 'Nombre',
        neighborhood_id: 'Barrio',
        node_id: 'Nodo (ID)',
        sequential_id: 'Sequencial ID',
        ssid: 'Nombre',
        state: 'Estado',
        brand: 'Marca',
        fbp: 'Interfaz',
        the_results_will_be_displayed_in_the_visible_area: 'Se mostrarán los resultados en la zona visible',
        this_model_does_not_have_search_criteria_yet: 'Este modelo todavía no cuenta con criterios de búsqueda.'
      },
      you_must_complete_all_fields: 'Debe completar todos los campos'
    },
    mikrotik: {
      allow_only_allowed_contracts_to_navigate: {
        off: "<0>OFF:</0> Liberá completamente el trafico, aceptando cualquier tipo de trafico. Opción util para <2>MikroTik's</2> que ya vienen en funcionamiento y que no se tienen cargado contratos en <4>Wispro</4>.",
        on: '<0>ON:</0> Solo permitirá navegar a los contratos permitidos (habilitados, alertados, degradados).'
      },
      cant_connect_to_service_please_refresh_page:
        'No se puedo establecer la comunicación con el servicio, recargue la pagina y si el error persiste contactese con soporte.',
      command_description:
        'Abra una terminal de su Mikrotik y copie los siguientes comandos, para realizar la conexión VPN.',
      commands_for_mikrotik: 'Comandos para Mikrotik',
      mikrotik_configuration: 'Configuración Mikrotik',
      mikrotik_use_ssl: 'Requiere certificado en el mikrotik',
      notification_https_block:
        'Para redirigir tráfico HTTPS es necesario bloquearlo.<1/>La redirección no es inmediata, la petición HTTPS debe completar un tiempo de espera predeterminado por cada navegador.<3/>Una vez que este tiempo se cumple el navegador solicita una pagina HTTP (generate_204) y muestra la notificación en una nueva pestaña.',
      select_mikrotik_version_label: 'Seleccione la versión de Mikrotik',
      traffic_control_enabled:
        'Al deshabilitar el control de ancho de banda, no se priorizará ni se limitará el trafico de los clientes.<1/>Funciona para MikroTik y versiones de BMU mayores o igual a <3>0.6.4</3>.',
      uniq_contracts_mac_address: 'Comprobar que la dirección MAC de contrato es única.',
      vpn_client_configuration: 'Configuración cliente VPN',
      web_proxy_enabled: {
        alert_contracts: 'Alerta de contratos.',
        customized_notifications: 'Notificaciones personalizadas.',
        service_disabled: 'Servicio deshabilitado.',
        title:
          'El servicio de web proxy es necesario que este Habilitado para que funcione el servicio de notificaciones:'
      },
      interfaces: {
        add_address: 'Agregar dirección',
        add_address_to_interface: 'Agregar dirección a la interfaz',
        service_kind: 'Tipo de servicio',
        tour: {
          add_address: 'Haciendo clic, tendrá la posibilidad de crear direcciones en la interfaz seleccionada.',
          complete_fields: 'Complete los campos y haga clic en Guardar.',
          create_vlan: 'Haciendo clic, tendrá la posibilidad de crear VLANs en la interfaz seleccionada.',
          edit_kind_description:
            'Haciendo clic, tendra la posibilidad de cambiar el tipo de la interfaz seleccionada. Esto es útil para definir el modo de trabajo de la interfaz. Si la interfaz es de tipo WAN, se utilizará para identificar el tráfico de salida a Internet, si es de tipo LAN, será para el trafico de la red local.',
          edit_kind_title: 'Editar tipo de interfaz',
          edit_service_kind_description:
            'Haciendo clic, podrá definir el tipo de servicio que se le otorgará al cliente final.',
          edit_service_kind_title: 'Editar tipo de servicio',
          interface: 'Interfaz sobre la cual se creara la VLAN',
          interface_name: 'Nombre de la intefaz VLAN a crear.',
          show_contracts_description: 'Haciendo clic, podrá filtrar los contratos que tengan asignada esta interfaz.',
          vlan_id: 'Identificador de VLAN(VLAN ID).'
        }
      },
      unpenalize_wait: 'Procesando, aguarde por favor.'
    },
    mikrotiks: {
      ping: {
        sent: 'Enviado',
        received: 'Recibido',
        status: 'Estado',
        size: 'Tamaño',
        ttl: 'TTL',
        time: 'Tiempo',
        packet_loss: 'Paquetes perdidos %'
      }
    },
    nap: {
      all_nap_contracts_have_seal: 'Todos los contratos de la NAP poseen un precinto',
      client_input_placeholder: 'buscar por nombre',
      contracts_associated_to_nap: 'Contratos asociados a la nap',
      dashboard: {
        alerts: 'Alertas',
        alerts_no_records: 'No hay alertas para mostrar',
        alerts_title: 'Alertas críticas y mayores de hoy',
        authorized_onts: 'Autorizadas',
        critical_alarms: 'Alarmas críticas o mayores',
        critical_interfaces: 'Interfaces críticas',
        error_querying_olt: 'Error al consultar OLT',
        interface_signal_warning_tooltip: "ONUs con señales 'critical' o 'warning' mayor al 80%",
        interfaces_no_records: 'No hay interfaces para mostrar',
        interfaces: 'Interfaces',
        title_hint: 'La actualización de datos depende del tiempo de respuesta de cada OLT',
        linked_olts: 'OLTs vinculadas',
        linked_olts_no_records: 'No hay OLTs vinculadas para mostrar',
        linked_onts: 'Vinculadas',
        linked_status: 'Conectadas',
        offline_onts: 'Desconectadas',
        olts_queried: 'OLTs consultadas',
        online_onts: 'Conectadas',
        querying_olt: 'Consultando OLT',
        retry: 'Reintentar',
        retry_olts_with_errors: 'Reintentar OLTs con errores',
        signal_status: 'Señal',
        successfull_olt_query: 'Consulta de OLT exitosa',
        title: 'Detalle ONUs',
        tooltip_message_info_naps_broken_slots: 'Puertos averiados',
        tooltip_message_info_naps_broken_slots_full_message: 'Cantidad de puertos marcados como averiados',
        tooltip_message_info_naps_capacity_total: 'Capacidad Total',
        tooltip_message_info_naps_capacity_total_full_message: 'Cantidad total de puertos que posee la NAP',
        tooltip_message_info_naps_free_slots: 'Puertos disponibles',
        tooltip_message_info_naps_free_slots_full_message:
          'Cantidad de puertos de la NAP que se encuentran disponibles',
        tooltip_message_info_naps_onts_linked: 'Puertos ocupados',
        tooltip_message_info_naps_onts_linked_full_message:
          'Suma entre la cantidad de contratos asociados a la NAP y puertos marcados como ocupados sin un contrato asociado'
      },
      enter_port: 'Ingrese un puerto',
      fbp: 'Frame/Board/Port',
      feasibility_distance_hint:
        'Si no se ingresa un valor, la factibilidad se determinará usando el valor ingresado en la Configuración de Fibra Óptica ({{value}} m).',
      fetch_available_ports_error: 'Error al obtener puertos libres',
      fetch_available_ports_success: 'Se obtuvieron los puertos libres',
      fetch_available_ports_retry: 'Reintentar búsqueda de puertos libres',
      hints: {
        must_associate_olt: 'Debe asociar una OLT',
        nap_full_capacity: 'NAP a máxima capacidad',
        must_assign_a_port_to_the_contracts: 'Debe asignar un puerto a los contratos asociados a la NAP'
      },
      massive_update_error_detail_message: '{{attr}}: {{error_type}} {{restriction_value}}, {{error_count}}',
      massive_update_error_hint: 'Clickea el elemento en la lista y se filtrará en la tabla las NAPs con errores',
      massive_update_error_refresh: 'No se han encontrado errores en la actualización masiva.',
      massive_update_error_title: 'Errores en la Actualización Masiva ({{count}} {{plurality}})',
      massive_update_nap_with_errors: '{{error_count}} NAP afectada',
      massive_update_naps_with_errors: '{{error_count}} NAPs afectadas',
      massive_update_process: 'La actualización masiva esta en proceso.',
      massive_update_remove_all_errors: 'Se han limpiado los errores de la actualización masiva.',
      massive_update_no_naps_selected: 'No hay NAPs seleccionadas.',
      nap_contracts_without_nap_port: 'Hay {{contracts}} contratos de la NAP sin puerto asignado',
      nap_contracts_without_seal: 'Hay {{contracts}} contratos de la NAP sin precinto asignado',
      nap_port_form: {
        unable_to_free_port: 'Para liberar el puerto debe desasociar el contrato asociado',
        unable_to_broken_port: 'Para marcar el puerto como averiado debe desasociar el contrato asociado',
        change_port_state: 'Cambiar estado del puerto'
      },
      nap_ports_state: 'Estado de Puertos',
      nap_has_no_contracts: 'La NAP no posee contratos conectados',
      port_select_placeholder: 'Busque puertos libres',
      power_limit_hint:
        'Valor de referencia para establecer si la instalación de una ONU fue correcta o si tiene problemas.',
      reset_to_default_value: 'Reestablecer al valor por defecto ({{value}} m)',
      no_available_ports: 'No hay puertos libres',
      help_tooltips: {
        availability_header: {
          capacity: {
            title: 'Capacidad',
            body: 'Número total de puertos disponibles en la NAP.'
          },
          broken_ports: {
            title: 'Puertos averiados',
            body: 'Cantidad de puertos inutilizables debido a que han sido marcados como averiados.'
          }
        },
        nap_port_states_header: {
          broken: {
            title: 'Puertos averiados',
            body: 'Cantidad de puertos inutilizables debido a que han sido marcados como averiados.'
          },
          capacity: {
            title: 'Capacidad',
            body: 'Número total de puertos disponibles en la NAP.'
          },
          free: {
            title: 'Puertos libres',
            body: 'Puertos disponibles para su asignación.'
          },
          filled_with_contract: {
            title: 'Puertos ocupados con contrato',
            body: 'Puertos actualmente en uso y asociados a un contrato activo.'
          },
          filled_without_contract: {
            title: 'Puertos ocupados sin contrato',
            body: 'Puertos actualmente en uso que no tienen un contrato asociado.'
          }
        },
        seals_header: {
          seals_with_contract: {
            title: 'Precintos con contrato',
            body: 'Precintos de la NAP que están vinculados a un contrato.'
          },
          seals_without_contract: {
            title: 'Precintos sin contrato',
            body: 'Precintos de la NAP que no tienen un contrato asociado.'
          },
          total: {
            title: 'Total de precintos',
            body: 'Cantidad total de precintos asignados a la NAP.'
          }
        },
        alerts_header: {
          nap_port_alerts: {
            title: 'Alerta de Puertos NAP',
            with_alerts:
              'Contratos sin puerto asignado: Indica la cantidad de contratos asociados a la NAP que no tienen un puerto asignado.',
            without_alerts: 'Sin alertas: Todos los contratos asociados a la NAP tienen un puerto asignado.'
          },
          seals_alerts: {
            title: 'Alerta de Precintos',
            with_alerts:
              'Contratos sin precinto asignado: Indica la cantidad de contratos asociados a la NAP que no tienen un precinto asignado.',
            without_alerts: 'Sin alertas: Todos los contratos asociados a la NAP tienen un precinto asignado.'
          }
        }
      }
    },
    nas: {
      linked_nas: 'NAS vinculado',
      unlinked_nas: 'NAS desvinculado',
      the_nas_service_is_linked_and_the_number_of_linked_nas_is_counted:
        'El servicio de NAS está vinculado, se cuenta el número de NAS vinculados',
      the_nas_service_is_unlinked: 'El servicio de NAS se encuentra desvinculado'
    },
    navigation: {
      topnav: {
        signout: 'Cerrar Sesión',
        edit_user: {
          client_input_search_message: 'Escriba 3 caracteres para buscar',
          error_fetching_isp: 'Error al buscar isps',
          error_updating_user: 'Error al establecer el usuario de prueba',
          isp_not_found: 'No se encontró el ISP'
        },
        users_guide: 'Guia de Usuarios'
      }
    },
    neighborhood: {
      created_succesful: 'Barrio creado',
      deleted_succesful: 'Barrio eliminado',
      is_load: 'No se encontró Barrios',
      neighborhoods_title: 'Nuevo Barrio',
      neighborhoods_title_edit: 'Editar Barrio',
      searcher: {
        basic_placeholder: 'Puedes buscar por: Nombre'
      },
      updated_succesful: 'Barrio actualizado'
    },
    olt_server_interfaces: {
      uplink_port: 'Puerto uplink OLT',
      basic_placeholder: 'Puedes buscar por: Nombre OLT, Nombre Servidor, Numero de VLAN',
      autodiscover_refresh: 'Refrescando Autodiscover',
      autodiscover_success: 'Autodiscover exitoso',
      autodiscover_error: 'Error al refrescar Autodiscover',
      autodiscover: 'Refrescar Autodiscover',
      pon_port: 'Puerto PON',
      pon_ports: 'Puertos PON',
      parent_interface: 'Interfaz padre',
      logic_interface: 'Interfaz lógica'
    },
    orders: {
      index: {
        add_article: 'Añadir artículo',
        bulk_actions: {
          download: {
            hint_1:
              ' La exportación puede tardar varios minutos; para evitar timeouts, descarga en lotes de máximo 1.000 órdenes.',
            hint_2: 'Filtra tus órdenes antes de exportar para reducir el tamaño y la complejidad del archivo.',
            hint_3: 'Las órdenes que no cuenten con contrato/prospecto no serán exportadas.',
            hint_4: 'Usa CSV para grandes volúmenes de datos; reserva XLS solo para funciones avanzadas.'
          }
        },
        by_order_kind: 'Por tipo de orden',
        change_order_state: 'Cambiar estado de la orden',
        click_here_to_add_article: 'Haga clic aquí para añadir un artículo',
        click_here_to_restore_contract: 'Haga clic aquí para restaurar el contrato',
        click_here_to_generate_contract: 'Haga clic aquí para generar el contrato',
        click_here_to_generate_networking_config: 'Haga clic aquí para generar la configuración de red',
        click_here_to_go_to_contract: 'Haga clic aquí para ir al contrato',
        click_to_change_state: 'Haga clic aquí para cambiar el estado',
        completed_orders: 'Órdenes completadas',
        configure_feedback_kinds: 'Configurar tipos de feedback',
        configure_order_configurations: 'Configurar PDF de las órdenes',
        configure_order_parameters: 'Configurar parámetros de las órdenes',
        contract_generated: 'Contrato generado',
        contract_info: 'Información del contrato',
        contract_deleted: 'Contrato eliminado',
        contract_not_generated: 'Contrato no generado',
        create_new_feedback_kind: 'Crear nuevo tipo de feedback',
        create_order: 'Crear orden',
        create_order_finalized_or_closed: 'No puede crear una orden con un ticket finalizado o cerrado.',
        create_order_with_contract: 'Para crear una orden, primero debe asociar un contrato.',
        create_order_without_contract: 'Para crear una orden, esta no debe estar asociada a un contrato.',
        current_month: 'Mes actual',
        deleted_contract: 'Contrato eliminado',
        deleted_employee: 'Empleado eliminado',
        deleted_prospect: 'Prospecto eliminado',
        error_getting_dashboard: 'Ocurrió un error al obtener los datos del panel de control',
        error_loading_lead_data: 'Error al cargar el Lead',
        failure: 'Fallidas',
        feasibility_order_must_be_create_from_sale_desk:
          'Las órdenes de factibilidad deben ser creadas desde <strong>Mesa de Ventas</strong>.',
        fix_errors: 'Corregir errores',
        help_desk_ticket: 'Ticket Mesa de Ayuda #{{ sequential_id }}',
        historic: 'Histórico',
        installation_order_must_be_create_from_sale_desk:
          'Las órdenes de instalación deben ser creadas desde <strong>Mesa de Ventas</strong>.',
        last_three_months: 'Últimos 3 meses',
        lead_converted_successfully: 'Lead convertido exitosamente',
        lead_conversion_went_wrong: 'Error al convertir el Lead',
        network_configuration: 'Configuración de red',
        networking_config_not_generated: 'Configuración de red no generada',
        new_order_state: 'Nuevo estado de la orden',
        no_assigned_employee: 'Sin empleado asignado',
        no_associated_ticket: 'Sin ticket asociado',
        select_employee: 'Seleccionar empleado',
        click_to_assign_employee: 'Haz clic para asignar empleado',
        click_to_change_employee: 'Haz clic para cambiar empleado',
        no_images_to_preview: 'No hay imágenes para previsualizar',
        not_scheduled: 'No programada',
        order_kind: 'Tipo de orden',
        overdue_orders: 'Órdenes atrasadas',
        pdf: {
          contract_required: 'No se puede visualizar el PDF porque la orden no tiene un contrato asociado.'
        },
        preparing_contract_generation: 'Preparando generación de contrato...',
        prospect_already_convert: 'El prospecto ya tiene un contrato generado',
        prospect_info: 'Información del prospecto',
        removed_article_destination: 'Destino del artículo removido',
        reschedule: 'Reprogramar',
        restore_contract: 'Restaurar contrato',
        sale_desk_ticket: 'Ticket Mesa de Venta #{{ sequential_id }}',
        schedule: 'Programar',
        scheduled: 'Programadas',
        service_resignation: 'Baja del servicio',
        success: 'Exitosas',
        technical_visit: 'Visita técnica',
        time_period: 'Período de tiempo',
        to_reschedule_orders: 'Órdenes a reprogramar',
        unscheduled: 'No programadas',
        update_feedback_kind: 'Editar tipo de feedback',
        update_ticket_badges: 'Actualizar etiquetas del ticket #{{sequential_id}}'
      },
      schedule: {
        cant_reschedule_completed_order: 'No se puede reprogramar una orden completada',
        drag_order: 'Arrastre una orden y suéltela en el calendario',
        end_at_input_hint: 'Para cambiar la fecha de inicio y fin, arrastre el evento en el calendario.',
        no_orders_to_schedule: 'No hay órdenes para programar',
        no_available_employees:
          'No hay empleados con roles de instalador, supervisor de instalador, técnico o supervisor de técnico',
        not_scheduled: 'No programada',
        non_scheduled_orders: 'Órdenes no programadas',
        one_day: '1 día',
        reschedule: 'Reprogramar',
        schedule: 'Programar',
        scheduled_orders: 'Órdenes programadas',
        select_a_not_scheduled_order: 'Seleccione una orden no programada',
        three_days: '3 días',
        unexpected_error_getting_orders: 'Error inesperado al obtener las órdenes',
        view_needs_bigger_screen: 'La planificación de órdenes necesita una pantalla más grande',
        view_needs_bigger_screen_hint:
          'Estamos trabajando para ofrecer soporte en dispositivos móviles. Mientras tanto, por favor, utilice una pantalla más grande.'
      },
      parameters: {
        sections: {
          orders: 'Órdenes',
          employees: 'Empleados',
          wispro_app: 'Wispro App'
        },
        rules: {
          create_installation_when_finalize_feasibility: 'Crear Instalación al finalizar Factibilidad',
          edit_order_when_finalize: 'Permitir ediciones en Órdenes finalizadas',
          close_order_when_finalize: 'Cerrar la Orden automáticamente luego de finalizar',
          create_client_when_create_order: 'Convertir Lead en Cliente al crear la Instalación',
          employee_can_autoassign_orders: 'Autorizar al instalador a asignarse una Orden',
          employee_can_schedule_orders: 'Autorizar al instalador a programarse una Orden',
          same_employee_feasibility_to_installation:
            'Asignar el Instalador que realizó la Factibilidad a la Instalación',
          article_management_required_mobile: 'Exigir verificación de artículos',
          track_employees_mobile: 'Exigir permisos de ubicación',
          photos_required_mobile: 'Exigir fotos',
          number_photos_required_mobile: 'Cantidad de fotos',
          tracking_level_mobile: 'Nivel de exigencia'
        },
        hints: {
          create_installation_when_finalize_feasibility:
            'Se crea automáticamente la Orden de Instalación al finalizar la Orden de Factibilidad.',
          edit_order_when_finalize: 'Se habilita la edición de Órdenes ya finalizadas.',
          close_order_when_finalize: 'Se cierra automáticamente la Orden al pasar a estado "Finalizada".',
          create_client_when_create_order: 'Se convierte el Lead en Cliente al crear la Orden de Instalación.',
          employee_can_autoassign_orders:
            'Se autoriza al instalador que se asigne como responsable de una Orden disponible.',
          employee_can_schedule_orders:
            'Se autoriza al instalador a elegir fecha y horario para ejecutar sus órdenes (según disponibilidad).',
          same_employee_feasibility_to_installation:
            'Se asignará automáticamente a la Orden de Instalación el mismo instalador que realizó la Orden de Factibilidad.',
          article_management_required_mobile:
            'Se exige confirmación de los Artículos encontrados en el domicilio del Cliente y los Artículos dejados en el lugar antes de finalizar la Orden.',
          track_employees_mobile:
            'Se exige permiso de GPS para registrar la ubicación durante las órdenes y los trayectos entre ellas, útil para trazabilidad y validaciones.',
          photos_required_mobile: 'Se exige cargar fotos del trabajo realizado antes de cerrar la Orden.'
        },
        tracking_level_mobile: {
          hard: 'Alto',
          medium: 'Medio',
          low: 'Bajo',
          none: 'Ninguno'
        }
      }
    },
    news: {
      add_answer: 'Agregar respuesta',
      add_survey: 'Agregar encuesta',
      banner:
        'Selecciona tus preferencias de notificación: suscríbase a los temas de interés para estar al tanto de nuevas funcionalidades, mejoras y correcciones.',
      create_new: 'Crear Novedad',
      delete_survey: 'Eliminar encuesta',
      feedback: {
        likes: 'Me gusta',
        sent: 'Enviadas',
        viewed: 'Vistas'
      },
      news_preview: 'Vista previa de novedad',
      no_record: 'No hay novedades para mostrar',
      no_record_subscriptions: 'No hay suscripciones para mostrar',
      service_not_available_subscriptions:
        'En este momento no es posible cargar las suscripciones, intente nuevamente.',
      service_not_available_news: 'En este momento no es posible cargar las novedades, intente nuevamente.',
      survey_analytics: 'Análisis de encuestas'
    },
    notification_mail: {
      assigned_installation_order: 'Orden de instalación asignada',
      assigned_issue: 'Ticket asignado',
      finalized_issue: 'Ticket Finalizado',
      closed_issue: 'Ticket Cerrado con comentario',
      button: {
        first_image: 'Primera Imagen',
        loading_image: 'Cargando Imagen',
        second_image: 'Segunda Imagen',
        update_mail_notification: 'Actualizar Notificación de correo'
      },
      email_is_not_required: 'En caso de dejarlo en blanco se utilizará el email de la razón social',
      first_image: 'Primera Imagen',
      image_error_format:
        'El archivo adjuntado no es una imagen o el formato no es correcto. Formatos permitidos: jpeg, jpg, png',
      image_error_weight: 'El peso de la imagen no puede exceder los 10 MB',
      issued_invoice: 'Factura emitida',
      mail_notifications_template_title: 'Plantillas de notificaciones de correo',
      new_installation_order: 'Nueva Orden de Instalación',
      new_issue: 'Nuevo Ticket',
      new_payment: 'Nuevo Pago',
      provider_offline: 'Cambios de estado de proveedores',
      second_image: 'Segunda Imagen',
      timeframe_to_notify_upcoming_changes: 'Tiempo de espera para notificar próximos cambios',
      updated_succesful: 'Actualizada exitosamente',
      upload_images: 'Puede subir imágenes:',
      without_permission: 'No tienes permiso'
    },
    notifications: {
      buttons: {
        create: 'Crear Notificación',
        update: 'Actualizar Notificación'
      },
      filter: {
        clients: {
          can_filter_clients_by: 'Puede filtrar Clientes por',
          clients_with_invoice: 'Con facturas pendientes',
          clients_without_invoice: 'Sin facturas pendientes',
          filter_by: 'Filtrar por cliente o zona',
          only_clients_with_email: 'Solo aparecen clientes con email',
          only_clients_with_mobile_phone: 'Solo aparecen clientes con teléfono móvil'
        },
        contracts: {
          filter_by: 'Filtrar por cliente, IP, plan, o zona'
        }
      },
      kinds: {
        mail: '[Mail]',
        sms: '[SMS]',
        web: 'Notificación Web'
      },
      modal_title: {
        mail: 'Notificación de correo',
        sms: 'Notificación SMS',
        web: 'Notificación Web'
      },
      select_a_client: 'Debe seleccionar al menos un cliente',
      select_a_contract: 'Al menos un contrato debe ser seleccionado',
      select_a_unit: 'Seleccione una unidad',
      sms_length_legend:
        'El largo del SMS puede variar si usas diferentes sustituciones, pero no debería exceder 160 caracteres',
      tooltips: {
        show: 'Ver'
      }
    },
    notification_sms: {
      button: {
        update_sms_notification: 'Actualizar Notificación SMS'
      },
      cannot_send_more_until_pay:
        'Envío de SMS desactivado. Esto puede deberse a que su cuenta sea de prueba o tenga su suscripción impaga.',
      characters_count: 'Cantidad de caracteres: ',
      considerations_text:
        'El largo del SMS puede variar si usas diferentes sustituciones, pero no debería exceder {{max_length}} caracteres. Las sustituciones encerradas entre {{}} no serán contadas en el largo del cuerpo',
      considerations_title: 'Consideraciones:',
      contract_alerted: 'Contrato alertado',
      contract_disabled: 'Contrato deshabilitado',
      issued_invoice: 'Factura emitida',
      notification_switches_title: 'Plantillas de notificaciones sms',
      phone_number_blank: 'Debe ingresar un número de teléfono para probar el SMS',
      substitutions_allowed_title: 'Las sustituciones permitidas son:',
      successfully_tested: 'Probado exitosamente',
      successfully_updated: 'Actualizado exitosamente',
      tooltip: {
        first_due_date: 'Primer vencimiento',
        second_due_date: 'Segundo vencimiento'
      },
      without_permission: 'No tienes permiso'
    },
    payments: {
      client_reference: 'Referencia',
      create_new_payment: 'Crear nuevo pago',
      import_payments_count_one: 'Se creará {{count}} pago. ¿Está seguro?',
      import_payments_count_other: 'Se crearán {{count}} pagos. ¿Está seguro?',
      import_payments_from: 'Importar pagos desde {{pg}}',
      payment_amount: 'Monto',
      payment_transaction_id: 'ID',
      form: {
        amount_to_pay: 'Monto a pagar',
        change: 'Cambio',
        client_hint: 'Busque y seleccione las factura que desea pagar.',
        client_input_placeholder: 'Puede buscar por nombre de cliente, id o id personalizable',
        client_input_search_message: 'Escriba 1 caracter para buscar',
        create_payment: 'Crear Pago',
        current_account_credit: 'Crédito en cuenta corriente',
        dont_print_receipt: 'No imprimir recibo',
        unexpected_error_paying_invoice_contact_support: 'Error inesperado al pagar la factura. Contacte a soporte.',
        error_getting_client_account_info: 'Error al obtener la información de la cuenta corriente del cliente',
        error_getting_client_invoices: 'Error al obtener las facturas del cliente',
        error_getting_exchange_information: 'Error al obtener la informacion del conversor de moneda',
        no_pending_invoices_to_show: 'El cliente no tiene facturas pendientes impagas.',
        pay_with_current_account_credit: 'Pagar con crédito de la cuenta corriente',
        payment_details_hint: 'Completa con los siguientes datos para realizar pago:',
        payment_details: 'Detalles del pago',
        save_change_in_account: 'Guardar cambio en cuenta corriente',
        searching_invoices: 'Estamos buscando resultados. Por favor espera un momento',
        total_owed: 'Total adeudado',
        total_to_pay: 'Total a pagar'
      },
      importer: {
        import_kind: 'Tipo de importación',
        no_pg_create_here:
          'No hay pasarelas de pago de {{gateway}} creadas. Para crear una, <anchor>haga clic aquí</anchor>.',
        must_select_an_import_kind: 'Debe seleccionar un tipo de importación',
        must_select_a_payment_gateway: 'Debe seleccionar una pasarela de pago',
        must_select_one_file: 'Debe seleccionar un archivo',
        invalid_file_type: 'Tipo de archivo no soportado. Solo se permiten archivos .csv y .xlsx'
      },
      new_payment: 'Nuevo Pago'
    },
    payment_gateway: {
      create_new_payment_gateway: 'Crear nueva pasarela de pago',
      siro: {
        batch_query: {
          button_tooltip: 'Consultar lote informado en SIRO',
          modal_title: 'Lote SIRO',
          batch_status: 'Estado del lote',
          total_lines: 'Registros procesados',
          correct_lines: 'Registros correctos',
          erroneous_lines: 'Registros con error',
          status_processed: 'Procesado',
          status_pending: 'Pendiente',
          status_error: 'Error',
          malformed_batch: 'El lote fue rechazado por SIRO',
          no_errors: 'El lote no tiene líneas con errores.',
          batch_pending_message: 'SIRO aún está procesando este lote. Reintentá en unos minutos.',
          ticket_number: 'Ticket',
          invoice_number: 'Factura',
          client: 'Cliente',
          amount: 'Monto',
          error: 'Error',
          fetch_error: 'No se pudo consultar el lote en SIRO. Intentá nuevamente.',
          pmc_sent_label: 'Informado a SIRO',
          pmc_first_due: '1° vto',
          pmc_second_due: '2° vto',
          pmc_third_due: '3° vto'
        }
      }
    },
    payment_promises: {
      create: 'Crear promesa de pago',
      searcher: {
        basic_placeholder: 'Puedes buscar por: Nombre y apellido creador, Nombre y apellido cliente'
      },
      without_permission: 'No tienes permiso'
    },
    payment_promise: {
      created_succesful: 'Promesa de pago creada',
      current: 'Vigente',
      custom_no_option_message: 'Puede buscar por: Nombre y apellido',
      deleted_succesful: 'Promesa de pago eliminada',
      expired: 'Expirada',
      kind: {
        manual: 'Manual',
        api: 'API',
        siro: 'SIRO'
      },
      operation_id: 'ID operación',
      payment_promise_title: 'Nueva Promesa de Pago',
      searcher: {
        basic_placeholder: 'Puedes buscar por: Nombre y apellido creador, Nombre y apellido cliente'
      }
    },
    payment_receipts: {
      pagination_info: '{{paginationFilterTotal}} comprobantes filtrados de {{paginationTotalCount}} en total',
      errors: {
        attachment: {
          not_loaded: 'No se pudo cargar el archivo adjunto.'
        }
      },
      state: {
        pending: 'Pendiente'
      }
    },
    pdf: {
      aliquot: 'Alícuota IVA',
      amount_to_pay_in_payment_gateways: 'Monto a cancelar en pasarelas de pago',
      argentina: {
        cobro_digital: {
          code_legend: 'Empresa: Cobro Digital. ID PagoMisCuentas/Link',
          barcode_legend: 'Rapipago, Pagofacil, Banco Bica, ProvinciaNet, Cobro Express, Ripsa, Pronto Pago, Multipago'
        },
        cuenta_digital: {
          code_legend: 'Codigo LinkPagos',
          barcode_legend:
            'Rapipago, Pagofacil, Bapro, CobroExpress, ProvinciaNet, Ripsa, Formo Pagos, Pagolisto, Pronto Pago, PampaPagos, ChubutPagos, Cooperativa Obrera'
        },
        siro: {
          barcode_legend:
            'Rapipago, PagoFacil, ChubutPagos, Pronto Pago, Santa Cruz Servicios, Munipagos, Santa Fe Servicios, Cobro Express, PampaPagos, Formopagos, Corrientes servicios, ProvinciaNet, San Juan Servicios, Bancor',
          code_legend: 'Empresa: Banco Roela SIRO. Código de Pago Electrónico LinkPagos/PagoMisCuentas'
        }
      },
      client_address: 'Dirección cliente',
      client_data: 'Datos del Cliente',
      client_id: 'ID Cliente',
      client_name: 'Nombre cliente',
      client_name_or_invoicing_firm: 'Nombre y Apellido / Razón Social',
      client_observations: 'Observaciones del cliente',
      client_signature: 'Firma y aclaración del cliente',
      colombia: {
        credit_note: 'Nota de Crédito electrónica',
        invoice: 'Factura de venta electrónica',
        first_due_date: 'Fecha de pago oportuno',
        second_due_date: 'Fecha límite de pago',
        service_cutoff_date: 'Fecha de corte de servicio',
        cutoff_date: 'Fecha de corte'
      },
      combo_pay: {
        link: 'Link de pago ComboPay'
      },
      connection_data: 'Datos de conexión',
      contract_id: 'ID Contrato',
      discount_rate: '% Bonif',
      errors: { deleted_contract: 'El contrato ha sido eliminado' },
      equipment: 'Equipamiento',
      first_due_date: '1º Ven',
      gateway_cable_modem: 'Puerta de enlace (Cable Modem)',
      ip_cable_modem: 'IP (Cable Modem)',
      mac_address_cable_modem: 'Mac address (Cable Modem)',
      mercado_pago: {
        link: 'Link MercadoPago. Clic aquí'
      },
      payment_method: {
        mexico: {
          single_payment: 'PUE - Pago en una sola exhibición',
          deferred_or_installments_payment: 'PPD - Pago en parcialidades o diferido'
        }
      },
      payment_way: {
        mexico: {
          cash: '01 - Efectivo',
          nominal_check: '02 - Cheque nominativo',
          electronic_transfer: '03 - Transferencia electrónica de fondos',
          credit_card: '04 - Tarjeta de crédito',
          debit_card: '28 - Tarjeta de débito',
          to_define: '99 - Por definir'
        },
        ecuador: {
          without_financial_system: '01 - Sin utilización del sistema financiero',
          debt_compensation: '15 - Compensación de deudas',
          debit_card: '16 - Tarjeta de débito',
          electronic_money: '17 - Dinero electrónico',
          prepaid_card: '18 - Tarjeta prepago',
          credit_card: '19 - Tarjeta de crédito',
          others_with_financial_system: '20 - Otros con utilización del sistema financiero',
          title_endorsement: '21 - Endoso de títulos'
        }
      },
      payu: {
        efecty: 'Código EFECTY',
        link: 'Link de orden. Clic aquí'
      },
      print_date: 'Fecha de impresión',
      quantity: 'Cant.',
      second_due_date: '2º Ven',
      subtotal_with_iva: 'Subtotal c/IVA',
      tax_ieps: 'IEPS 3%',
      tax_iva_12: 'IVA 12%',
      tax_iva_15: 'IVA 15%',
      tax_iva_16: 'IVA 16%',
      tax_ice_15: 'ICE 15%',
      technician_observations: 'Observaciones del técnico',
      technician_signature: 'Firma y aclaración de técnico',
      total_owed_at_today: 'Deuda al',
      unit_code: 'Unidad',
      username: 'Usuario'
    },
    pdf_viewer: {
      error: 'No se ha podido cargar el archivo PDF.',
      no_data: 'No se ha especificado ningún archivo PDF.',
      page_number: 'Página {{numberPage}} de {{totalPage}}'
    },
    ping: 'Ping',
    plan: {
      time_and_burst_enabled: 'Ráfagas | Control Horario',
      indicators: {
        burst_enabled: 'Ráfaga habilitada',
        burst_disabled: 'Ráfagas deshabilitadas',
        time_enabled: 'Control horario habilitado',
        time_disabled: 'Control horario deshabilitado'
      },
      speed_changes: 'Cambio de Velocidad',
      time_control_times: 'Se aplicará el control horario los días: ',
      time_control_subtitle: 'Control horario desde <1> {{time_from}} </1> hasta <1> {{time_to}} </1>',
      remove_taxes_message: 'A partir del {{bold}} se realizarán los siguientes cambios:',
      remove_taxes_date: '<0>1 de Junio de 2023</0>',
      remove_taxes_message_item_1:
        'Se elimina el {{bold}}, que se configura en el Plan. A partir de 1 de junio en caso de cobrar instalación se hará uso del impuesto seleccionado en cada cliente.',
      remove_taxes_message_item_2:
        'Se elimina el {{bold}}, que se configura en el Perfil de facturación. A partir de 1 de junio en caso de cobrar este recargo se hará uso del impuesto seleccionado en cada cliente.',
      remove_taxes_installation_tax: '<0>impuesto de instalación</0>',
      remove_taxes_recharge_tax: '<0>impuesto del recargo por conexión</0>',
      burst_duration: 'Duración de Ráfaga',
      burst_duration_down: 'Duración de la ráfaga de bajada (Segundos)',
      burst_duration_up: 'Duración de la ráfaga de subida (Segundos)',
      button: {
        submit_create: 'Crear nuevo Plan',
        submit_update: 'Actualizar'
      },
      degraded_percent: 'Porcentaje de ancho de banda del total del plan para un contrato que tiene estado Degradado',
      invoicing_plan_attributes: {
        installation_price: {
          gross_amount:
            'Precio de instalación del servicio, solo se podrá utilizar al momento de generar manualmente la primer factura. <0>IMPORTANTE:</0> El valor es precio final, por lo que incluye cualquier tipo de impuesto en el monto.',
          net_amount:
            'Precio de instalación del servicio, solo se podrá utilizar al momento de generar manualmente la primer factura. <0>IMPORTANTE:</0> El valor es precio neto.'
        },
        price: {
          gross_amount:
            '<0>IMPORTANTE:</0> El valor es precio final, por lo que incluye cualquier tipo de impuesto en el monto.',
          net_amount: '<0>IMPORTANTE:</0> El valor es precio neto.'
        }
      },
      long_download_max: 'Tamaño a partir del cual una descarga HTTP/HTTPS pasa a ser clasificada como tráfico P2P',
      long_upload_max: 'Tamaño a partir del cual una carga HTTP/HTTPS pasa a ser clasificada como tráfico P2P',
      propagate_frequency_to_contracts:
        'Propagar cambio de frecuencia a los contratos asociados Si tienes contratos con frecuencias personalizados, estas frecuencias serán reemplazadas marcando esta opción. Los cambios serán efectivos en el próximo periodo de facturación.',
      propagate_price_to_contracts:
        'Propagar cambio de precio a los contratos asociados Si tienes contratos con precios personalizados, estos precios serán reemplazados marcando esta opción. Los cambios serán efectivos en el próximo periodo de facturación',
      public_description: 'Visible para los clientes desde la aplicación móvil',
      searcher: {
        advanced_placeholder: 'Puedes buscar por: Nombre',
        basic_placeholder: 'Puedes buscar por: Nombre, Precio'
      },
      time_control: 'Control horario',
      time_control_header_title: 'Control <1></1> horario',
      time_from: 'Formato: HH:MM:SS ejemplo: 11:15:00 o 22:10:00',
      time_to: 'Formato: HH:MM:SS ejemplo: 11:15:00 o 22:10:00',
      simple_queue_with_cake_message_notice:
        'El uso de la estrategia <1>Colas simples con cake</1> puede aumentar considerablemente el consumo de CPU. Se recomienda aplicarla con una cantidad reducida de contratos para mantener un buen rendimiento.'
    },
    portal_configuration: {
      all: 'Todos estos campos serán usados en la sección de Portal de Clientes, y podrás personalizarlos para mejorar la experiencia de tus clientes.',
      audits_warning:
        'Se muestran los cambios realizados en el portal de cliente, así como también los realizados en configuración de notificaciones móviles y notificaciones SMS.',
      button: {
        delete: 'Eliminar',
        update: 'Actualizar'
      },
      change_plan_mobile_setting: 'Cambiar Plan',
      company_isotype_hint: 'dimensión máxima {{max}}',
      create_issue_mobile_setting: 'Crear Tickets',
      create_payment_promise_mobile_setting: 'Crear Promesas de pago',
      description:
        'Será mostrado debajo del nombre de tu ISP (Sea considerado con el tamaño del texto por los dispositivos móviles).',
      general_form_title: 'Datos generales',
      graph: 'Hábilitar gráficos de contratos',
      hints: {
        change_plan_mobile_setting: 'Permitir a los clientes solicitar el cambio desde la app.',
        create_issue_mobile_setting: 'Permitir a los clientes crear tickets desde la app.',
        create_payment_promise_mobile_setting: 'Permitir a los clientes crear promesas de pago desde la app.',
        wifi_mobile_setting: 'Permitir a los clientes visualizar la contraseña y solicitar el cambio desde la app.'
      },
      mobile_settings_title: 'App Móvil',
      placeholder: {
        email: 'Email de contacto para dar soporte a clientes.',
        mobile_phone: 'Número de contacto para dar soporte a clientes.',
        name: 'El nombre de tu ISP en la sección de Portal de Clientes.',
        phone: 'Número de contacto para dar soporte a clientes.',
        subdomain: 'El nombre de tu subdominio para el Portal de Clientes',
        telegram_phone: 'Usuario de telegram para dar soporte a clientes.',
        whatsapp_phone: 'Número de contacto para dar soporte a clientes.'
      },
      portal_form_title: 'Portal de clientes',
      portal_logo_hint: 'Dimensión máxima  {{max}}',
      tooltip: {
        click: 'click aquí'
      },
      welcome: 'Habilitar Portal de Clientes',
      wifi_mobile_setting: 'Wifi'
    },
    ppp_profile: {
      cannot_exec_command: 'No se pudo ejecutar el comando',
      isLoad: 'No hay registros para mostrar',
      mikrotik_not_linked: 'MikroTik no vinculado',
      ppp_profiles_title: 'Nuevo Perfil PPP',
      ppp_profiles_title_edit: 'Editar Perfil PPP',
      searcher: {
        basic_placeholder: 'Puedes buscar por: Nombre, Servidor, ID, Dirección IP.'
      },
      'select-ppp_profiles_plan_id-container': 'solo podes elegir esta opcion si switch esta activado',
      show_quantity_records: 'Mostrando perfiles {{beginRecords}} - {{endRecords}} de {{total}} en total',
      show_total_records: 'Mostrando {{total}} perfiles',
      use_rate_limit_off:
        'OFF: Perfil dependiente del plan, los cambios de ancho de banda ({{up}} / {{down}}) que se realicen en el plan, afectarán al perfil.',
      use_rate_limit_on:
        'ON: Perfil independiente de un plan, es necesario definir los anchos ({{up}} / {{down}}) de bandas en el propio perfil',
      use_rate_limit_title: 'Personalizar perfil',
      define_rate_limit_title: 'Definir ancho de banda'
    },
    react_quill: {
      editor: {
        align: 'Alinear',
        background_color: 'Color de fondo',
        bold: 'Negrita',
        code_block: 'Bloque de código',
        code_view: 'Ver código fuente',
        color: 'Color',
        font_family: 'Fuente',
        font_size: 'Tamaño de la fuente',
        highlight: 'Resaltar',
        headings: {
          normal: 'Normal',
          subtitle: 'Subtítulo',
          title: 'Título'
        },
        indent: 'Más tabulación',
        insert_link: 'Insertar enlace',
        italic: 'Cursiva',
        ordered_list: 'Lista ordenada',
        outdent: 'Menos tabulación',
        picture: 'Imagen',
        quote: 'Cita',
        redo: 'Rehacer',
        remove_styles: 'Quitar estilo',
        size: 'Tamaño',
        start_typing_here: 'Comienza a escribir aquí...',
        styles: 'Estilo',
        substitutions: 'Sustituciones',
        substitutions_tooltip: 'Al hacer click, se agregará la llave al cuerpo',
        underline: 'Subrayado',
        undo: 'Deshacer',
        unordered_list: 'Lista desordenada'
      },
      susbtitutions: {
        amount: 'Monto',
        client_avatar: 'Avatar del cliente',
        client_full_address: 'Dirección completa de cliente',
        client_link_mobile_login: 'Link de login de cliente (App mobile)',
        client_mobile_phone: 'Teléfono móvil del cliente',
        client_name: 'Nombre del cliente',
        company_logo: 'Logo de la compañia',
        contract_full_address: 'Dirección completa del contrato',
        contract_ip: 'IP del contrato',
        date: 'Fecha',
        first_image: 'Primer imagen',
        installation_order_client_name: 'Nombre de Cliente',
        installation_order_number: 'Número de orden de instalación',
        installation_order_plan_name: 'Nombre del plan',
        invoice_balance: 'Balance',
        invoice_first_due_date: 'Primer vencimiento',
        invoice_issued_at: 'Fecha de Autorización',
        invoice_second_due_date: 'Segundo vencimiento',
        issue_number: 'Número',
        payment_amount_currency: 'Moneda',
        payment_created_at: 'Fecha de creación',
        payment_transaction_kind: 'Forma de pago',
        pending_invoices: 'Facturas pendientes',
        plan_name: 'Nombre del plan',
        portal_link: 'Link al portal',
        second_image: 'Segunda imagen',
        issue_closed_comment: 'Comentario de Ticket Cerrado'
      }
    },
    recurring_item: {
      count_of_items: 'Periodos facturados',
      every_period: 'Incluir en todos los periodos',
      infinite: 'Infinito',
      lapse: {
        every_period: 'Todos los periodos'
      },
      remaining_items: 'Periodos restantes',
      summary: 'Resumen'
    },
    sale_desk: {
      lead: {
        client_not_generated: 'Cliente no generado',
        click_here_to_go_to_client: 'Haga clic aquí para ir al cliente',
        convert_to_client: 'Convertir a Cliente',
        enter_international_phone_number: 'Ingrese el número en formato internacional',
        format_international: '+[código de país][código de área][código móvil][número]',
        generated_client: 'Cliente generado',
        show_lead_detail: 'Ver detalle del lead',
        zone: 'Zona'
      },
      prospect: {
        availabel_connection_points: 'Punto(s) de conexión disponible(s)',
        connection_point: 'Punto de conexión',
        convert_to_contract: 'Convertir a Contrato',
        converted: 'Ganados',
        generated_contract: 'Contrato generado',
        last_ticket_tags: 'Etiquetas del último ticket',
        lost: 'Perdidos',
        pending: 'Pendientes',
        pending_ticket: 'Tickets en curso',
        search_by_leads_name: 'Busque por nombre de Lead',
        unexpected_error_getting_prospect: 'Error inesperado al obtener el prospecto',
        zone: 'Zona'
      },
      ticket: {
        add_tags: 'Agregar etiquetas',
        assigned_employee_is_from_another_zone: 'El empleado asignado pertenece a una zona distinta',
        attachments: 'Archivos adjuntos',
        attachments_uploaded_successfully: 'Archivos adjuntos subidos exitosamente',
        change_ticket_state: 'Cambiar estado del ticket',
        change_ticket_tags: 'Cambiar las etiquetas del Ticket',
        comments_attachments: 'Comentarios y archivos adjuntos',
        create_ticket_with_this_client: 'Crear ticket para este Cliente',
        create_ticket_with_this_lead: 'Crear ticket para este Lead',
        error_fetching_contact_information: 'Error al obtener la información de contacto',
        lead_has_no_prospects: 'El Lead no tiene Prospectos',
        must_select_a_lead: 'Debe seleccionar un Lead',
        must_select_a_plan_before_discount: 'Debe seleccionar un plan antes de seleccionar un descuento',
        new: {
          summary: 'Resumen',
          create_ticket: 'Crear Ticket',
          create_ticket_with_installation: 'Crear Ticket + Instalación',
          create_ticket_with_feasibility: 'Crear Ticket + Factibilidad',
          packs_card: {
            title: 'Paquetes de DGO',
            placeholder_search: 'Buscar paquete de DGO...'
          },
          discount_card: {
            placeholder_search: 'Buscar descuento...'
          },
          recurring_item_card: {
            placeholder_search: 'Buscar item recurrente...'
          }
        },
        new_ticket_state: 'Nuevo estado del ticket',
        no_attachments_to_preview: 'No hay archivos adjuntos para previsualizar',
        remove_employee: 'Quitar empleado',
        remove_tag: 'Quitar etiqueta',
        schedule_date: 'Programar fecha',
        searcher: {
          basic_placeholder: 'Puedes buscar por: Nombre de Lead'
        },
        show: {
          click_here_to_try_again: 'Haga clic aquí para intentar nuevamente',
          error_fetching_orders: 'Ocurrió un error al obtener las ordenes',
          error_fetching_comments: 'Ocurrió un error al obtener los comentarios',
          error_fetching_images: 'Ocurrió un error al obtener las imágenes'
        },
        upload_attachments_dropzone: 'Arrastre y suelte los archivos que desea subir o haga clic para seleccionar',
        zone: 'Zona'
      },
      tickets: {
        pending: 'Pendientes',
        pending_order: 'Orden en curso',
        success: 'Ganados',
        failure: 'Perdidos'
      }
    },
    seal: {
      bulk_actions: {
        delete: {
          background_title: 'Eliminación en proceso',
          background_message: 'Los precintos seleccionados se están eliminando en segundo plano.',
          warning_message: 'Esta acción no se puede deshacer.'
        }
      },
      code: {
        unit: {
          create_unit_seal: 'Ingrese un código y presione Enter'
        }
      },
      only_coordinates_can_be_converted: 'Solo se pueden convertir coordenadas en formato DMS',
      search_by_nap_name: 'Busque por nombre de NAP'
    },
    sent_sms: {
      cannot_send_more_until_pay:
        'Envío de SMS desactivado. Esto puede deberse a que su cuenta sea de prueba o tenga su suscripción impaga.',
      category: {
        contract_alerted: 'Contrato alertado',
        contract_disabled: 'Contrato deshabilitado',
        issued_invoice: 'Factura emitida',
        manual: 'Manual'
      },
      clickatell_errors: {
        account_is_not_active: 'La cuenta no está activa.',
        empty_message_content: 'El contenido está vacío.',
        integration_is_not_active: 'La integración no ha sido activada. Active la integración primero.',
        invalid_destination_address: 'El número de destino es inválido.',
        invalid_or_missing_integration_api_key:
          'La API key de integración es incorrecta o no fue incluída en la llamada.',
        maximum_message_parts_exceeded: 'Máximo de partes de mensaje excedido.',
        not_enough_money: 'No hay suficiente dinero',
        too_long_input_phone: 'El número de teléfono es muy largo',
        too_short_input_phone: 'El número de teléfono es muy corto',
        us_numbers_limitation: 'Números de USA están limitados por la CTIA.'
      },
      is_load: 'No se encontró SMS Enviados',
      searcher: {
        paid: 'cobrados',
        to_pay: 'por cobrar'
      },
      state: {
        cancelled: 'Cancelado',
        discarded: 'Descartado',
        error: 'Error',
        processed: 'Procesado',
        scheduled: 'En cola',
        sent: 'Enviado',
        unreachable: 'Inalcanzable'
      },
      test_sms: 'SMS de prueba',
      title_badge: 'Mensual',
      title_category: 'Categorías SMS',
      title_price: 'Precio estimado para la próxima factura',
      title_sent_sms: 'SMS Enviados'
    },
    sidenav: {
      advanced_configuration: 'Configuración avanzada',
      authorized_not_linked_onts: 'ONUs autorizadas sin contrato',
      automigrator: 'Automigrador',
      bmu_versions: 'Versiones de BMU',
      changelogs: 'Historial de mejoras',
      changes_history: 'Cambios recientes',
      cloud_summary: 'Resumen',
      configuration: 'Configuración',
      dashboard: 'Panel de control',
      drafts: 'Borradores',
      inventory: 'Inventario',
      issued: 'Emitidas',
      kind_feedback: 'Tipos de feedback',
      manuals: 'Manuales',
      optic_fiber: 'Fibra Óptica',
      orders: 'Órdenes',
      portal_configuration: 'Portal de Clientes',
      referrals: 'Referidos',
      schedule: 'Planificar',
      stripe_account: 'Datos de facturación',
      terms_and_conditions: 'Términos y Condiciones',
      wispro_admin: 'Wispro Admin',
      olt_server_interfaces: 'Redes'
    },
    smtp_configuration: {
      send_test_email: 'Enviar correo de prueba',
      send_test_invalid_email: 'Indique una dirección de correo electrónico válida.',
      send_test_invalid_response: 'La solicitud ha fallado con el status {{status}}. Por favor, inténtalo de nuevo.',
      send_test_unable_to_send: 'No se ha podido enviar el correo de prueba.',
      send_test_email_sent: 'Email enviado',
      send_test_success_sent:
        'Se ha enviado un correo electrónico de prueba a {{email}}. Compruebe su bandeja de entrada.',
      update_smtp_message: 'Configuración SMTP Actualizada: {{message}}',
      smtp_message: 'Configuración SMTP: {{message}}',
      authentication: {
        cram_md5: 'MD5(cram_md5)',
        login: 'Sesión(login)',
        plain: 'Plano(plain)'
      },
      button: {
        send: 'Enviar correo de prueba',
        submitCreate: 'Crear configuración de SMTP',
        submitUpdate: 'Actualizar configuraciones de SMTP'
      },
      switch_enable: 'Habilitado',
      switch_tls: 'Auto TLS',
      title: 'Configuración SMTP para enviar emails con tu propia cuenta'
    },
    tv_services: {
      directv_go: {
        transaction_actions: {
          delete_success: 'Transacción eliminada correctamente',
          delete_error: 'Error al eliminar la transacción',
          restore_success: 'Transacción restaurada correctamente',
          restore_error: 'Error al restaurar la transacción',
          delete_confirm_title: 'Eliminar deuda',
          delete_confirm_text:
            '¿Estás seguro que deseas eliminar esta deuda del cliente? Podra revertir esta accion filtrando con "Incluir eliminadas" y haciendo click en la accion "Restaurar".',
          restore_confirm_title: 'Restaurar deuda',
          restore_confirm_text:
            '¿Estás seguro que deseas restaurar esta deuda? Será incluida en la próxima factura de servicio del cliente.'
        },
        header_title_discount: 'Cálculo para los Descuentos',
        header_title_revenue: 'Calculo para las Comisiones',
        header_unit_total_amount: 'Total sin IVA',
        header_percentage_discount: '% de Descuento',
        header_percentage_revenue: '% de Comisión',
        header_total_discount: 'Total Descuento',
        header_total_revenue: 'Total Comisión',
        proportional_cal_title: 'Cálculo para Montos Proporcionales',
        date_from: 'Desde',
        date_to: 'Hasta',
        activate_plans: 'Activar Planes',
        active_plans: 'Planes Activos',
        basic_plans: 'Planes Basicos',
        cancel_subscription: 'Cancelar Suscripción',
        sync_subscription: 'Resincronizar',
        unknown_pack: 'Desconocido',
        errors: {
          provider_not_found: 'No se Encontró al Proveedor'
        },
        configure_directv_go: {
          api_key: {
            configure: 'Configurar',
            configuring: 'Configurando',
            request_credentials: 'Solicitar credenciales',
            subtitle: 'Configure el servicio con las credenciales otorgadas por DirectvGo',
            title: 'Configurar DirectvGo'
          },
          test_date: {
            generate: 'Configurar',
            generating: 'Configurando',
            subtitle:
              'Se deben generar datos de prueba para validarlos con DirectvGo y verificar que todo funciona correctamente',
            title: 'Generacion de Datos de Prueba'
          }
        },
        confirm_subscription_form: {
          title: '¿Está seguro?',
          subtitle_create: 'Se creará una nueva suscripción con los siguientes datos:',
          subtitle_update: 'Se actualizará la suscripción con los siguientes datos:'
        },
        inactive_plans: 'Planes Inactivos',
        info_card: {
          subtitle: 'Solicite el servicio de DirectvGo contactando con Wispro. Para mas información <0>click aquí</0>',
          title: 'Solicitud de DirectvGo'
        },
        service_will_be_active_next_month: 'El servicio se activará el mes próximo',
        service_will_be_cancelled_on: 'El servicio será cancelado el {{date}}',
        service_will_be_cancelled_end_of_month: 'El servicio será cancelado a final de mes',
        no_packs_message_action: 'Configurar Planes',
        no_packs_message_subtitle: 'Pueden ser configurados en la pantalla de Configuración de Directv Go',
        no_packs_message_title: 'No hay packs configurados',
        pack_info: 'Pack info',
        pack_kind: {
          basic: 'Básico',
          premium: 'Premium'
        },
        aditional_plans: 'Planes Adicionales',
        total_to_dgo: 'Total a DGO',
        subscription_state_tooltips: {
          to_inactive: 'La suscripción se inactivará a fin de mes',
          suspended: 'La suscripción se suspendió ya que el contrato se deshabilitó. <br/>Para reactivar la subscripcion habilite el contrato'
        },
        suspended_alert: '<strong>La suscripción se encuentra suspendida</strong> por lo que:<ul><li>No posee acceso a la plataforma DGO</li><li>No se le generará deuda de DGO</li><li>No se le aplican cambios programados de plan</li></ul>Se rehabilitará al habilitarse el contrato',
        reactivate_subscription: 'Reactivar Suscripción',
        resume_service: 'Reanudar Servicio',
        view_conciliations: 'Ver conciliaciones',
        view_invoicing_summary: 'Ver resumen de facturación',
        name_and_lastname_subscription: 'Nombre y Apellido de la suscripción',
        subscription_email: 'Email de la suscripción',
        creation_date_acc: 'Fecha de creación de cuenta',
        date_of_discharge_date: 'Fecha de Alta del servicio',
        cant_download_transactions: 'No se puede descargar las transacciones del mes actual',
        create_new_pack: 'Crear nuevo Pack',
        must_set_update_date: 'Debe establecer una fecha de actualización',
        cant_modify_kind_with_active_subscriptions:
          'No puedes modificar el tipo si suscripciones activas ya poseen este plan',
        cant_modify_urns_with_active_subscriptions:
          'No puedes modificar las URN si suscripciones activas ya poseen este plan'
      }
    },
    zone: {
      created_succesful: 'Zona creada',
      deleted_succesful: 'Zona eliminada',
      is_load: 'No se encontró Zonas',
      searcher: {
        basic_placeholder: 'Puedes buscar por: Nombre'
      },
      updated_succesful: 'Zona actualizada',
      zones_title: 'Nueva Zona',
      zones_title_edit: 'Editar Zona'
    },
    olt: {
      firmware: {
        homologation_states: {
          unknown: 'Firmware desconocido',
          unsupported: 'Firmware no soportado',
          supported: 'Firmware soportado',
          indeterminate: 'Indeterminado'
        },
        modal: {
          title: 'Test de Homologación de Firmware'
        },
        tooltip: {
          title: 'Estado del Firmware',
          status: 'Estado',
          model: 'Modelo',
          version: 'Versión',
          release_date: 'Lanzamiento',
          error_message: 'No se pudo obtener el firmware de la OLT'
        },
        homologation: {
          categories: {
            basic_olt_info: 'Información Básica OLT',
            basic_olt_actions: 'Acciones Básicas OLT',
            authoriation: 'Autorización',
            authorization_basic: 'Autorización',
            onu_actions: 'Acciones ONU',
            onu_info: 'Información ONU'
          },
          tests: {
            basic_info: 'Información Básica',
            capabilities: 'Capacidades',
            onu_info: {
              show_ont_authorization_info: 'Información de Autorización ONU',
              show_ont_capability_info: 'Información de Capacidades ONU',
              show_ont_info: 'Información ONU',
              show_ont_optical_info: 'Información Óptica ONU',
              show_ont_ports_info: 'Información de Puertos ONU',
              show_ont_version_info: 'Información de Versión ONU',
              show_ont_wan_info: 'Información WAN ONU'
            },
            show_ont_authorization_info: 'Información de Autorización ONU',
            show_ont_capability_info: 'Información de Capacidades ONU',
            show_ont_info: 'Información ONU',
            show_ont_optical_info: 'Información Óptica ONU',
            show_ont_ports_info: 'Información de Puertos ONU',
            show_ont_version_info: 'Información de Versión ONU',
            show_ont_wan_info: 'Información WAN ONU',
            test_activate: 'Activar',
            test_alarms: 'Alarmas',
            test_authorization_basic: 'Autorización Básica',
            test_authorization_bridge: 'Autorización Bridge',
            test_authorization_dhcp: 'Autorización DHCP',
            test_authorization_pppoe: 'Autorización PPPoE',
            test_authorization_static: 'Autorización Estática',
            test_authorized_onus: 'ONUs Autorizadas',
            test_create_vlan: 'Crear VLAN',
            test_deactivate: 'Desactivar',
            test_disable_catv: 'Deshabilitar CATV',
            test_enable_catv: 'Habilitar CATV',
            test_factory_reset: 'Restablecimiento de Fábrica',
            test_mac_address_table: 'Tabla de Direcciones MAC',
            test_reboot: 'Reiniciar',
            test_signals: 'Señales',
            test_tr069: 'TR-069',
            test_traffic_control: 'Control de Tráfico',
            test_unauthorized_onus: 'ONUs No Autorizadas',
            test_uplink_interfaces: 'Interfaces Uplink'
          },
          modal: {
            error_title: 'Error al ejecutar el test',
            error_default_message: 'No se pudo completar el test de homologación. Intente nuevamente más tarde.',
            instruction: 'Ejecute un test para verificar el estado de homologación del firmware.',
            result_title: 'Resultado del Test',
            detailed_results: 'Resultados Detallados',
            no_data_title: 'Firmware desconocido',
            passed: 'aprobados',
            run_test: 'Ejecutar Test',
            test_running_title: 'Test en proceso...',
            test_running_subtitle: 'Aguarde mientras homologamos la OLT'
          }
        }
      },
      autodiscover_onts: 'Autodescubrimiento de ONUs',
      available_plans: 'Planes disponibles',
      available_plans_hint: 'Planes disponibles para los contratos conectados a esta OLT',
      olt_should_be_linked: 'La OLT debe estar Vinculada',
      how_to_interpret_it: '¿Cómo interpretarlo?',
      no_default_plan: 'Ningún plan',
      one_default_plan: '1 plan',
      default_plans_count: '{{count}} planes',
      reset_to_default_value: 'Reestablecer al valor por defecto ({{message}})',
      statistics: 'Estadísticas',
      tooltip_message_info_critical_interfaces: 'Puertos críticos con ONUs vinculadas a contratos',
      tooltip_message_info_interfaces: 'Puertos con ONUs vinculadas a contratos',
      tooltip_message_info_naps_capacity_total: 'Capacidad Total',
      tooltip_message_info_naps_capacity_total_full_message:
        'Capacidad total en las NAPs, incluyendo las ranuras ocupadas y libres',
      tooltip_message_info_naps_free_slots: 'Ranuras Libres',
      tooltip_message_info_naps_free_slots_full_message: 'Cantidad de ranuras libres en NAPs',
      tooltip_message_info_naps_onts_linked: 'ONUs vinculadas a NAPs',
      tooltip_message_info_naps_onts_linked_full_message: 'Cantidad de ONUs que se encuentran vinculadas a NAPs',
      tooltip_message_info_onts_auth_with_contracts: 'ONU Vinculadas con contratos',
      tooltip_message_info_olts_auth_with_contracts: 'OLT Vinculadas con contratos',
      tooltip_message_info_onts_auth_without_contracts: 'ONU sin vincular a contratos',
      tooltip_message_info_onts_auth_totals: 'Total de ONU Autorizadas',
      tooltip_message_info_onts_auth_with_contracts_full_message:
        'Cantidad de ONUs que se encuentran autorizadas y vinculadas a algún contrato.',
      tooltip_message_info_onts_auth_without_contracts_full_message:
        'Cantidad de ONUs disponibles que se encuentran autorizadas para vincular a algún contrato',
      tooltip_message_info_onts_auth_totals_full_message:
        'Total de ONUs, tanto las autorizadas con contratos como las autorizadas sin contratos.',

      tooltip_message_info_onts_connected: 'ONUs online con contrato',
      tooltip_message_info_onts_connected_full_message: 'Cantidad de ONUs con contrato online.',
      tooltip_message_info_onts_noConnected: 'ONUs online sin contrato',
      tooltip_message_info_onts_noConnected_full_message:
        'Cantidad de ONUs online que no están vinculadas a un contrato en Wispro.',
      tooltip_message_info_onts_linked_offline: 'ONUs offline con contrato',
      tooltip_message_info_onts_linked_offline_full_message: 'Cantidad de ONUs con contratos offline.',
      tooltip_message_info_onts_linked: 'ONUs vinculadas con contrato',
      tooltip_message_info_onts_linked_full_message: 'Cantidad total de ONUs con contratos.',
      tooltip_message_info_onts_connectedTotal: 'Total de ONUs online',
      tooltip_message_info_onts_connectedTotal_full_message:
        'Sumatoria de todas las ONUs online (online con contrato + online sin contrato).',

      tooltip_message_info_onts_ok_signal: 'ONUs con señales óptimas',
      tooltip_message_info_onts_ok_signal_full_message:
        'Cantidad de ONUs con señales óptimas. Estas funcionan correctamente',

      tooltip_message_info_onts_warning_signal: 'ONUs con señales de advertencia',
      tooltip_message_info_onts_warning_signal_full_message:
        'Cantidad de ONUs con señales en estado de advertencia, estas superaron el umbral óptimo de potencia',

      tooltip_message_info_onts_critical_signal: 'ONUs con señales críticas',
      tooltip_message_info_onts_critical_signal_full_message:
        'Cantidad de ONUs con señales en un estado Crítico, estas ONUs están por superar los umbrales críticos de potencia',

      tooltip_message_info_onts_total_signals: 'Total de ONUs',
      tooltip_message_info_onts_total_signals_full_message:
        'Total de ONUs, conectadas, autorizadas y vinculadas con contratos.',

      tooltip_title_critical_nap_alarm: 'Capacidad de NAPs casi completada',
      tooltip_explanation_critical_nap_alarm: 'Capacidad de NAPS casi completada',
      tooltip_title_critical_not_linked_alarm: 'ONUs autorizadas sin contrato',
      tooltip_explanation_critical_not_linked_alarm: 'ONUs autorizadas sin contrato',
      tooltip_title_critical_alarms: 'Alarmas críticas y mayores de hoy',
      tooltip_explanation_critical_alarms: 'Alarmas críticas o mayores',
      tooltip_title_critical_interfaces: 'Puertos críticos',
      tooltip_explanation_critical_interfaces_reason1: 'Tiene al menos 1 ONU con señal crítica',
      tooltip_explanation_critical_interfaces_reason2: 'Tiene más del 80% de las ONUs con señal alarmante',
      tooltip_explanation_critical_interfaces_reason3: 'Tiene alguna alarma crítica o mayor',
      update_alarms_info_at: 'Última consulta realizada',
      update_authorized_info_at: 'Actualización de info de OLTs Autorizadas en',
      update_unauthorized_info_at: 'Actualización de info de OLTs No Autorizadas en',
      rx_power_critical_lower: 'Potencia crítica inferior',
      rx_power_warning_lower: 'Potencia advertencia inferior',
      rx_power_warning_upper: 'Potencia advertencia superior',
      rx_power_critical_upper: 'Potencia crítica superior',
      free: 'No Vinculado',
      rx_power_threshold: 'Alerta de Potencia',
      adapter_error:
        'Ocurrió un error de comunicación con la OLT, intente nuevamente. Si el problema persiste, contacte a soporte',
      apply_changes: 'Aplicar cambios',
      apply_changes_error: 'Hubo un error al aplicar cambios.',
      apply_changes_status: 'Estado de cambios aplicados',
      apply_changes_succeed: 'Los cambios pendientes han sido enviados al equipo',
      applying_changes: 'Aplicando cambios',
      auth_info: 'Información de Autenticación',
      auth_ont: 'Autorizar ONU',
      auth_ont_more_info_available: 'Hay más información disponible',
      auth_ont_get_more_info: 'Haga clic para consultarla',
      authorized_onts: 'ONUs autorizadas',
      backup: {
        download_backup_error: 'Ha ocurrido un error al descargar el backup. Intente nuevamente más tarde',
        fetch_backups_error: 'Ha ocurrido un error al buscar los backups. Intente nuevamente más tarde',
        generate_backup: 'Generar Backup',
        generate_backup_error: 'Ha ocurrido un error al generar el backup. Intente nuevamente más tarde',
        generate_backup_success: 'Backup generado. Puedes encontrarlo al principio de la lista',
        no_data: 'No hay backups disponibles'
      },
      basic_info: 'Información Básica',
      bridge: 'Puente',
      cannot_get_traffic_profiles:
        'No se pudo obtener información de los traffic profiles. Intente nuevamente, si el problema persiste contacte a soporte.',
      cant_get_optical_info_from_physicial_olt: 'No se pudo obtener información óptica de la OLT',
      capa2_info: 'Información Capa 2',
      catv_config_not_supported: 'La ONU no soporta configuración de CATV',
      catv_control_disabled_text: 'Los contratos deshabilitados seguirán teniendo servicio de CATV.',
      catv_control_enabled_text: 'Los contratos deshabilitados NO tendrán servicio de CATV.',
      equipment_model_auto_detect_hint: 'Si no selecciona el modelo, se intentará obtener desde la OLT al vincularla.',
      catv_control_label: 'Control CATV',
      catv_info: 'Información de CATV',
      catv_ports_info: 'Información de los Puertos CATV',
      check_service_wait: 'Comprobando servicio, por favor aguarde.',
      autodiscover_onts_wait: 'Autodescubrimiento de ONUs, por favor aguarde.',
      choose_an_option: 'Seleccione una opción',
      click_here_to_refresh_list: 'Actualizar desde la OLT: ',
      configuration_error: 'Hubo un error en la configuración. Contacte con soporte',
      contract_placeholder: 'Puede buscar por: Nombre cliente, Direccion IP, Nombre plan',
      contract_searcher_placeholder: 'Nombre cliente, Direccion IP, Plan',
      couldnt_get_models_for_brands: 'No se pudieron obtener los modelos para las siguientes marcas',
      created_at: 'Creado',
      credentials: 'Credenciales',
      current_wan_config: 'Configuración actual de la WAN',
      dashboard: {
        authorized_onts: 'Autorizadas',
        critical_alarms: 'Alarmas críticas o mayores',
        critical_interfaces: 'Interfaces críticas',
        error_querying_olt: 'Error al consultar OLT',
        interfaces_no_records: 'No hay interfaces para mostrar',
        linked_olts: 'OLTs vinculadas',
        linked_olts_no_records: 'No hay OLTs vinculadas para mostrar',
        linked_status: 'Conectadas',
        not_authorized: 'No autorizadas',
        olts_queried: 'OLTs consultadas',
        querying_olt: 'Consultando OLT',
        retry_olts_with_errors: 'Reintentar OLTs con errores',
        see_ports: 'Ver puertos',
        see_alarms: 'Ver alarmas',
        select_olt_to_show_info: 'Seleccione una OLT para ver mas información',
        signal_status: 'Señal',
        successfull_olt_query: 'Consulta de OLT exitosa',
        title: 'Detalle ONUs',
        title_hint: 'La actualización de datos depende del tiempo de respuesta de cada OLT',
        update_alarms_info_at: 'Consulta de alarmas realizada el',
        update_authorized_info_at: 'Consulta de ONUs autorizadas realizada el',
        update_unauthorized_info_at: ' Consulta de ONUs no autorizadas realizada el',
        duration_update_authorized_info: 'Tiempo consulta ONUs autorizadas',
        duration_update_unauthorized_info: 'Tiempo consulta ONUs no autorizadas',
        duration_update_alarms_info: 'Tiempo consulta alarmas'
      },
      delete_downstream_gem_traffic_not_supported: 'El control de ancho de banda no está soportado por la OLT',
      delete_upstream_gem_traffic_not_supported: 'El control de ancho de banda no está soportado por la OLT',
      dhcp: 'DHCP',
      downstream_gem_traffic_not_supported: 'El control de ancho de banda no está soportado por la OLT',
      downstream_traffic_control: 'Control de ancho de banda de bajada',
      due_license_detail: 'Su suscripción no está al día, por favor verifique su suscripción y medios de pago',
      due_license_error: 'Suscripción vencida',
      error_apply_changes: 'Hubo un error al aplicar cambios: {{errors}}',
      exceded_max_outbound_speedlimit_entry:
        'Se alcanzó el número máximo posible de service-ports con control de ancho de banda de bajada, se realizó control solo de subida. Contacte con soporte para verificar si es posible actualizar el firmware de la OLT para resolver el problema.',
      export_authorized_not_linked_onts: {
        error_toastr: {
          unauthorized: 'No puede realizar esta accion',
          only_one_pending_export_allowed: 'Existe una exportación pendiente.\nRecibirá los resultados en su correo',
          olt_not_linked: 'La OLT debe estar enlazada para realizar la exportación',
          unable_to_schedule_export: 'Error al programar exportación',
          default_error: 'Error al exportar ONUs.\nIntente nuevamente o verifique la OLT'
        },
        tooltip: 'Exportar ONUs autorizadas no vinculadas',
        success_toastr: 'Recibirá un correo con los resultados'
      },
      failed_to_get_ont_optical_info: 'ONU Offline: No se pudo obtener la información óptica.',
      general_error: 'Algo salió mal, por favor contacte con soporte.',
      general_info: 'Información General',
      import_error: 'Ha ocurrido un error importando su configuración. Por favor contacte con soporte.',
      invalid_ont_interface:
        'La ONU fue modificada por fuera de Wispro. Debe reescribir la configuración de la ONU para poder aplicar cambios desde Wispro',
      ip_mode_hint:
        'Al usar modo Router({{ip_mode}}) el tipo de conexión de la WAN lo determina la configuración del contrato.',
      is_ont_missing: 'No encuentra su ONU?',
      last_acked_pending_sync_does_not_match: 'No coincide la secuencia de sincronización',
      last_synchronization: 'Última sincronización',
      last_unsuccessfully_applied_bmu_pending_sync: 'Última aplicación sin éxito del BMU pendiente de sincronización',
      link: 'Vinculación',
      link_error: 'Hubo un error al vincular: {{errors}}',
      link_olt:
        'La vinculación puede tardar unos minutos ya que se intentará importar toda la configuración de la OLT.',
      link_olt_success: 'Vinculado con OLT exitosamente"',
      link_olt_vsol:
        'Para el correcto funcionamiento es necesario desactivar la funcionalidad "autolearn" en la OLT. Para mayor información al respecto contacte con soporte.',
      link_ont: 'Vincular ONU',
      link_ont_advertise:
        'Al vincular la ONU con un contrato, se sobrescribirán las configuraciones actuales con las de Wispro.',
      linked: 'Vinculado',
      linked_with: 'Vinculado con',
      linking_olt: 'Vinculando OLT, por favor aguarde.',
      loading_status: 'Cargando...',
      msg_time_out: 'Tiempo de espera excedido, intente más tarde',
      never: 'Nunca',
      no_more_numbers: 'No hay más números',
      no_options: 'No se encontraron resultados',
      no_related_information_to_show: 'No hay información relacionada para mostrar',
      no_wan_config: 'No hay configuraciones WAN para mostrar',
      not_linked: 'no vinculado',
      not_supported_wan_config: 'La ONU no soporta configuración WAN desde la OLT',
      number_ont_already_use: 'ONU ID está en uso',
      offline: 'desconectado',
      olt_summary: 'Resumen de la OLT',
      online: 'conectado',
      ont: {
        auth_onts_with_contracts: 'Autorizadas <1>CON</1> Contratos',
        auth_onts_without_contracts: 'Autorizadas <1>SIN</1> Contratos',
        board: 'Board',
        filter_onts_by: 'Filtrar ONUs por',
        frame: 'Frame',
        interface: 'Interfaz',
        full_interface: 'Interfaz F/B/P:N',
        mac_address: 'Dirección MAC',
        port: 'Puerto',
        serial: 'Nº de serie',
        unauth_onts: '<0>NO</0> Autorizadas'
      },
      onu_auth_mode_must_be_in_sn: 'Debe tener ONU auth mode por SN',
      ont_authorized_but_failed_to_save:
        'La ONU fue autorizada, pero hubo un error al guardar la configuración en la OLT',
      ont_doesnt_support_wan_configuration: 'La ONU no soporta configuración WAN',
      ont_info: 'Información de la ONU',
      ont_not_exist: 'La ONU no existe',
      ont_not_exist_in_physicial_olt: 'La ONU no existe en la OLT física',
      ont_not_online: 'La ONU no está conectada',
      ont_provision: 'Aprovisionamiento ONU',
      ont_rate_info: 'ONU-RATE (control de ancho de banda de bajada)',
      ont_state_info: 'Historial de estados',
      ont_autolinked: 'ONUs autovinculadas',
      onu_in_another_frame_or_board_or_port: 'La ONU está en otro frame, board o puerto',
      onu_info: 'Información de la ONU',
      onu_is_offline: 'La ONU está desconectada',
      onu_offline: 'La ONU está desconectada',
      password: 'Contraseña',
      pending_changes: 'Cambios pendientes',
      pending_rules: 'Reglas Pendientes',
      pending_rules_keys: {
        autosave_time: 'Configuración de autoguardado diario',
        plan: 'Plan',
        service_port: 'Service Port',
        traffic_control: 'Traffic control',
        traffic_table_inbound: 'Traffic table inbound',
        traffic_table_outbound: 'Traffic table outbound',
        unauthorize_onu: 'Unauthorize onu',
        unknown: 'Unknown',
        update_onu: 'Update onu'
      },
      pppoe: 'PPPoe',
      profiles_info: 'Información de Perfiles',
      reboot_ont: 'La ONU se reiniciará y quedará sin navegación por unos minutos, ¿Desea continuar?',
      reconfig_ont:
        'Al reescribir la configuración, se desautorizará la ONU y se volverá autorizar y configurar con toda la información establecida en el contrato.',
      reconfig_wan: 'Se reescribirá la configuracion WAN, ¿Desea continuar?',
      factory_reset_ont:
        'Esta acción eliminará todos los ajustes del usuario incluyendo nombre y contraseña del Wi-Fi, redirección de puertos, VLANs, etc.<br/> Al finalizar, la ONU quedará en su estado original y sin conexión hasta que la WAN reconfigurada manualmente. ¿Desea continuar?',
      resync_ont: 'Se resincronizará la ONU, ¿Desea continuar?',
      rx_power_critical: 'Potencia crítica',
      rx_power_warning: 'Potencia alarmante',
      rx_power_optimal: 'Potencia óptima',
      rx_power_not_configured: 'No configurado',
      registration_info: 'Información de registro',
      searcher: {
        basic_placeholder: 'Puedes buscar por: Nombre'
      },
      sending: 'Enviando...',
      serial_not_found: 'El número de serie de la ONU no existe en la OLT',
      serial_number_no_exist: 'No existe el número de serie.',
      service_port_config: 'Configuración de los Service Ports',
      search_by_host_address: 'Busque por direccion de Host',
      search_by_port_number: 'Busque por número de Puerto',
      show_ont_capability_info: 'Información de la Capacidad',
      show_ont_info: 'Información Básica',
      show_ont_configuration_info: 'Información de configuración ONU',
      show_ont_optical_node_info: 'Información del nodo óptico',
      show_ont_optical_down_info: 'Información Óptica Bajada',
      show_ont_optical_info: 'Información Óptica',
      show_ont_optical_reference_info: 'Información de Referencia Óptica',
      show_ont_optical_up_info: 'Información Óptica Subida',
      show_ont_port_info: 'Información de los Puertos',
      show_ont_secundary_info: 'Información Secundaria',
      show_ont_version_info: 'Información de Versión',
      snmp: 'SNMP',
      static: 'Estática',
      status: 'Estado',
      refresh_alarms: 'Refrescar',
      synchronization: 'Sincronización',
      tabs: {
        apply_changes_status: 'Estado de cambios aplicados'
      },
      the_ont_can_not_support: 'La ONU no soporta configuración WAN',
      there_is_no_wan_configuration_available: 'No hay configuraciones WAN disponibles',
      timeout_error:
        'Tiempo de espera excedido, intente mas tarde. Compruebe que se muestra como conectado antes de Aplicar cambios.',
      tooltips: {
        apply_changes: 'Aplicar cambios',
        applying_changes: 'Aplicando cambios',
        catv_control_disabled: 'Control de CATV deshabilitado',
        catv_control_enabled: 'Control de CATV habilitado',
        changes_to_apply_count: 'Cambios para aplicar',
        delete_disabled: 'No se puede eliminar la OLT si tiene contratos vinculados',
        link: 'Vincular',
        olt_has_pending_configuration: 'El contrato no está asociado a una ONU, requiere realizar la autorización.',
        olt_not_linked: 'El contrato está asociado a una OLT no vinculada, requiere vincular la OLT.',
        olt_provisioning_wan_disabled: ' Aprovisionamiento WAN deshabilitado',
        olt_provisioning_wan_enabled: 'Aprovisionamiento WAN habilitado',
        reboot_ont: 'Reiniciar ONU',
        see_changes_between_versions: 'Ver cambios entre versiones',
        show: 'Ver',
        show_onu_actions: 'Ver Acciones de la ONU',
        show_onu_info: 'Ver Información de la ONU',
        ont_unsync: 'La ONU no está sincronizada',
        traffic_control_disabled: 'Control de ancho de banda deshabilitado',
        traffic_control_enabled: 'Control de ancho de banda habilitado',
        unlink: 'Desvincular',
        uplink_interfaces: 'Interfaces Uplink',
        with_gps_point: 'Con Geolocalización',
        without_gps_point: 'Sin Geolocalización'
      },

      traffic_control_enabled_hint:
        'Al deshabilitar el control de ancho de banda, no se priorizará ni se limitará el tráfico de los clientes',
      try_again_if_persist_contact_with_support: 'Intente nuevamente, si el problema persiste contacte a soporte.',
      try_to_reboot_ont_manually: 'Intente reiniciar la ONU manualmente para que se aplique la configuración WAN',
      unauth: 'Esta acción implica que perderá la navegación en el equipo, ¿Desea continuar?',
      unauth_not_linked: 'Se va a desautorizar la ONU solo en el puerto PON seleccionado. ¿Desea continuar?',
      unexpected_error_getting_data: 'Error al intentar obtener datos',
      unlink_ont: 'Se desvinculará la ONU del contrato asociado. No se realizarán cambios en la OLT.',
      uplink_interfaces: {
        admin_status: 'Admin',
        native_vlan: 'VLAN nativa',
        speed: 'Velocidad',
        tagged_vlans: 'Tagged VLANs',
        untagged_vlans: 'Untagged VLANs',
        uplink_interfaces_sync: 'Refrescar Interfaces Uplink'
      },
      update_onu_ont: 'Editar ONU',
      updated_at: 'Actualizado',
      upstream_gem_traffic_not_supported: 'El control de ancho de banda no está soportado por la OLT',
      upstream_traffic_control: 'Control de ancho de banda de subida',
      var_no_resource: 'No es posible obtener información de CATV',
      version_info: 'Información de Versión',
      vlan_no_options: 'No hay ninguna vlan creada en la OLT',
      vlans_info: 'Información de VLANs',
      wan_config_not_supported: 'La ONU no soporta configuración WAN desde la OLT',
      olt_model_cant_support_traffic_control: 'El modelo de OLT no soporta el control de tráfico',
      feature_not_supported_by_model: 'Característica no soportada por el modelo de OLT',
      write_to_memory: 'Guardar configuración',
      gpon_navigator: {
        sync_gpon_ports: 'Sincronizar puertos GPON',
        gpon_ports_no_records: 'No hay puertos GPON para mostrar'
      }
    },
    vat_condition: {
      billing_regime: 'Regimen de Facturación',
      billing_regime_juridical: 'Regimen de Facturación (P. Jurídica)',
      billing_regime_person: 'Regimen de Facturación (P. Física)',
      common_regime: 'Regimen Común',
      common_regime_juridical: 'Regimen Común (P. Jurídica)',
      common_regime_person: 'Regimen Común (P. Física)',
      exempt: 'Exento',
      fantasy: 'Fantasia',
      final_consumer: 'Consumidor Final',
      registered_vat_payer: 'Responsable Inscripto',
      self_employed_taxpayer: 'Responsable Monotributo',
      simplified_regime: 'Regimen Simplificado',
      general_regime: 'Régimen General de Ley Personas Morales',
      legal_entities_with_non_profit_purpose: 'Personas Morales con Fines no Lucrativos',
      wages_and_salaries_and_income_assimilated_to_salaries: 'Sueldos y Salarios e Ingresos Asimilados a Salarios',
      lease: 'Arrendamiento',
      property_disposal_or_acquisition_regime: 'Régimen de Enajenación o Adquisición de Bienes',
      other_income: 'Demás ingresos',
      residents_abroad_without_permanent_establishment_in_mexico:
        'Residentes en el Extranjero sin Establecimiento Permanente en México',
      dividend_income: 'Ingresos por Dividendos (socios y accionistas)',
      individuals_with_business_and_professional_activities:
        'Personas Físicas con Actividades Empresariales y Profesionales',
      interest_income: 'Ingresos por intereses',
      income_regime_for_obtaining_prizes: 'Régimen de los ingresos por obtención de premios',
      no_tax_obligations: 'Sin obligaciones fiscales',
      production_cooperative_societies_that_choose_to_defer_their_income:
        'Sociedades Cooperativas de Producción que optan por diferir sus ingresos',
      tax_incorporation: 'Incorporación Fiscal',
      agricultural_livestock_forestry_and_fishing_activities:
        'Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras',
      optional_for_groups_of_companies: 'Opcional para Grupos de Sociedades',
      coordinated: 'Coordinados',
      regime_of_business_activities_with_income_through_technological_platforms:
        'Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas',
      simplified_trust_regime: 'Régimen Simplificado de Confianza'
    },
    vippo: {
      report_transaction: {
        client_identification_number_hint: 'Primer carácter letra (V/E/J/G) + hasta 9 dígitos',
        client_phone_number_hint:
          'Debe comenzar con 0 (ej. 04XX1234455). Excepto si el banco receptor es Banesco o Banco de Venezuela, donde comienza sin 0 (ej. 4XX1234455).'
      }
    }
  }
};
